require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/ae78cfa5fdd38176b6b2580bdb95748c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ae78cfa5fdd38176b6b2580bdb95748c'] = async function fn_ae78cfa5fdd38176b6b2580bdb95748c(x) {
return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(null))
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'gebruiker') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'beheerder') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/declaratieindienen_v2/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var factuurbetaaldvacatiegelden, tarievenvastevacatiegelden, declaratienummer, timestamp, factuurbetaaldkilometers, tariefperkm, factuurbetaaldovparkeerkosten, tarievenovparkeerkosten, factuurbetaaldvrijwilligersvergoeding, tarievenvrijwilligersvergoeding, factuurbetaaldkostenderden, tarievenkostenderden, factuurbetaalditkosten, tarievenitkosten, factuurbetaaldadministratiekosten, tarievenadministratiekosten, factuurbetaaldmaterielekosten, tarievenmaterielekosten, factuurbetaaldlocatiekosten, tarievenlocatiekosten, factuurbetaaldwerkminutenpl, tarievenwerktijdpl, factuurbetaaldwerkminutentc, tarievenwerktijdtc, factuurbetaaldwerkminutengv, tarievenwerktijdgv, dnbtariefperminuut, dnbtariefperkm, projectbtwsoort, dnbtariefperuur, factuurbetaaldwerkminutenco, tarievenwerktijdco, factuurbetaaldwerkminutenbl, tarievenwerktijdbl, btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('Projectnaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedbl')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedco')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedtc')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedgv')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedlk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedmk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedpk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedrk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedvg')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedpl')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedvrijwilliger')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedak')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedit')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedkd')) == null) {
    (function (message) { alert(message) })('Soort declaratie dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'omschrijving')) == null) {
    (function (message) { alert(message) })('Omschrijving dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98a953586aa23acc18141918abbde32a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenbl')) == null) {
    (function (message) { alert(message) })('Werktijd bestuurslid dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0adba33a7552f1cd0b3ed27870c4d455')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenco')) == null) {
    (function (message) { alert(message) })('Werktijd coördinator dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d67aa664657ded5808c49f7a8d0fb01a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutentc')) == null) {
    (function (message) { alert(message) })('Werktijd teamcoördinator dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23682a7871319c1f5c52ac71e2cd38e4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenpl')) == null) {
    (function (message) { alert(message) })('Werktijd projectleider dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22b380f638e2ba583ac2bc2927e15e6c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutengv')) == null) {
    (function (message) { alert(message) })('Werktijd geestelijk verzorger dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f72f8858173185a4c33c7625a6c7336')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag locatiekosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f72f8858173185a4c33c7625a6c7336')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedraglocatiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag locatiekosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fb7f2c66006cddd23e873ddc4451749')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) == null) {
    (function (message) { alert(message) })('Bedrag materiële kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fb7f2c66006cddd23e873ddc4451749')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragmaterielekosten')) == null) {
    (function (message) { alert(message) })('Bedrag materiële kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b852e7b31ad4ed5a1337f445732453b')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag administratie kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('708398a50f4f240e05c209b131c76624')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) == null) {
    (function (message) { alert(message) })('Bedrag IT kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70f247ada1063121284599e87a7e9626')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) == null) {
    (function (message) { alert(message) })('Bedrag Kosten derden dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b9ad23445dd68c3f66e8657a8fd3c886')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) == null) {
    (function (message) { alert(message) })('Bedrag OV/Parkeerkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b9ad23445dd68c3f66e8657a8fd3c886')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragparkeerkosten')) == null) {
    (function (message) { alert(message) })('Bedrag OV/Parkeerkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c725f97168a7224e1b3e743d5892cad')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')) == null) {
    (function (message) { alert(message) })('Bedrag vrijwilligersvergoeding dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f79b9bfcd2fd56adadeebaaf95f160e5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'kilometers')) == null) {
    (function (message) { alert(message) })('Aantal kilometers dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f679de510355092ef64c331ccb3fac2d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegelden')) == null) {
    (function (message) { alert(message) })('Bedrag vaste vacatiegelden dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedgv')) == true && (getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == null) {
    (function (message) { alert(message) })('Soort activiteit dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['spinner'] = true;
    await Backendless.Counters.addAndGet('declaratienummer', 1);
    declaratienummer = (await (async function(number) {
    	function FormatNumberLength(num, length) {
    	    var r = "" + num;
    	    while (r.length < length) {
    	        r = "0" + r;
    	    }
    	    return r;
    	}

    	var result;

    	result = FormatNumberLength(number, 6);

    	return result;
    })((await Backendless.Counters.get('declaratienummer'))));
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
    ___arguments.context.pageData['projectbtwsoort'] = (getObjectProperty(btwsoortgevuld, 'projectbtwsoort'));
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdbestuurslidblock')) == true) {
      tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdbl => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenwerktijdbl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdbl, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdbl, 'reistijd')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperuur')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenbl')) == true) {
        factuurbetaaldwerkminutenbl = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenbl = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate`]: true,[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperuur')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd bestuurslid',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenbl')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersbl')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdbl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdbl, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenbl,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdcoordinatorblock')) == true) {
      tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdco => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenwerktijdco, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdco, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdco, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdco, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdco, 'reistijd')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdco, 'tariefperuur')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenco')) == true) {
        factuurbetaaldwerkminutenco = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenco = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate`]: true,[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd coördinator',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenco')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersco')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdco, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdco, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdco, 'tariefperminuut')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdco, 'tariefperuur')),[`reistijd`]: (getObjectProperty(tarievenwerktijdco, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenco,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdgeestelijkverzorgerblock')) == true) {
      tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdgv => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdgv, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdgv, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdgv, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutengv')) == true) {
        factuurbetaaldwerkminutengv = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutengv = 'TE CONTROLEREN';
      }
      if ((getObjectProperty(___arguments.context.pageData, 'declaratienietbetalen')) == true) {
        dnbtariefperkm = 0;
        dnbtariefperminuut = 0;
        dnbtariefperuur = 0;
      } else {
        dnbtariefperkm = (getObjectProperty(tarievenwerktijdgv, 'tariefperkm'));
        dnbtariefperminuut = (getObjectProperty(tarievenwerktijdgv, 'tariefperminuut'));
        dnbtariefperuur = (getObjectProperty(tarievenwerktijdgv, 'tariefperuur'));
      }
      if ((getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == 'Consult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')) == false) {
        projectbtwsoort = 'zonderbtw';
      } else if ((getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
        projectbtwsoort = 'zonderbtw';
      } else {
        projectbtwsoort = (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort'));
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuurgegevenspartij`]: (getObjectProperty(___arguments.context.pageData, 'factuurgegevenspartij')),[`tariefafrondingupdate`]: true,[`tariefperuur`]: dnbtariefperuur,[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: projectbtwsoort,[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd geestelijk verzorger',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutengv')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersgv')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdgv, 'kostenplaats')),[`tariefperkm`]: dnbtariefperkm,[`tariefperminuut`]: dnbtariefperminuut,[`reistijd`]: (getObjectProperty(tarievenwerktijdgv, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutengv,[`invoer`]: 'declaratie',[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`soortactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdteamcoordinatorblock')) == true) {
      tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdtc => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdtc, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdtc, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdtc, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutentc')) == true) {
        factuurbetaaldwerkminutentc = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutentc = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate`]: true,[`tariefperuur`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperuur')),[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd teamcoördinator',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutentc')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometerstc')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdtc, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdtc, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutentc,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdprojectleiderblock')) == true) {
      tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdpl => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdpl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdpl, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdpl, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenpl')) == true) {
        factuurbetaaldwerkminutenpl = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenpl = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate`]: true,[`tariefperuur`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperuur')),[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd projectleider',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenpl')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometerspl')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdpl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdpl, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenpl,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedraglocatiekostenblock')) == true) {
      tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'tariefperuur']).setPageSize(10))).map(async tarievenlocatiekosten => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenlocatiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenlocatiekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldlocatiekosten')) == true) {
        factuurbetaaldlocatiekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldlocatiekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Locatiekosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenlocatiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')),[`bedrag`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filelocatiekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filelocatiekosten')),[`controle`]: factuurbetaaldlocatiekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragmaterielekostenblock')) == true) {
      tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenmaterielekosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenmaterielekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenmaterielekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldmaterielekosten')) == true) {
        factuurbetaaldmaterielekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldmaterielekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Materiële kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenmaterielekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filematerielekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filematerielekosten')),[`controle`]: factuurbetaaldmaterielekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragadministratiekostenblock')) == true) {
      tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenadministratiekosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenadministratiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenadministratiekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldadministratiekosten')) == true) {
        factuurbetaaldadministratiekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldadministratiekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Administratie kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenadministratiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileadministratiekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileadministratiekosten')),[`controle`]: factuurbetaaldadministratiekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragitkostenblock')) == true) {
      tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenitkosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenitkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenitkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenitkosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenitkosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaalditkosten')) == true) {
        factuurbetaalditkosten = 'REEDS BETAALD';
      } else {
        factuurbetaalditkosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'IT kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenitkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenitkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenitkosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwitkosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileitkosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileitkosten')),[`controle`]: factuurbetaalditkosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragkostenderdenblock')) == true) {
      tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenkostenderden => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenkostenderden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenkostenderden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenkostenderden, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenkostenderden, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldkostenderden')) == true) {
        factuurbetaaldkostenderden = 'REEDS BETAALD';
      } else {
        factuurbetaaldkostenderden = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Kosten derden',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenkostenderden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenkostenderden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenkostenderden, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filekostenderden')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filekostenderden')),[`controle`]: factuurbetaaldkostenderden,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilligersvergoedingblock')) == true) {
      tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd']).setPageSize(10))).map(async tarievenvrijwilligersvergoeding => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldvrijwilligersvergoeding')) == true) {
        factuurbetaaldvrijwilligersvergoeding = 'REEDS BETAALD';
      } else {
        factuurbetaaldvrijwilligersvergoeding = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Vrijwilligersvergoeding',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersvw')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'reistijd')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')),[`bedragbtw`]: 0,[`bedraginput`]: undefined,[`file`]: undefined,[`fileref`]: undefined,[`controle`]: factuurbetaaldvrijwilligersvergoeding,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragparkeerkostenblock')) == true) {
      tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenovparkeerkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenovparkeerkosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldovparkeerkosten')) == true) {
        factuurbetaaldovparkeerkosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldovparkeerkosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'OV/Parkeerkosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenovparkeerkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileovparkeerkosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileovparkeerkosten')),[`controle`]: factuurbetaaldovparkeerkosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true) {
      tariefperkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tariefperkm => {; return ({ [`kostenplaats`]: (getObjectProperty(tariefperkm, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tariefperkm, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tariefperkm, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tariefperkm, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldkilometers')) == true) {
        factuurbetaaldkilometers = 'REEDS BETAALD';
      } else {
        factuurbetaaldkilometers = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Kilometervergoeding',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometers')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tariefperkm, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tariefperkm, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tariefperkm, 'tariefperminuut')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldkilometers,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegeldenblock')) == true) {
      tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd']).setPageSize(10))).map(async tarievenvastevacatiegelden => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldvacatiegelden')) == true) {
        factuurbetaaldvacatiegelden = 'REEDS BETAALD';
      } else {
        factuurbetaaldvacatiegelden = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Vaste vacatiegelden',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersvacatiegelden')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'reistijd')),[`bedragexbtw`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldvacatiegelden,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['projectcode'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['werkminutenbl'] = null;
    ___arguments.context.pageData['werkminutenco'] = null;
    ___arguments.context.pageData['werkminutengv'] = null;
    ___arguments.context.pageData['werkminutentc'] = null;
    ___arguments.context.pageData['werkminutenpl'] = null;
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    ___arguments.context.pageData['btwlocatiekosten'] = null;
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    ___arguments.context.pageData['btwmaterielekosten'] = null;
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
    ___arguments.context.pageData['exbtwitkosten'] = null;
    ___arguments.context.pageData['btwitkosten'] = null;
    ___arguments.context.pageData['bedragitkosten'] = null;
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    ___arguments.context.pageData['btwkostenderden'] = null;
    ___arguments.context.pageData['bedragkostenderden'] = null;
    ___arguments.context.pageData['bedragvrijwilliger'] = null;
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['btwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedragvastevacatiegelden'] = null;
    ___arguments.context.pageData['file'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
    ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
    ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
    ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
    ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
    ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
    ___arguments.context.pageData['bedragaantalkmblock'] = false;
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
    ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
    ___arguments.context.pageData['bedragitkostenblock'] = false;
    ___arguments.context.pageData['bedragkostenderdenblock'] = false;
    ___arguments.context.pageData['kilometersbl'] = null;
    ___arguments.context.pageData['kilometersco'] = null;
    ___arguments.context.pageData['kilometerstc'] = null;
    ___arguments.context.pageData['kilometerspl'] = null;
    ___arguments.context.pageData['kilometersgv'] = null;
    ___arguments.context.pageData['kilometersvw'] = null;
    ___arguments.context.pageData['kilometersvacatiegelden'] = null;
    ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
    ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
    ___arguments.context.pageData['svwerktijdcoordinator'] = false;
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = false;
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = false;
    ___arguments.context.pageData['svwerktijdprojectleider'] = false;
    ___arguments.context.pageData['svlocatiekosten'] = false;
    ___arguments.context.pageData['svmaterielekosten'] = false;
    ___arguments.context.pageData['svparkeerkosten'] = false;
    ___arguments.context.pageData['svreiskosten'] = false;
    ___arguments.context.pageData['svvastevacatiegelden'] = false;
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = false;
    ___arguments.context.pageData['svadministratiekosten'] = false;
    ___arguments.context.pageData['svitkosten'] = false;
    ___arguments.context.pageData['svkostenderden'] = false;
    ___arguments.context.pageData['selectedbl'] = false;
    ___arguments.context.pageData['selectedco'] = false;
    ___arguments.context.pageData['selectedtc'] = false;
    ___arguments.context.pageData['selectedpl'] = false;
    ___arguments.context.pageData['selectedgv'] = false;
    ___arguments.context.pageData['selectedlk'] = false;
    ___arguments.context.pageData['selectedmk'] = false;
    ___arguments.context.pageData['selectedvrijwilliger'] = false;
    ___arguments.context.pageData['selectedpk'] = false;
    ___arguments.context.pageData['selectedrk'] = false;
    ___arguments.context.pageData['selectedvg'] = false;
    ___arguments.context.pageData['selectedak'] = false;
    ___arguments.context.pageData['selectedit'] = false;
    ___arguments.context.pageData['selectedkd'] = false;
    ___arguments.context.pageData['soortactiviteit'] = null;
    ___arguments.context.pageData['declaratienietbetalen'] = false;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));
    ___arguments.context.pageData['spinner'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileovparkeerkosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileovparkeerkosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tarievenadministratiekosten, tarievenitkosten, tarievenkm, tarievenkostenderden, tarievenlocatiekosten, tarievenmaterielekosten, tarievenovparkeerkosten, tarievenvastevacatiegelden, tarievenvrijwilligersvergoeding, tarievenwerktijdbl, tarievenwerktijdco, tarievenwerktijdgv, tarievenwerktijdpl, tarievenwerktijdtc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loadmax() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdbl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdbl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdco => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdco, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdco'] = (getObjectProperty(tarievenwerktijdco, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdgv => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdgv, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdtc => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdtc, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdpl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdpl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenlocatiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenlocatiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenlocatiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxlocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenmaterielekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenmaterielekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenmaterielekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxmaterielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenvrijwilligersvergoeding => {; return ({ 'maxbedrag': (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxvrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['maxbedrag', 'informatietekst']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenovparkeerkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    tarievenkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['informatietekst', 'maxaantal']).setPageSize(1))).map(async tarievenkm => {; return ({ 'maxaantal': (getObjectProperty(tarievenkm, 'maxaantal')),'informatietekst': (getObjectProperty(tarievenkm, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkilometervergoeding'] = (getObjectProperty(tarievenkm, 'maxaantal'));
    ___arguments.context.pageData['informatiekilometervergoeding'] = (getObjectProperty(tarievenkm, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'vacatiegeldenbedrag') {
    tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['vacatiegeldenbedrag']).setPageSize(1))).map(async tarievenvastevacatiegelden => {; return ({ 'kostenplaats': (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),'tariefperkm': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),'tariefperminuut': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),'vacatiegeldenbedrag': (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')) });})))[0];
    ___arguments.context.pageData['vacatiegeldenbedrag'] = (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenadministratiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenadministratiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenadministratiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenitkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenitkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenitkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxitkosten'] = (getObjectProperty(tarievenitkosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenkostenderden => {; return ({ 'maxbedrag': (getObjectProperty(tarievenkostenderden, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenkostenderden, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkostenderden'] = (getObjectProperty(tarievenkostenderden, 'maxbedrag'));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
    await loadmax();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
    await loadmax();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? false : true))))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? true : false))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? true : false))))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, tarievenvastevacatiegelden, tarievenkm, tarievenovparkeerkosten, tarievenmaterielekosten, tarievenlocatiekosten, tarievenwerktijdtc, tarievenwerktijdgv, tarievenwerktijdco, tarievenwerktijdbl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')), ({ 'change': false }) );
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/422ff6fcd0f10f14ff75eb4fe3472b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiekilometervergoeding'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/1e911222da8da8ae912247b336be6da3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
    (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
    ___arguments.context.pageData['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3ebc7c4270cd4075baf7c12551d219a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiematerielekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['omschrijving'] = null;
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['options'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? false : true))))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/81f163647e09f40599a67bce439df575/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`file`]: null,[`fileref`]: null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0748b133dc3fe8cef8d601a3953a5baa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND svactiefinproject=1 ','AND projectgegevens.projectstatus=1'].join(''))).setRelated('projectgegevens').setSortBy('projectnaam ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'projectcode')),'label': (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tarievenkostenderden, projecttoestemmingen, tarievenitkosten, tarievenadministratiekosten, tarievenvastevacatiegelden, tarievenkm, tarievenovparkeerkosten, tarievenvrijwilligersvergoeding, tarievenmaterielekosten, tarievenlocatiekosten, tarievenwerktijdpl, tarievenwerktijdtc, tarievenwerktijdgv, tarievenwerktijdco, tarievenwerktijdbl, factuuradresvscl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function factuuradresvscl2() {
  factuuradresvscl = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties(['factuuradres']).setPageSize(1))).map(async factuuradresvscl => {; return ({ [`factuuradres`]: (getObjectProperty(factuuradresvscl, 'factuuradres')) });})))[0];
  ___arguments.context.pageData['factuuradres'] = (getObjectProperty(factuuradresvscl, 'factuuradres'));
}


  ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
  ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
  ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
  ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
  ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
  ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
  ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
  ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
  ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
  ___arguments.context.pageData['bedragaantalkmblock'] = false;
  ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
  ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
  ___arguments.context.pageData['bedragitkostenblock'] = false;
  ___arguments.context.pageData['bedragkostenderden'] = false;
  ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
  ___arguments.context.pageData['svwerktijdteamcoordinator'] = false;
  ___arguments.context.pageData['svwerktijdcoordinator'] = false;
  ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = false;
  ___arguments.context.pageData['svwerktijdprojectleider'] = false;
  ___arguments.context.pageData['svlocatiekosten'] = false;
  ___arguments.context.pageData['svmaterielekosten'] = false;
  ___arguments.context.pageData['svvrijwilligersvergoeding'] = false;
  ___arguments.context.pageData['svadministratiekosten'] = false;
  ___arguments.context.pageData['svitkosten'] = false;
  ___arguments.context.pageData['svparkeerkosten'] = false;
  ___arguments.context.pageData['svreiskosten'] = false;
  ___arguments.context.pageData['svvastevacatiegelden'] = false;
  ___arguments.context.pageData['selectedbl'] = false;
  ___arguments.context.pageData['selectedco'] = false;
  ___arguments.context.pageData['selectedtc'] = false;
  ___arguments.context.pageData['selectedpl'] = false;
  ___arguments.context.pageData['selectedgv'] = false;
  ___arguments.context.pageData['selectedlk'] = false;
  ___arguments.context.pageData['selectedmk'] = false;
  ___arguments.context.pageData['selectedpk'] = false;
  ___arguments.context.pageData['selectedrk'] = false;
  ___arguments.context.pageData['selectedvg'] = false;
  ___arguments.context.pageData['selectedvrijwilliger'] = false;
  ___arguments.context.pageData['selectedak'] = false;
  ___arguments.context.pageData['selectedit'] = false;
  ___arguments.context.pageData['projectcode'] = ___arguments.value;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    await factuuradresvscl2();
  }
  projecttoestemmingen = (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties(['svwerktijdbestuurslid', 'svwerktijdcoordinator', 'svwerktijdgeestelijkverzorger', 'svwerktijdteamcoordinator', 'svwerktijdprojectleider', 'svlocatiekosten', 'svmaterielekosten', 'svparkeerkosten', 'svprojectleider', 'svreiskosten', 'svvastevacatiegelden', 'projectnaam', 'svvrijwilligersvergoeding', 'svadministratiekosten', 'svitkosten', 'svkostenderden']).setPageSize(1))).map(async projecttoestemmingen => {; return ({ [`svwerktijdbestuurslid`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdbestuurslid')),[`svwerktijdcoordinator`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdcoordinator')),[`svwerktijdgeestelijkverzorger`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdgeestelijkverzorger')),[`svwerktijdteamcoordinator`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdteamcoordinator')),[`svwerktijdprojectleider`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdprojectleider')),[`svlocatiekosten`]: (getObjectProperty(projecttoestemmingen, 'svlocatiekosten')),[`svmaterielekosten`]: (getObjectProperty(projecttoestemmingen, 'svmaterielekosten')),[`svparkeerkosten`]: (getObjectProperty(projecttoestemmingen, 'svparkeerkosten')),[`svprojectleider`]: (getObjectProperty(projecttoestemmingen, 'svprojectleider')),[`svreiskosten`]: (getObjectProperty(projecttoestemmingen, 'svreiskosten')),[`svvastevacatiegelden`]: (getObjectProperty(projecttoestemmingen, 'svvastevacatiegelden')),[`projectnaam`]: (getObjectProperty(projecttoestemmingen, 'projectnaam')),[`svvrijwilligersvergoeding`]: (getObjectProperty(projecttoestemmingen, 'svvrijwilligersvergoeding')),[`svadministratiekosten`]: (getObjectProperty(projecttoestemmingen, 'svadministratiekosten')),[`svitkosten`]: (getObjectProperty(projecttoestemmingen, 'svitkosten')),[`svkostenderden`]: (getObjectProperty(projecttoestemmingen, 'svkostenderden')) });})))[0];
  ___arguments.context.pageData['projectnaam'] = (getObjectProperty(projecttoestemmingen, 'projectnaam'));
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdbestuurslid')) == true) {
    ___arguments.context.pageData['svwerktijdbestuurslid'] = true;
    tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdbl => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdbl, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdbl, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdcoordinator'] = true;
    tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdco => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdco, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdco, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdco'] = (getObjectProperty(tarievenwerktijdco, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdco'] = (getObjectProperty(tarievenwerktijdco, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdgeestelijkverzorger')) == true) {
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = true;
    tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdgv => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdgv, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdgv, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdteamcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = true;
    tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdtc => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdtc, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdtc, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdprojectleider')) == true) {
    ___arguments.context.pageData['svwerktijdprojectleider'] = true;
    tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdpl => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdpl, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdpl, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svlocatiekosten')) == true) {
    ___arguments.context.pageData['svlocatiekosten'] = true;
    tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenlocatiekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenlocatiekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenlocatiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxlocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatielocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svmaterielekosten')) == true) {
    ___arguments.context.pageData['svmaterielekosten'] = true;
    tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenmaterielekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenmaterielekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenmaterielekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxmaterielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatiematerielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svvrijwilligersvergoeding')) == true) {
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = true;
    tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['informatietekst', 'maxbedrag', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenvrijwilligersvergoeding => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst')),[`informatietekstreistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxvrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag'));
    ___arguments.context.pageData['informatievrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst'));
    ___arguments.context.pageData['informatietekstreistijdvw'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svparkeerkosten')) == true) {
    ___arguments.context.pageData['svparkeerkosten'] = true;
    tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['maxbedrag', 'informatietekst']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenovparkeerkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svreiskosten')) == true) {
    ___arguments.context.pageData['svreiskosten'] = true;
    tarievenkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['informatietekst', 'maxaantal']).setPageSize(1))).map(async tarievenkm => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenkm, 'maxaantal')),[`informatietekst`]: (getObjectProperty(tarievenkm, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkilometervergoeding'] = (getObjectProperty(tarievenkm, 'maxaantal'));
    ___arguments.context.pageData['informatiekilometervergoeding'] = (getObjectProperty(tarievenkm, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svvastevacatiegelden')) == true) {
    ___arguments.context.pageData['svvastevacatiegelden'] = true;
    tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['vacatiegeldenbedrag', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenvastevacatiegelden => {; return ({ [`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`informatietekstreistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['vacatiegeldenbedrag'] = (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag'));
    ___arguments.context.pageData['informatietekstreistijdvg'] = (getObjectProperty(tarievenvastevacatiegelden, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svadministratiekosten')) == true) {
    ___arguments.context.pageData['svadministratiekosten'] = true;
    tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenadministratiekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenadministratiekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenadministratiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svitkosten')) == true) {
    ___arguments.context.pageData['svitkosten'] = true;
    tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenitkosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenitkosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenitkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxitkosten'] = (getObjectProperty(tarievenitkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieitkosten'] = (getObjectProperty(tarievenitkosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svkostenderden')) == true) {
    ___arguments.context.pageData['svkostenderden'] = true;
    tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenkostenderden => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenkostenderden, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenkostenderden, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkostenderden'] = (getObjectProperty(tarievenkostenderden, 'maxbedrag'));
    ___arguments.context.pageData['informatiekostenderden'] = (getObjectProperty(tarievenkostenderden, 'informatietekst'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/98a953586aa23acc18141918abbde32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdbestuurslidblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0adba33a7552f1cd0b3ed27870c4d455/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdcoordinatorblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/22b380f638e2ba583ac2bc2927e15e6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdgeestelijkverzorgerblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d67aa664657ded5808c49f7a8d0fb01a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdteamcoordinatorblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0f72f8858173185a4c33c7625a6c7336/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedraglocatiekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5fb7f2c66006cddd23e873ddc4451749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragmaterielekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/b9ad23445dd68c3f66e8657a8fd3c886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragparkeerkostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f79b9bfcd2fd56adadeebaaf95f160e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f679de510355092ef64c331ccb3fac2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegeldenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/811b21b4ca9c3e1ba393de015d097b7f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedraglocatiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f6b94bb3ca3bf0c3823e1e828c95994e')));
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f6b94bb3ca3bf0c3823e1e828c95994e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedraglocatiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f6b94bb3ca3bf0c3823e1e828c95994e')));
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/9d2190a2ba4d3cc7c02b90518e4fdccc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragmaterielekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2190a2ba4d3cc7c02b90518e4fdccc')));
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/11a1e31938f5bcce1d271118f3cb5c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragmaterielekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2190a2ba4d3cc7c02b90518e4fdccc')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/cd64c49420d86272abd24ae691f600b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragparkeerkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd64c49420d86272abd24ae691f600b2')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/14f55f4adc88392c6ca94a954e629706/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragparkeerkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd64c49420d86272abd24ae691f600b2')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5ebd804565b117dace186f6d80589a6b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvastevacatiegelden'] = (getObjectProperty(___arguments.context.pageData, 'vacatiegeldenbedrag'));

  return (getObjectProperty(___arguments.context.pageData, 'vacatiegeldenbedrag'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/c25a6485dee8e18b71e42128dfaac3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenbl')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))));
    ___arguments.context.pageData['werkminutenbl'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/776464956662776c1b677996487ff519/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenco')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))));
    ___arguments.context.pageData['werkminutenco'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/9b43c42c073b1fa74437b929ea41576b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutengv')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))));
    ___arguments.context.pageData['werkminutengv'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/893ccc575c8e894a78ff1654a2badd67/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutentc')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))));
    ___arguments.context.pageData['werkminutentc'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0705680eb25da0a718dffed75f68edcd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatielocatiekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/fc740f79ad699e885b6872519dfd26dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieovparkeerkosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/4d3f47d19b1fe4a8e7ddc88706f2b993/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/a8678ce1d24e3f7d7fd2b836a5c98963/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('a8678ce1d24e3f7d7fd2b836a5c98963');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension, target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filelocatiekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filelocatiekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0eb5fb19f8eb5fdea2db230bd87f27e3/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('0eb5fb19f8eb5fdea2db230bd87f27e3');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filematerielekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filematerielekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5ebacb2c444cf0213a6781debf2192d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/6936d582b95657281367854ff59473fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/45d26eb69a0c2be5393e9a3f55eb120f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/ebce23b9b931c263e459e943cceb3c9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/cb94cbdfd6ba1cf714939c2ddd4f76b6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svlocatiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e264e4fd220535f7b6d39cb4b26664b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svmaterielekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f833018aaf62b8fb377600d50a6ce1fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svparkeerkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/56e40bfc255bd834074986b636298e52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svreiskosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/655ed4d7614e77c5310336d63fd37a94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/87fbe28ccd3e5845f76fbd74d1b69bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenbl'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedbl')) == true) {
    ___arguments.context.pageData['werktijdbestuurslidblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visibl'] = true;
  } else {
    ___arguments.context.pageData['visibl'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/fe247637d0ad87197fa69c9f6b9a4306/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenco'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedco')) == true) {
    ___arguments.context.pageData['werktijdcoordinatorblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visico'] = true;
  } else {
    ___arguments.context.pageData['visico'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/adaff29ea5b65279154315c8f7521e27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutentc'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedtc')) == true) {
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visitc'] = true;
  } else {
    ___arguments.context.pageData['visitc'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3185cf24ed24b55882058627616600bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutengv'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedgv')) == true) {
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visigv'] = true;
  } else {
    ___arguments.context.pageData['visigv'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d8e3a02c000c023e4447e9d9472a3e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwlocatiekosten'] = null;
  ___arguments.context.pageData['btwlocatiekosten'] = null;
  ___arguments.context.pageData['bedraglocatiekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedlk')) == true) {
    ___arguments.context.pageData['bedraglocatiekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/c578a08cd271849996985f0712c57bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwmaterielekosten'] = null;
  ___arguments.context.pageData['btwmaterielekosten'] = null;
  ___arguments.context.pageData['bedragmaterielekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedmk')) == true) {
    ___arguments.context.pageData['bedragmaterielekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/94f5aa1b0d4dbc2435837c0e65168da1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwparkeerkosten'] = null;
  ___arguments.context.pageData['btwparkeerkosten'] = null;
  ___arguments.context.pageData['bedragparkeerkosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedpk')) == true) {
    ___arguments.context.pageData['bedragparkeerkostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/c3a7711b68ff3644741e5363a4b385d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['kilometers'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedrk')) == true) {
    ___arguments.context.pageData['bedragaantalkmblock'] = true;
  } else {
    ___arguments.context.pageData['bedragaantalkmblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/194850093956f064864d15092e28b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvastevacatiegelden'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedvg')) == true) {
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visivg'] = true;
  } else {
    ___arguments.context.pageData['visivg'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/91539a7bb09575be305e53d14d26c67d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenpl'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedpl')) == true) {
    ___arguments.context.pageData['werktijdprojectleiderblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visipl'] = true;
  } else {
    ___arguments.context.pageData['visipl'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/23682a7871319c1f5c52ac71e2cd38e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdprojectleiderblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/77f443ad752d25d50a0dc0bf1c48efa3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenpl')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))));
    ___arguments.context.pageData['werkminutenpl'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/2a868f3a245e9dc5cd393ede8c3df437/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f27f010c5b89088dd2efbd8a5a8a9732/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/6c725f97168a7224e1b3e743d5892cad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilligersvergoedingblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d12ca1e815a449ce99e8f13db4c82f1e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvrijwilliger'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedvrijwilliger')) == true) {
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = true;
  } else {
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visivw'] = true;
  } else {
    ___arguments.context.pageData['visivw'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0d89994cf30e6de94747e39716948ada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatievrijwilligersvergoeding'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e93e2648b32e052a52c9bca3321b2264/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')) > (getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))) {
    (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))));
    ___arguments.context.pageData['bedragvrijwilliger'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e93e2648b32e052a52c9bca3321b2264')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/31fa33086e05949e6726557243a6ee58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwadministratiekosten'] = null;
  ___arguments.context.pageData['btwadministratiekosten'] = null;
  ___arguments.context.pageData['bedragadministratiekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedak')) == true) {
    ___arguments.context.pageData['bedragadministratiekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/dc9a27ba5bcf22963a936cf71a41fdbf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwitkosten'] = null;
  ___arguments.context.pageData['btwitkosten'] = null;
  ___arguments.context.pageData['bedragitkosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedit')) == true) {
    ___arguments.context.pageData['bedragitkostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragitkostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/dceae4f25198c697819ac5ea09392cfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragadministratiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
    ___arguments.context.pageData['exbtwadministratiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dceae4f25198c697819ac5ea09392cfe')));
    ___arguments.context.pageData['bedragadministratiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/5fe5875d9ee2190c777a9244d7f998f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragadministratiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
    ___arguments.context.pageData['exbtwadministratiekosten'] = null;
    ___arguments.context.pageData['bedragadministratiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dceae4f25198c697819ac5ea09392cfe')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/28cbde5d0add7b914d250a91f48c934a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragitkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
    ___arguments.context.pageData['exbtwitkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cbde5d0add7b914d250a91f48c934a')));
    ___arguments.context.pageData['bedragitkosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/6fa76e08d6465ffd6a9891ee707f2625/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragitkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
    ___arguments.context.pageData['exbtwitkosten'] = null;
    ___arguments.context.pageData['bedragitkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cbde5d0add7b914d250a91f48c934a')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/6ff3d53a17f3699fedb3f0d1c22e8b52/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileladministratiekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileladministratiekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('6ff3d53a17f3699fedb3f0d1c22e8b52');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/ab5210b8f2b3e781ab935fb83d0a85dd/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileitkosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileitkosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ab5210b8f2b3e781ab935fb83d0a85dd');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/53f7ab3427fca1fa0fed7a475e01bd2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svadministratiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/ac15aabd32a7e5e90de50104ece10fa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svitkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/7879ae01e90d893789fb78567ce7910c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieadministratiekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/7dab80f8a41e35ad415c9be3ba25a979/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieitkosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3b852e7b31ad4ed5a1337f445732453b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragadministratiekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/708398a50f4f240e05c209b131c76624/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragitkostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0b33a4ffeae60b36b47eb9bca3ff4e62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svkostenderden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f266ecd4c045001992648f216658daef/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwkostenderden'] = null;
  ___arguments.context.pageData['btwkostenderden'] = null;
  ___arguments.context.pageData['bedragkostenderden'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedkd')) == true) {
    ___arguments.context.pageData['bedragkostenderdenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragkostenderdenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/4c7681f4edbe322fdc869ff55608b425/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragkostenderden'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c7681f4edbe322fdc869ff55608b425')));
    ___arguments.context.pageData['bedragkostenderden'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/9b35bf0c8e5cd5e280e46ab2febfa10d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragkostenderden'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c7681f4edbe322fdc869ff55608b425')));
    ___arguments.context.pageData['bedragkostenderden'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e55f7d19ef3a7fbd62d437ca1cc749c7/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e55f7d19ef3a7fbd62d437ca1cc749c7');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filekostenderden'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filekostenderden'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/70f247ada1063121284599e87a7e9626/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragkostenderdenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f08b684548440e1ae5e709fafde447ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiekostenderden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/4a2c6034d3a57dcf30be73c663c4b952/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/4f73a39d3f13c3995b1514041d651a0e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/a017dcaac54be5367e584e697f5ce067/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/fc0830b2c7449bedfce23e8fd7df217b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d2626efb62bb5a084a2dd5b203c11348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/56ea553ddc620265d0cf3d71609fcb32/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0e6cf2d94bb3d475ed0e3df4e64223bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/368184e5c27b7b7e576f98b439f45d05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/bfcba5e2931f8a6c5d62db06fb8cf8f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d484035a93c8ba8349ba550c3775b89c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/2754ab4aac4e367f71991944b3eba373/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/cc8805ee016980bdc8a28285ac4a7e7b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/dc3f950c13fe155d6e75f016426c0f44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/a5db2d6f7dcd216fc467dd18f1859d1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3a13c7f7ad46750a42a91a7252e37d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/70abc28a8f2fbe9b8875bf8177f94c48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e9575836cd67cdc5805b82e86d9aa51a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/7c3cdb324b3f0e553379c7369b872a7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/c9baa3b48e65325aa7563af80d2a476d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/749167dc7487b5b9ba2f4c921d886bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/804b3fc9249f0de3d715a20180a58f63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/479ae5bfbc7a0c4d1c3c9dfef997d87b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdbl'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/a874a0353295dde9b674aa6fe282f2d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdco'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/4ca8fd93a88b3409ba9bffe6e0068c81/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdtc'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/0dd5856ea78fb58f1abc793c9ef1da3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdpl'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/dcda190601dd7cda013487efb8dad4d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdgv'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/1c69c10cc944accad6b7c3d5636da444/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdvw'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/38e3690a32914b4b8f01930652cec77e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdvg'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/431a755d2d55bc34dce5723fb056dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/aab701220aa341057f825774528eff1d/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/7e6bc0e612444aabf94752bbe7d79f46/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3ee1c88dea06e78c18aa38e7d955e43f/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/f6c20a62ba06e8bb1b72f993b6fbfab6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/22bd9d0f568473d166caad459de5b7ec/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/fcab51eb95d422cc6e546516b82e41b6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/2824a5b4f303a8e982c18e898eeaa1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/329992740d986461cd040cfe34694d6f/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/48892734c34647c13b37f226c56e1333/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/9b8be778e0a7a57aef28ccadc365b28c/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/d9dad562738e915285025cae4781281d/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/3cee71185aad59939611bebfcf5bbbf9/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/8a9d59613682a28f30fb0fff0231662b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten en dat je het geld nog moet ontvangen van de administrateur.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2/components/e4680bf85043df18ab4193c1a4a87c08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var factuurbetaaldvacatiegelden, tarievenvastevacatiegelden, declaratienummer, timestamp, factuurbetaaldkilometers, tariefperkm, factuurbetaaldovparkeerkosten, tarievenovparkeerkosten, factuurbetaaldvrijwilligersvergoeding, tarievenvrijwilligersvergoeding, factuurbetaaldkostenderden, tarievenkostenderden, factuurbetaalditkosten, tarievenitkosten, factuurbetaaldadministratiekosten, tarievenadministratiekosten, factuurbetaaldmaterielekosten, tarievenmaterielekosten, factuurbetaaldlocatiekosten, tarievenlocatiekosten, factuurbetaaldwerkminutenpl, tarievenwerktijdpl, factuurbetaaldwerkminutentc, tarievenwerktijdtc, factuurbetaaldwerkminutengv, tarievenwerktijdgv, projectbtwsoort, factuurbetaaldwerkminutenco, tarievenwerktijdco, factuurbetaaldwerkminutenbl, tarievenwerktijdbl, btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('Projectnaam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedbl')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedco')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedtc')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedgv')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedlk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedmk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedpk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedrk')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedvg')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedpl')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedvrijwilliger')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedak')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedit')) == null && (getObjectProperty(___arguments.context.pageData, 'selectedkd')) == null) {
    (function (message) { alert(message) })('Soort declaratie dient geselecteerd te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'omschrijving')) == null) {
    (function (message) { alert(message) })('Omschrijving dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98a953586aa23acc18141918abbde32a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenbl')) == null) {
    (function (message) { alert(message) })('Werktijd bestuurslid dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0adba33a7552f1cd0b3ed27870c4d455')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenco')) == null) {
    (function (message) { alert(message) })('Werktijd coördinator dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d67aa664657ded5808c49f7a8d0fb01a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutentc')) == null) {
    (function (message) { alert(message) })('Werktijd teamcoördinator dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('23682a7871319c1f5c52ac71e2cd38e4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenpl')) == null) {
    (function (message) { alert(message) })('Werktijd projectleider dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22b380f638e2ba583ac2bc2927e15e6c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutengv')) == null) {
    (function (message) { alert(message) })('Werktijd geestelijk verzorger dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f72f8858173185a4c33c7625a6c7336')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag locatiekosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f72f8858173185a4c33c7625a6c7336')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedraglocatiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag locatiekosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fb7f2c66006cddd23e873ddc4451749')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) == null) {
    (function (message) { alert(message) })('Bedrag materiële kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fb7f2c66006cddd23e873ddc4451749')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragmaterielekosten')) == null) {
    (function (message) { alert(message) })('Bedrag materiële kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b852e7b31ad4ed5a1337f445732453b')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) == null) {
    (function (message) { alert(message) })('Bedrag administratie kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('708398a50f4f240e05c209b131c76624')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) == null) {
    (function (message) { alert(message) })('Bedrag IT kosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70f247ada1063121284599e87a7e9626')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) == null) {
    (function (message) { alert(message) })('Bedrag Kosten derden dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b9ad23445dd68c3f66e8657a8fd3c886')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) == null) {
    (function (message) { alert(message) })('Bedrag OV/Parkeerkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b9ad23445dd68c3f66e8657a8fd3c886')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragparkeerkosten')) == null) {
    (function (message) { alert(message) })('Bedrag OV/Parkeerkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c725f97168a7224e1b3e743d5892cad')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')) == null) {
    (function (message) { alert(message) })('Bedrag vrijwilligersvergoeding dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f79b9bfcd2fd56adadeebaaf95f160e5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'kilometers')) == null) {
    (function (message) { alert(message) })('Aantal kilometers dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f679de510355092ef64c331ccb3fac2d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegelden')) == null) {
    (function (message) { alert(message) })('Bedrag vaste vacatiegelden dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedgv')) == true && (getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == null) {
    (function (message) { alert(message) })('Soort activiteit dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['spinner'] = true;
    await Backendless.Counters.addAndGet('declaratienummer', 1);
    declaratienummer = (await (async function(number) {
    	function FormatNumberLength(num, length) {
    	    var r = "" + num;
    	    while (r.length < length) {
    	        r = "0" + r;
    	    }
    	    return r;
    	}

    	var result;

    	result = FormatNumberLength(number, 6);

    	return result;
    })((await Backendless.Counters.get('declaratienummer'))));
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
    ___arguments.context.pageData['projectbtwsoort'] = (getObjectProperty(btwsoortgevuld, 'projectbtwsoort'));
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdbestuurslidblock')) == true) {
      tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdbl => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenwerktijdbl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdbl, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdbl, 'reistijd')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperuur')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenbl')) == true) {
        factuurbetaaldwerkminutenbl = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenbl = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate `]: true,[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperuur')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd bestuurslid',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenbl')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersbl')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdbl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdbl, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdbl, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenbl,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdcoordinatorblock')) == true) {
      tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdco => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenwerktijdco, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdco, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdco, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdco, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdco, 'reistijd')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdco, 'tariefperuur')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenco')) == true) {
        factuurbetaaldwerkminutenco = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenco = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate `]: true,[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd coördinator',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenco')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersco')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdco, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdco, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdco, 'tariefperminuut')),[`tariefperuur`]: (getObjectProperty(tarievenwerktijdco, 'tariefperuur')),[`reistijd`]: (getObjectProperty(tarievenwerktijdco, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenco,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdgeestelijkverzorgerblock')) == true) {
      tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdgv => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdgv, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdgv, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdgv, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutengv')) == true) {
        factuurbetaaldwerkminutengv = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutengv = 'TE CONTROLEREN';
      }
      if ((getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == 'Consult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')) == false) {
        projectbtwsoort = 'zonderbtw';
      } else if ((getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
        projectbtwsoort = 'zonderbtw';
      } else {
        projectbtwsoort = (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort'));
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate `]: true,[`tariefperuur`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperuur')),[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: projectbtwsoort,[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd geestelijk verzorger',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutengv')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersgv')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdgv, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdgv, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdgv, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutengv,[`invoer`]: 'declaratie',[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`soortactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'soortactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdteamcoordinatorblock')) == true) {
      tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdtc => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdtc, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdtc, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdtc, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutentc')) == true) {
        factuurbetaaldwerkminutentc = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutentc = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate `]: true,[`tariefperuur`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperuur')),[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd teamcoördinator',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutentc')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometerstc')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdtc, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdtc, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdtc, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutentc,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werktijdprojectleiderblock')) == true) {
      tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd', 'tariefperuur']).setPageSize(10))).map(async tarievenwerktijdpl => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdpl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenwerktijdpl, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenwerktijdpl, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldwerkminutenpl')) == true) {
        factuurbetaaldwerkminutenpl = 'REEDS BETAALD';
      } else {
        factuurbetaaldwerkminutenpl = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`tariefafrondingupdate `]: true,[`tariefperuur`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperuur')),[`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Werktijd projectleider',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenpl')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometerspl')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenwerktijdpl, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenwerktijdpl, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenwerktijdpl, 'reistijd')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldwerkminutenpl,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedraglocatiekostenblock')) == true) {
      tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'tariefperuur']).setPageSize(10))).map(async tarievenlocatiekosten => {; return ({ [`tariefperuur`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperuur')),[`kostenplaats`]: (getObjectProperty(tarievenlocatiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenlocatiekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldlocatiekosten')) == true) {
        factuurbetaaldlocatiekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldlocatiekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Locatiekosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenlocatiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenlocatiekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')),[`bedrag`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filelocatiekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filelocatiekosten')),[`controle`]: factuurbetaaldlocatiekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragmaterielekostenblock')) == true) {
      tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenmaterielekosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenmaterielekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenmaterielekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldmaterielekosten')) == true) {
        factuurbetaaldmaterielekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldmaterielekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Materiële kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenmaterielekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenmaterielekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filematerielekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filematerielekosten')),[`controle`]: factuurbetaaldmaterielekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragadministratiekostenblock')) == true) {
      tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenadministratiekosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenadministratiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenadministratiekosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldadministratiekosten')) == true) {
        factuurbetaaldadministratiekosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldadministratiekosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Administratie kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenadministratiekosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenadministratiekosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileadministratiekosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileadministratiekosten')),[`controle`]: factuurbetaaldadministratiekosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragitkostenblock')) == true) {
      tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenitkosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenitkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenitkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenitkosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenitkosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaalditkosten')) == true) {
        factuurbetaalditkosten = 'REEDS BETAALD';
      } else {
        factuurbetaalditkosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'IT kosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenitkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenitkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenitkosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwitkosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileitkosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileitkosten')),[`controle`]: factuurbetaalditkosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragkostenderdenblock')) == true) {
      tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenkostenderden => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenkostenderden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenkostenderden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenkostenderden, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenkostenderden, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldkostenderden')) == true) {
        factuurbetaaldkostenderden = 'REEDS BETAALD';
      } else {
        factuurbetaaldkostenderden = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Kosten derden',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenkostenderden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenkostenderden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenkostenderden, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'filekostenderden')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'filekostenderden')),[`controle`]: factuurbetaaldkostenderden,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilligersvergoedingblock')) == true) {
      tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd']).setPageSize(10))).map(async tarievenvrijwilligersvergoeding => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldvrijwilligersvergoeding')) == true) {
        factuurbetaaldvrijwilligersvergoeding = 'REEDS BETAALD';
      } else {
        factuurbetaaldvrijwilligersvergoeding = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Vrijwilligersvergoeding',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersvw')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'reistijd')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')),[`bedragbtw`]: 0,[`bedraginput`]: undefined,[`file`]: undefined,[`fileref`]: undefined,[`controle`]: factuurbetaaldvrijwilligersvergoeding,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragparkeerkostenblock')) == true) {
      tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenovparkeerkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenovparkeerkosten, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldovparkeerkosten')) == true) {
        factuurbetaaldovparkeerkosten = 'REEDS BETAALD';
      } else {
        factuurbetaaldovparkeerkosten = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'OV/Parkeerkosten',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenovparkeerkosten, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenovparkeerkosten, 'tariefperminuut')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')),[`bedragbtw`]: (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')),[`bedraginput`]: undefined,[`file`]: (getObjectProperty(___arguments.context.pageData, 'fileovparkeerkosten')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'fileovparkeerkosten')),[`controle`]: factuurbetaaldovparkeerkosten,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true) {
      tariefperkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag']).setPageSize(10))).map(async tariefperkm => {; return ({ [`kostenplaats`]: (getObjectProperty(tariefperkm, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tariefperkm, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tariefperkm, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tariefperkm, 'vacatiegeldenbedrag')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldkilometers')) == true) {
        factuurbetaaldkilometers = 'REEDS BETAALD';
      } else {
        factuurbetaaldkilometers = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Kilometervergoeding',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometers')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tariefperkm, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tariefperkm, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tariefperkm, 'tariefperminuut')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldkilometers,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegeldenblock')) == true) {
      tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['kostenplaats', 'maxaantal', 'maxbedrag', 'tariefperkm', 'tariefperminuut', 'vacatiegeldenbedrag', 'reistijd']).setPageSize(10))).map(async tarievenvastevacatiegelden => {; return ({ [`kostenplaats`]: (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),[`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`reistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'reistijd')) });})))[0];
      if ((getObjectProperty(___arguments.context.pageData, 'factuurbetaaldvacatiegelden')) == true) {
        factuurbetaaldvacatiegelden = 'REEDS BETAALD';
      } else {
        factuurbetaaldvacatiegelden = 'TE CONTROLEREN';
      }
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaratiesmnl').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectbtwsoort`]: (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`aanmaakdatum`]: (new Date(timestamp)),[`declaratienummer`]: declaratienummer,[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: 'Vaste vacatiegelden',[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`werkminuten`]: undefined,[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometersvacatiegelden')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`kostenplaats`]: (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),[`tariefperkm`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),[`tariefperminuut`]: (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),[`reistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'reistijd')),[`bedragexbtw`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`bedragbtw`]: 0,[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: factuurbetaaldvacatiegelden,[`invoer`]: 'declaratie' }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdeclaraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['projectcode'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['werkminutenbl'] = null;
    ___arguments.context.pageData['werkminutenco'] = null;
    ___arguments.context.pageData['werkminutengv'] = null;
    ___arguments.context.pageData['werkminutentc'] = null;
    ___arguments.context.pageData['werkminutenpl'] = null;
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    ___arguments.context.pageData['btwlocatiekosten'] = null;
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    ___arguments.context.pageData['btwmaterielekosten'] = null;
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
    ___arguments.context.pageData['exbtwitkosten'] = null;
    ___arguments.context.pageData['btwitkosten'] = null;
    ___arguments.context.pageData['bedragitkosten'] = null;
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    ___arguments.context.pageData['btwkostenderden'] = null;
    ___arguments.context.pageData['bedragkostenderden'] = null;
    ___arguments.context.pageData['bedragvrijwilliger'] = null;
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['btwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedragvastevacatiegelden'] = null;
    ___arguments.context.pageData['file'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
    ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
    ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
    ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
    ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
    ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
    ___arguments.context.pageData['bedragaantalkmblock'] = false;
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
    ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
    ___arguments.context.pageData['bedragitkostenblock'] = false;
    ___arguments.context.pageData['bedragkostenderdenblock'] = false;
    ___arguments.context.pageData['kilometersbl'] = null;
    ___arguments.context.pageData['kilometersco'] = null;
    ___arguments.context.pageData['kilometerstc'] = null;
    ___arguments.context.pageData['kilometerspl'] = null;
    ___arguments.context.pageData['kilometersgv'] = null;
    ___arguments.context.pageData['kilometersvw'] = null;
    ___arguments.context.pageData['kilometersvacatiegelden'] = null;
    ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
    ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
    ___arguments.context.pageData['svwerktijdcoordinator'] = false;
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = false;
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = false;
    ___arguments.context.pageData['svwerktijdprojectleider'] = false;
    ___arguments.context.pageData['svlocatiekosten'] = false;
    ___arguments.context.pageData['svmaterielekosten'] = false;
    ___arguments.context.pageData['svparkeerkosten'] = false;
    ___arguments.context.pageData['svreiskosten'] = false;
    ___arguments.context.pageData['svvastevacatiegelden'] = false;
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = false;
    ___arguments.context.pageData['svadministratiekosten'] = false;
    ___arguments.context.pageData['svitkosten'] = false;
    ___arguments.context.pageData['svkostenderden'] = false;
    ___arguments.context.pageData['selectedbl'] = false;
    ___arguments.context.pageData['selectedco'] = false;
    ___arguments.context.pageData['selectedtc'] = false;
    ___arguments.context.pageData['selectedpl'] = false;
    ___arguments.context.pageData['selectedgv'] = false;
    ___arguments.context.pageData['selectedlk'] = false;
    ___arguments.context.pageData['selectedmk'] = false;
    ___arguments.context.pageData['selectedvrijwilliger'] = false;
    ___arguments.context.pageData['selectedpk'] = false;
    ___arguments.context.pageData['selectedrk'] = false;
    ___arguments.context.pageData['selectedvg'] = false;
    ___arguments.context.pageData['selectedak'] = false;
    ___arguments.context.pageData['selectedit'] = false;
    ___arguments.context.pageData['selectedkd'] = false;
    ___arguments.context.pageData['soortactiviteit'] = null;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2cb48ffb74bc4e91d3d34b8c6c9f3d7')));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));
    ___arguments.context.pageData['spinner'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileovparkeerkosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileovparkeerkosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tarievenadministratiekosten, tarievenitkosten, tarievenkm, tarievenkostenderden, tarievenlocatiekosten, tarievenmaterielekosten, tarievenovparkeerkosten, tarievenvastevacatiegelden, tarievenvrijwilligersvergoeding, tarievenwerktijdbl, tarievenwerktijdco, tarievenwerktijdgv, tarievenwerktijdpl, tarievenwerktijdtc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loadmax() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdbl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdbl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdco => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdco, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdco'] = (getObjectProperty(tarievenwerktijdco, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdgv => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdgv, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdtc => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdtc, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdpl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdpl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenlocatiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenlocatiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenlocatiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxlocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenmaterielekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenmaterielekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenmaterielekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxmaterielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenvrijwilligersvergoeding => {; return ({ 'maxbedrag': (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxvrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['maxbedrag', 'informatietekst']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenovparkeerkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    tarievenkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['informatietekst', 'maxaantal']).setPageSize(1))).map(async tarievenkm => {; return ({ 'maxaantal': (getObjectProperty(tarievenkm, 'maxaantal')),'informatietekst': (getObjectProperty(tarievenkm, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkilometervergoeding'] = (getObjectProperty(tarievenkm, 'maxaantal'));
    ___arguments.context.pageData['informatiekilometervergoeding'] = (getObjectProperty(tarievenkm, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'vacatiegeldenbedrag') {
    tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['vacatiegeldenbedrag']).setPageSize(1))).map(async tarievenvastevacatiegelden => {; return ({ 'kostenplaats': (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),'tariefperkm': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),'tariefperminuut': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),'vacatiegeldenbedrag': (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')) });})))[0];
    ___arguments.context.pageData['vacatiegeldenbedrag'] = (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenadministratiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenadministratiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenadministratiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenitkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenitkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenitkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxitkosten'] = (getObjectProperty(tarievenitkosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenkostenderden => {; return ({ 'maxbedrag': (getObjectProperty(tarievenkostenderden, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenkostenderden, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkostenderden'] = (getObjectProperty(tarievenkostenderden, 'maxbedrag'));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
    await loadmax();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
    await loadmax();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? false : true))))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? true : false))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? true : false))))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, tarievenvastevacatiegelden, tarievenkm, tarievenovparkeerkosten, tarievenmaterielekosten, tarievenlocatiekosten, tarievenwerktijdtc, tarievenwerktijdgv, tarievenwerktijdco, tarievenwerktijdbl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')), ({ 'change': false }) );
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/422ff6fcd0f10f14ff75eb4fe3472b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiekilometervergoeding'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/1e911222da8da8ae912247b336be6da3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
    (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
    ___arguments.context.pageData['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3ebc7c4270cd4075baf7c12551d219a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiematerielekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['omschrijving'] = null;
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['options'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? false : true))))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/81f163647e09f40599a67bce439df575/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`file`]: null,[`fileref`]: null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0748b133dc3fe8cef8d601a3953a5baa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND svactiefinproject=1 ','AND projectgegevens.projectstatus=1'].join(''))).setRelated('projectgegevens').setSortBy('projectnaam ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'projectcode')),'label': (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tarievenkostenderden, projecttoestemmingen, tarievenitkosten, tarievenadministratiekosten, tarievenvastevacatiegelden, tarievenkm, tarievenovparkeerkosten, tarievenvrijwilligersvergoeding, tarievenmaterielekosten, tarievenlocatiekosten, tarievenwerktijdpl, tarievenwerktijdtc, tarievenwerktijdgv, tarievenwerktijdco, tarievenwerktijdbl, factuuradresvscl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function factuuradresvscl2() {
  factuuradresvscl = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties(['factuuradres']).setPageSize(1))).map(async factuuradresvscl => {; return ({ [`factuuradres`]: (getObjectProperty(factuuradresvscl, 'factuuradres')) });})))[0];
  ___arguments.context.pageData['factuuradres'] = (getObjectProperty(factuuradresvscl, 'factuuradres'));
}


  ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
  ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
  ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
  ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
  ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
  ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
  ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
  ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
  ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
  ___arguments.context.pageData['bedragaantalkmblock'] = false;
  ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
  ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
  ___arguments.context.pageData['bedragitkostenblock'] = false;
  ___arguments.context.pageData['bedragkostenderden'] = false;
  ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
  ___arguments.context.pageData['svwerktijdteamcoordinator'] = false;
  ___arguments.context.pageData['svwerktijdcoordinator'] = false;
  ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = false;
  ___arguments.context.pageData['svwerktijdprojectleider'] = false;
  ___arguments.context.pageData['svlocatiekosten'] = false;
  ___arguments.context.pageData['svmaterielekosten'] = false;
  ___arguments.context.pageData['svvrijwilligersvergoeding'] = false;
  ___arguments.context.pageData['svadministratiekosten'] = false;
  ___arguments.context.pageData['svitkosten'] = false;
  ___arguments.context.pageData['svparkeerkosten'] = false;
  ___arguments.context.pageData['svreiskosten'] = false;
  ___arguments.context.pageData['svvastevacatiegelden'] = false;
  ___arguments.context.pageData['selectedbl'] = false;
  ___arguments.context.pageData['selectedco'] = false;
  ___arguments.context.pageData['selectedtc'] = false;
  ___arguments.context.pageData['selectedpl'] = false;
  ___arguments.context.pageData['selectedgv'] = false;
  ___arguments.context.pageData['selectedlk'] = false;
  ___arguments.context.pageData['selectedmk'] = false;
  ___arguments.context.pageData['selectedpk'] = false;
  ___arguments.context.pageData['selectedrk'] = false;
  ___arguments.context.pageData['selectedvg'] = false;
  ___arguments.context.pageData['selectedvrijwilliger'] = false;
  ___arguments.context.pageData['selectedak'] = false;
  ___arguments.context.pageData['selectedit'] = false;
  ___arguments.context.pageData['projectcode'] = ___arguments.value;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    await factuuradresvscl2();
  }
  projecttoestemmingen = (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties(['svwerktijdbestuurslid', 'svwerktijdcoordinator', 'svwerktijdgeestelijkverzorger', 'svwerktijdteamcoordinator', 'svwerktijdprojectleider', 'svlocatiekosten', 'svmaterielekosten', 'svparkeerkosten', 'svprojectleider', 'svreiskosten', 'svvastevacatiegelden', 'projectnaam', 'svvrijwilligersvergoeding', 'svadministratiekosten', 'svitkosten', 'svkostenderden']).setPageSize(1))).map(async projecttoestemmingen => {; return ({ [`svwerktijdbestuurslid`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdbestuurslid')),[`svwerktijdcoordinator`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdcoordinator')),[`svwerktijdgeestelijkverzorger`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdgeestelijkverzorger')),[`svwerktijdteamcoordinator`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdteamcoordinator')),[`svwerktijdprojectleider`]: (getObjectProperty(projecttoestemmingen, 'svwerktijdprojectleider')),[`svlocatiekosten`]: (getObjectProperty(projecttoestemmingen, 'svlocatiekosten')),[`svmaterielekosten`]: (getObjectProperty(projecttoestemmingen, 'svmaterielekosten')),[`svparkeerkosten`]: (getObjectProperty(projecttoestemmingen, 'svparkeerkosten')),[`svprojectleider`]: (getObjectProperty(projecttoestemmingen, 'svprojectleider')),[`svreiskosten`]: (getObjectProperty(projecttoestemmingen, 'svreiskosten')),[`svvastevacatiegelden`]: (getObjectProperty(projecttoestemmingen, 'svvastevacatiegelden')),[`projectnaam`]: (getObjectProperty(projecttoestemmingen, 'projectnaam')),[`svvrijwilligersvergoeding`]: (getObjectProperty(projecttoestemmingen, 'svvrijwilligersvergoeding')),[`svadministratiekosten`]: (getObjectProperty(projecttoestemmingen, 'svadministratiekosten')),[`svitkosten`]: (getObjectProperty(projecttoestemmingen, 'svitkosten')),[`svkostenderden`]: (getObjectProperty(projecttoestemmingen, 'svkostenderden')) });})))[0];
  ___arguments.context.pageData['projectnaam'] = (getObjectProperty(projecttoestemmingen, 'projectnaam'));
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdbestuurslid')) == true) {
    ___arguments.context.pageData['svwerktijdbestuurslid'] = true;
    tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdbl => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdbl, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdbl, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdcoordinator'] = true;
    tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdco => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdco, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdco, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdco'] = (getObjectProperty(tarievenwerktijdco, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdco'] = (getObjectProperty(tarievenwerktijdco, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdgeestelijkverzorger')) == true) {
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = true;
    tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdgv => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdgv, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdgv, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdteamcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = true;
    tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdtc => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdtc, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdtc, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svwerktijdprojectleider')) == true) {
    ___arguments.context.pageData['svwerktijdprojectleider'] = true;
    tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['maxaantal', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenwerktijdpl => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenwerktijdpl, 'maxaantal')),[`informatietekstreistijd`]: (getObjectProperty(tarievenwerktijdpl, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxwerktijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'maxaantal'));
    ___arguments.context.pageData['informatietekstreistijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svlocatiekosten')) == true) {
    ___arguments.context.pageData['svlocatiekosten'] = true;
    tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenlocatiekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenlocatiekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenlocatiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxlocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatielocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svmaterielekosten')) == true) {
    ___arguments.context.pageData['svmaterielekosten'] = true;
    tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenmaterielekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenmaterielekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenmaterielekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxmaterielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatiematerielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svvrijwilligersvergoeding')) == true) {
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = true;
    tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['informatietekst', 'maxbedrag', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenvrijwilligersvergoeding => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst')),[`informatietekstreistijd`]: (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['maxvrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag'));
    ___arguments.context.pageData['informatievrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst'));
    ___arguments.context.pageData['informatietekstreistijdvw'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svparkeerkosten')) == true) {
    ___arguments.context.pageData['svparkeerkosten'] = true;
    tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['maxbedrag', 'informatietekst']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenovparkeerkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svreiskosten')) == true) {
    ___arguments.context.pageData['svreiskosten'] = true;
    tarievenkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['informatietekst', 'maxaantal']).setPageSize(1))).map(async tarievenkm => {; return ({ [`maxaantal`]: (getObjectProperty(tarievenkm, 'maxaantal')),[`informatietekst`]: (getObjectProperty(tarievenkm, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkilometervergoeding'] = (getObjectProperty(tarievenkm, 'maxaantal'));
    ___arguments.context.pageData['informatiekilometervergoeding'] = (getObjectProperty(tarievenkm, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svvastevacatiegelden')) == true) {
    ___arguments.context.pageData['svvastevacatiegelden'] = true;
    tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['vacatiegeldenbedrag', 'informatietekstreistijd']).setPageSize(1))).map(async tarievenvastevacatiegelden => {; return ({ [`vacatiegeldenbedrag`]: (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')),[`informatietekstreistijd`]: (getObjectProperty(tarievenvastevacatiegelden, 'informatietekstreistijd')) });})))[0];
    ___arguments.context.pageData['vacatiegeldenbedrag'] = (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag'));
    ___arguments.context.pageData['informatietekstreistijdvg'] = (getObjectProperty(tarievenvastevacatiegelden, 'informatietekstreistijd'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svadministratiekosten')) == true) {
    ___arguments.context.pageData['svadministratiekosten'] = true;
    tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenadministratiekosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenadministratiekosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenadministratiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svitkosten')) == true) {
    ___arguments.context.pageData['svitkosten'] = true;
    tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenitkosten => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenitkosten, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenitkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxitkosten'] = (getObjectProperty(tarievenitkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieitkosten'] = (getObjectProperty(tarievenitkosten, 'informatietekst'));
  }
  if ((getObjectProperty(projecttoestemmingen, 'svkostenderden')) == true) {
    ___arguments.context.pageData['svkostenderden'] = true;
    tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenkostenderden => {; return ({ [`maxbedrag`]: (getObjectProperty(tarievenkostenderden, 'maxbedrag')),[`informatietekst`]: (getObjectProperty(tarievenkostenderden, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkostenderden'] = (getObjectProperty(tarievenkostenderden, 'maxbedrag'));
    ___arguments.context.pageData['informatiekostenderden'] = (getObjectProperty(tarievenkostenderden, 'informatietekst'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/98a953586aa23acc18141918abbde32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdbestuurslidblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0adba33a7552f1cd0b3ed27870c4d455/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdcoordinatorblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/22b380f638e2ba583ac2bc2927e15e6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdgeestelijkverzorgerblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d67aa664657ded5808c49f7a8d0fb01a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdteamcoordinatorblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0f72f8858173185a4c33c7625a6c7336/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedraglocatiekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5fb7f2c66006cddd23e873ddc4451749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragmaterielekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/b9ad23445dd68c3f66e8657a8fd3c886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragparkeerkostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f79b9bfcd2fd56adadeebaaf95f160e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragaantalkmblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f679de510355092ef64c331ccb3fac2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragvastevacatiegeldenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/811b21b4ca9c3e1ba393de015d097b7f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedraglocatiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f6b94bb3ca3bf0c3823e1e828c95994e')));
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f6b94bb3ca3bf0c3823e1e828c95994e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedraglocatiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwlocatiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwlocatiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
    ___arguments.context.pageData['exbtwlocatiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f6b94bb3ca3bf0c3823e1e828c95994e')));
    ___arguments.context.pageData['bedraglocatiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/9d2190a2ba4d3cc7c02b90518e4fdccc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragmaterielekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2190a2ba4d3cc7c02b90518e4fdccc')));
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/11a1e31938f5bcce1d271118f3cb5c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragmaterielekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwmaterielekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwmaterielekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
    ___arguments.context.pageData['exbtwmaterielekosten'] = null;
    ___arguments.context.pageData['bedragmaterielekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2190a2ba4d3cc7c02b90518e4fdccc')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/cd64c49420d86272abd24ae691f600b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragparkeerkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd64c49420d86272abd24ae691f600b2')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/14f55f4adc88392c6ca94a954e629706/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragparkeerkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwparkeerkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwparkeerkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
    ___arguments.context.pageData['exbtwparkeerkosten'] = null;
    ___arguments.context.pageData['bedragparkeerkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd64c49420d86272abd24ae691f600b2')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5ebd804565b117dace186f6d80589a6b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvastevacatiegelden'] = (getObjectProperty(___arguments.context.pageData, 'vacatiegeldenbedrag'));

  return (getObjectProperty(___arguments.context.pageData, 'vacatiegeldenbedrag'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/c25a6485dee8e18b71e42128dfaac3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenbl')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))));
    ___arguments.context.pageData['werkminutenbl'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/776464956662776c1b677996487ff519/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenco')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))));
    ___arguments.context.pageData['werkminutenco'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/9b43c42c073b1fa74437b929ea41576b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutengv')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))));
    ___arguments.context.pageData['werkminutengv'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/893ccc575c8e894a78ff1654a2badd67/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutentc')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))));
    ___arguments.context.pageData['werkminutentc'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0705680eb25da0a718dffed75f68edcd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatielocatiekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/fc740f79ad699e885b6872519dfd26dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieovparkeerkosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/4d3f47d19b1fe4a8e7ddc88706f2b993/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/a8678ce1d24e3f7d7fd2b836a5c98963/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('a8678ce1d24e3f7d7fd2b836a5c98963');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension, target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filelocatiekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filelocatiekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0eb5fb19f8eb5fdea2db230bd87f27e3/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('0eb5fb19f8eb5fdea2db230bd87f27e3');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filematerielekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filematerielekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5ebacb2c444cf0213a6781debf2192d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/6936d582b95657281367854ff59473fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/45d26eb69a0c2be5393e9a3f55eb120f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/ebce23b9b931c263e459e943cceb3c9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/cb94cbdfd6ba1cf714939c2ddd4f76b6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svlocatiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/e264e4fd220535f7b6d39cb4b26664b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svmaterielekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f833018aaf62b8fb377600d50a6ce1fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svparkeerkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/56e40bfc255bd834074986b636298e52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svreiskosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/655ed4d7614e77c5310336d63fd37a94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/87fbe28ccd3e5845f76fbd74d1b69bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenbl'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedbl')) == true) {
    ___arguments.context.pageData['werktijdbestuurslidblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdbestuurslidblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visibl'] = true;
  } else {
    ___arguments.context.pageData['visibl'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/fe247637d0ad87197fa69c9f6b9a4306/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenco'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedco')) == true) {
    ___arguments.context.pageData['werktijdcoordinatorblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdcoordinatorblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visico'] = true;
  } else {
    ___arguments.context.pageData['visico'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/adaff29ea5b65279154315c8f7521e27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutentc'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedtc')) == true) {
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdteamcoordinatorblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visitc'] = true;
  } else {
    ___arguments.context.pageData['visitc'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3185cf24ed24b55882058627616600bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutengv'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedgv')) == true) {
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdgeestelijkverzorgerblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visigv'] = true;
  } else {
    ___arguments.context.pageData['visigv'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d8e3a02c000c023e4447e9d9472a3e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwlocatiekosten'] = null;
  ___arguments.context.pageData['btwlocatiekosten'] = null;
  ___arguments.context.pageData['bedraglocatiekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedlk')) == true) {
    ___arguments.context.pageData['bedraglocatiekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedraglocatiekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/c578a08cd271849996985f0712c57bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwmaterielekosten'] = null;
  ___arguments.context.pageData['btwmaterielekosten'] = null;
  ___arguments.context.pageData['bedragmaterielekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedmk')) == true) {
    ___arguments.context.pageData['bedragmaterielekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragmaterielekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/94f5aa1b0d4dbc2435837c0e65168da1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwparkeerkosten'] = null;
  ___arguments.context.pageData['btwparkeerkosten'] = null;
  ___arguments.context.pageData['bedragparkeerkosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedpk')) == true) {
    ___arguments.context.pageData['bedragparkeerkostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragparkeerkostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/c3a7711b68ff3644741e5363a4b385d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['kilometers'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedrk')) == true) {
    ___arguments.context.pageData['bedragaantalkmblock'] = true;
  } else {
    ___arguments.context.pageData['bedragaantalkmblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/194850093956f064864d15092e28b29f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvastevacatiegelden'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedvg')) == true) {
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragvastevacatiegeldenblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visivg'] = true;
  } else {
    ___arguments.context.pageData['visivg'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/91539a7bb09575be305e53d14d26c67d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminutenpl'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedpl')) == true) {
    ___arguments.context.pageData['werktijdprojectleiderblock'] = true;
  } else {
    ___arguments.context.pageData['werktijdprojectleiderblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visipl'] = true;
  } else {
    ___arguments.context.pageData['visipl'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/23682a7871319c1f5c52ac71e2cd38e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'werktijdprojectleiderblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/77f443ad752d25d50a0dc0bf1c48efa3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'werkminutenpl')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))) {
    (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))));
    ___arguments.context.pageData['werkminutenpl'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/2a868f3a245e9dc5cd393ede8c3df437/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f27f010c5b89088dd2efbd8a5a8a9732/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/6c725f97168a7224e1b3e743d5892cad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilligersvergoedingblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d12ca1e815a449ce99e8f13db4c82f1e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var state, reistijdwaarde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragvrijwilliger'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedvrijwilliger')) == true) {
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = true;
  } else {
    ___arguments.context.pageData['bedragvrijwilligersvergoedingblock'] = false;
  }
  reistijdwaarde = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties('reistijd').setPageSize(10))).map(async reistijdwaarde => {; return ({ 'reistijd': (getObjectProperty(reistijdwaarde, 'reistijd')) });})))[0];
  if ((getObjectProperty(reistijdwaarde, 'reistijd')) == 'Ja') {
    ___arguments.context.pageData['visivw'] = true;
  } else {
    ___arguments.context.pageData['visivw'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0d89994cf30e6de94747e39716948ada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatievrijwilligersvergoeding'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/e93e2648b32e052a52c9bca3321b2264/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragvrijwilliger')) > (getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))) {
    (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))));
    ___arguments.context.pageData['bedragvrijwilliger'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e93e2648b32e052a52c9bca3321b2264')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/31fa33086e05949e6726557243a6ee58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwadministratiekosten'] = null;
  ___arguments.context.pageData['btwadministratiekosten'] = null;
  ___arguments.context.pageData['bedragadministratiekosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedak')) == true) {
    ___arguments.context.pageData['bedragadministratiekostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragadministratiekostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/dc9a27ba5bcf22963a936cf71a41fdbf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwitkosten'] = null;
  ___arguments.context.pageData['btwitkosten'] = null;
  ___arguments.context.pageData['bedragitkosten'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedit')) == true) {
    ___arguments.context.pageData['bedragitkostenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragitkostenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/dceae4f25198c697819ac5ea09392cfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragadministratiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
    ___arguments.context.pageData['exbtwadministratiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dceae4f25198c697819ac5ea09392cfe')));
    ___arguments.context.pageData['bedragadministratiekosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/5fe5875d9ee2190c777a9244d7f998f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragadministratiekosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwadministratiekosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwadministratiekosten')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
    ___arguments.context.pageData['exbtwadministratiekosten'] = null;
    ___arguments.context.pageData['bedragadministratiekosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dceae4f25198c697819ac5ea09392cfe')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/28cbde5d0add7b914d250a91f48c934a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragitkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
    ___arguments.context.pageData['exbtwitkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cbde5d0add7b914d250a91f48c934a')));
    ___arguments.context.pageData['bedragitkosten'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/6fa76e08d6465ffd6a9891ee707f2625/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragitkosten'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwitkosten')) + (getObjectProperty(___arguments.context.pageData, 'exbtwitkosten')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
    ___arguments.context.pageData['exbtwitkosten'] = null;
    ___arguments.context.pageData['bedragitkosten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('28cbde5d0add7b914d250a91f48c934a')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/6ff3d53a17f3699fedb3f0d1c22e8b52/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileladministratiekosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileladministratiekosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('6ff3d53a17f3699fedb3f0d1c22e8b52');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/ab5210b8f2b3e781ab935fb83d0a85dd/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['fileitkosten'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['fileitkosten'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ab5210b8f2b3e781ab935fb83d0a85dd');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/53f7ab3427fca1fa0fed7a475e01bd2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svadministratiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/ac15aabd32a7e5e90de50104ece10fa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svitkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/7879ae01e90d893789fb78567ce7910c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieadministratiekosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/7dab80f8a41e35ad415c9be3ba25a979/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatieitkosten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3b852e7b31ad4ed5a1337f445732453b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragadministratiekostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/708398a50f4f240e05c209b131c76624/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragitkostenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0b33a4ffeae60b36b47eb9bca3ff4e62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svkostenderden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f266ecd4c045001992648f216658daef/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exbtwkostenderden'] = null;
  ___arguments.context.pageData['btwkostenderden'] = null;
  ___arguments.context.pageData['bedragkostenderden'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'selectedkd')) == true) {
    ___arguments.context.pageData['bedragkostenderdenblock'] = true;
  } else {
    ___arguments.context.pageData['bedragkostenderdenblock'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/4c7681f4edbe322fdc869ff55608b425/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragkostenderden'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c7681f4edbe322fdc869ff55608b425')));
    ___arguments.context.pageData['bedragkostenderden'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/9b35bf0c8e5cd5e280e46ab2febfa10d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bedragkostenderden'] = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')))));
  if (((getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btwkostenderden')) + (getObjectProperty(___arguments.context.pageData, 'exbtwkostenderden')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
    (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
    ___arguments.context.pageData['exbtwkostenderden'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c7681f4edbe322fdc869ff55608b425')));
    ___arguments.context.pageData['bedragkostenderden'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/e55f7d19ef3a7fbd62d437ca1cc749c7/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e55f7d19ef3a7fbd62d437ca1cc749c7');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['filekostenderden'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['filekostenderden'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/70f247ada1063121284599e87a7e9626/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'bedragkostenderdenblock')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f08b684548440e1ae5e709fafde447ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatiekostenderden'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/4a2c6034d3a57dcf30be73c663c4b952/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/4f73a39d3f13c3995b1514041d651a0e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/a017dcaac54be5367e584e697f5ce067/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/fc0830b2c7449bedfce23e8fd7df217b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d2626efb62bb5a084a2dd5b203c11348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/56ea553ddc620265d0cf3d71609fcb32/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Bedrag invullen:'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0e6cf2d94bb3d475ed0e3df4e64223bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/368184e5c27b7b7e576f98b439f45d05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/bfcba5e2931f8a6c5d62db06fb8cf8f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d484035a93c8ba8349ba550c3775b89c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/2754ab4aac4e367f71991944b3eba373/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/cc8805ee016980bdc8a28285ac4a7e7b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/dc3f950c13fe155d6e75f016426c0f44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/a5db2d6f7dcd216fc467dd18f1859d1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3a13c7f7ad46750a42a91a7252e37d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/70abc28a8f2fbe9b8875bf8177f94c48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/e9575836cd67cdc5805b82e86d9aa51a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/7c3cdb324b3f0e553379c7369b872a7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/c9baa3b48e65325aa7563af80d2a476d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/749167dc7487b5b9ba2f4c921d886bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/804b3fc9249f0de3d715a20180a58f63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/479ae5bfbc7a0c4d1c3c9dfef997d87b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdbl'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/a874a0353295dde9b674aa6fe282f2d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdco'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visico'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/4ca8fd93a88b3409ba9bffe6e0068c81/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdtc'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visitc'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/0dd5856ea78fb58f1abc793c9ef1da3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdpl'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visipl'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/dcda190601dd7cda013487efb8dad4d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdgv'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visigv'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/1c69c10cc944accad6b7c3d5636da444/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdvw'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivw'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/38e3690a32914b4b8f01930652cec77e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'informatietekstreistijdvg'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visivg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/431a755d2d55bc34dce5723fb056dec9/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/aab701220aa341057f825774528eff1d/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/7e6bc0e612444aabf94752bbe7d79f46/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3ee1c88dea06e78c18aa38e7d955e43f/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/f6c20a62ba06e8bb1b72f993b6fbfab6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/22bd9d0f568473d166caad459de5b7ec/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/fcab51eb95d422cc6e546516b82e41b6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/2824a5b4f303a8e982c18e898eeaa1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/329992740d986461cd040cfe34694d6f/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/48892734c34647c13b37f226c56e1333/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/9b8be778e0a7a57aef28ccadc365b28c/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/d9dad562738e915285025cae4781281d/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/3cee71185aad59939611bebfcf5bbbf9/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/declaratieindienen_v2_backup/components/8a9d59613682a28f30fb0fff0231662b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    text = 'Alleen aanvinken als er geen betaling meer hoeft te volgen';
  } else {
    text = 'Aanklikken als de factuur of bon rechtstreeks door de administrateur wordt betaald. Niet aanklikken als je het hebt voorgeschoten.';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/5f4671d2f6343e8584e8771e9352d2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/ac87c8fa16e485d293199495c6720a16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/fb13e3e3e27b9c617ae879cd7fd824c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/25c914c5171ae269b454e393f72304e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/1d273ce6120df6f357413d362015c2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/7ed532a8f53286c87ccbc39c0bc1050c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/93cb27ef87a1dce932eda874836fea84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND factuuradres=\'VSCL\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/5f4671d2f6343e8584e8771e9352d2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/ac87c8fa16e485d293199495c6720a16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/fb13e3e3e27b9c617ae879cd7fd824c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/25c914c5171ae269b454e393f72304e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/1d273ce6120df6f357413d362015c2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/7ed532a8f53286c87ccbc39c0bc1050c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/93cb27ef87a1dce932eda874836fea84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('e0db28f3ec44c0b11cbb7c8775c8d64e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/e60e906514dac6390e181c78ac98b998/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e60e906514dac6390e181c78ac98b998', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND factuuradres=\'UVH\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/39dc28066f98f5e8255103443c0a797a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/eb485498f198b168e925b3584cca5838/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/8ab59c6c91780efd7748f21d212877ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/5ac813d14d88e888c23873787a5bf392/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/e398e6e391c8b188b66857a88dd72f38/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/2a7c66de2d1527383f48d288f4b339c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevensvscl/components/1687e31843284ccf7e883d0824a8f828/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('a538503d8df8f868122924d83ef7bb8e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND factuuradres =\'',(getObjectProperty(___arguments.context.pageData, 'factuuradres')),'\' OR factuuradres IS NULL'].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var count, j, centrafactuurnummer, item, userlistfactuurnummers, userslist, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function factuurnummers_aanmaken_per_maand() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    centrafactuurnummer = 'MNL';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
    centrafactuurnummer = 'RDAM';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
    centrafactuurnummer = 'GLD';
  } else {
    centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  }
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','whereClause': (['centra=\'',centrafactuurnummer,'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslistfactuurnummers: ') + String(userlistfactuurnummers));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle=\'AKKOORD\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslist: ') + String(userslist));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      count = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join('')))));
      if (count == 0) {
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: centrafactuurnummer,[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: 1 }) );
      } else {
        count = (await asyncListSort((await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join(''))).setProperties('nummer').setSortBy('nummer DESC').setPageSize(10))), -1, async (item) => {


         return (getObjectProperty(item, 'nummer'));
        }))[0];
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: centrafactuurnummer,[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: (getObjectProperty(count, 'nummer')) + 1 }) );
      }
    }
  }
}

/**
 * Describe this function...
 */
async function factuurnummers_aanmaken_per_maand_VSCL() {
  centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','whereClause': (['centra=\'',centrafactuurnummer,'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslistfactuurnummers: ') + String(userlistfactuurnummers));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslist: ') + String(userslist));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      count = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\' AND centra=\'VSCL\''].join('')))));
      if (count == 0) {
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: centrafactuurnummer,[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: 1 }) );
      } else {
        count = (await asyncListSort((await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join(''))).setProperties('nummer').setSortBy('nummer DESC').setPageSize(10))), -1, async (item) => {


         return (getObjectProperty(item, 'nummer'));
        }))[0];
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: centrafactuurnummer,[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: (getObjectProperty(count, 'nummer')) + 1 }) );
      }
    }
  }
}

/**
 * Describe this function...
 */
async function factuurnummers_aanmaken_per_maand_UVH() {
  centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','whereClause': (['centra=\'','UVH','\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslistfactuurnummers: ') + String(userlistfactuurnummers));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslist: ') + String(userslist));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      count = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\' AND centra=\'UVH\''].join('')))));
      if (count == 0) {
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: 'UVH',[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: 1 }) );
      } else {
        count = (await asyncListSort((await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join(''))).setProperties('nummer').setSortBy('nummer DESC').setPageSize(10))), -1, async (item) => {


         return (getObjectProperty(item, 'nummer'));
        }))[0];
        await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: 'UVH',[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: (getObjectProperty(count, 'nummer')) + 1 }) );
      }
    }
  }
}

/**
 * Describe this function...
 */
async function oude_else() {
  await Backendless.Data.of('factuurnummers').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`username`]: j,[`aanmaakmaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: count + 1 }) );
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == null) {
    (function (message) { alert(message) })('Factuuradres moet geselecteerd worden');
  } else {
    ___arguments.context.pageData['filternaamgv'] = '%';
    ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'VSCL') {
      await factuurnummers_aanmaken_per_maand_VSCL();
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'UVH') {
      await factuurnummers_aanmaken_per_maand_UVH();
    } else {
      await factuurnummers_aanmaken_per_maand();
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'VSCL') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','VSCL','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'UVH') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','UVH','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['factdatum'] = (getObjectProperty(___arguments.context.appData, 'factdatum'));
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['factuuradres'] = (getObjectProperty(___arguments.context.appData, 'factuuradres'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'VSCL') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','VSCL','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'UVH') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','UVH','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukken/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == null) {
    (function (message) { alert(message) })('Vul eerst het factuuradres in.');
  } else {
    ___arguments.context.appData['factuuradres'] = (getObjectProperty(___arguments.context.pageData, 'factuuradres'));
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.appData['factgebruiker'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'gebruiker'));
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'VSCL') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenfactuurvscl', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'UVH') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenfactuuruvh', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenfactuur', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 0 }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;
  ___arguments.context.pageData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/f055cad8696dcf895949d03896c81812/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'VSCL') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','VSCL','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == 'UVH') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\'',' AND factuuradres =\'','UVH','\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['centra', 'aanmaakmaand', 'naam', 'maandakkoord', 'email', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/53cb1d85cab8e068473e09b80308fde1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['maandselectie'] = undefined;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['INVOICE'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('856680a61949a83eb1a8478ed0e6ddec', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dabd8d3ebb0ee43cba91a3fdf7aede65', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8588789085cd90a69e1be433d4433a1', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7821334ce34251608bcc7e167da4901', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('000d043d25dc58130d99a66c50521fb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee4f6b3e2aacf228be1d842aa71ebbef', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.appData, 'maandselectie')),' - ',(getObjectProperty(___arguments.context.appData, 'factnaam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	if (euro) {
  	  // We maken van het getal eerst een string met 2 decimalen,
  	  // en zetten dat weer om naar een getal voor de formatter.
  	  let roundedEuro = Number(parseFloat(euro).toFixed(2));

  	  let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	    style: "currency",
  	    currency: "EUR",
  	  });

  	  result = EUcostFormat.format(roundedEuro);
  	} else {
  	  result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14b6ae5812a265798d6226178fa862ef'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND extrainformatie is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ee4f6b3e2aacf228be1d842aa71ebbef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4b7567447f9b3be56a0665b624bf5b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/75c5ac622d5cc511a516b85e60fe2ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/c282864d56ae9c0deab4c11c45030f34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/c9f44db226bdc6075caf9be4b624a3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/856680a61949a83eb1a8478ed0e6ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/867f80439271706f4c38747f74e32807/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/19268d5a5e45e69ab975babf7255e60c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/20f94af482ce9eaad4a9ae69e85db016/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/dabd8d3ebb0ee43cba91a3fdf7aede65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f8588789085cd90a69e1be433d4433a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f60110ecc74a0b3900ec9f441b1788cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/00cdebe9218bf81f09b1d1a51e9cd5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/02983e0d981f7ea188c949a271a57b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/cec2199ea578d4ed6459a3eedfaf189e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/25e52648735f9c7e98f1489fd55f7494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/41a53d86c856ad58bf5ea9c1f5222536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/0b9c8c47c406e83f52eb9359a3fd3d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/badb3f656a8a7fd56386d09b2ad46bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/ac3f7ac990412e6180e7cdfc72bb1873/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/3c6165cc9fc58db9a8bd37ac7adc5a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/2ad7d6761a49863a5bf64e1344af8cc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/27d4a246726986a6f17f71d9e09af14d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/87c52c0a4c99c82d2284258187d78d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/cda805e96a4ee3c50c85680da80bbf76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/976772f92cc2d68425fbaea25faebad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/0e8afd19f12810ba276e84cb384a1da9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a1bd29c69e75275bd02fe75a55241405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/4a5e280b93e5e642db1cc474b445e332/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/218b3c72e071026c6ea43f1e107876c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/a7821334ce34251608bcc7e167da4901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/000d043d25dc58130d99a66c50521fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/aee86ab91313933de54a056f948c6ac2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
    centrafactuurnummer = 'MNL';
  } else if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Rotterdam') {
    centrafactuurnummer = 'RDAM';
  } else if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Gelderland') {
    centrafactuurnummer = 'GLD';
  } else {
    centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aee86ab91313933de54a056f948c6ac2', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',centrafactuurnummer,'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('factuurnummer').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f6052f0486aa32a77e3ffb9b8b5c75dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var factuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible, centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/f928a99a30fe5f71a0a70f49f87ccfa2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/e4c32ca5bbec59487a5c41ba9ef29ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text, visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuurnummer:';
  } else {
    text = 'Kwitantienummer:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuur/components/adac8dd99df14cfd84420f6b59a8143d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var cent, euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['factuurkwitantie'] = (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['maandselectie'] = undefined;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['INVOICE'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('856680a61949a83eb1a8478ed0e6ddec', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dabd8d3ebb0ee43cba91a3fdf7aede65', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8588789085cd90a69e1be433d4433a1', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7821334ce34251608bcc7e167da4901', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('000d043d25dc58130d99a66c50521fb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND kmbtw<>0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee4f6b3e2aacf228be1d842aa71ebbef', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND kmbtw=0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\'',' AND factuuradres=\'UVH\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.appData, 'maandselectie')),' - ',(getObjectProperty(___arguments.context.appData, 'factnaam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\' AND factuuradres=\'UVH\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	if (euro) {
  	  // We maken van het getal eerst een string met 2 decimalen,
  	  // en zetten dat weer om naar een getal voor de formatter.
  	  let roundedEuro = Number(parseFloat(euro).toFixed(2));

  	  let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	    style: "currency",
  	    currency: "EUR",
  	  });

  	  result = EUcostFormat.format(roundedEuro);
  	} else {
  	  result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14b6ae5812a265798d6226178fa862ef'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND extrainformatie is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ee4f6b3e2aacf228be1d842aa71ebbef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4b7567447f9b3be56a0665b624bf5b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/75c5ac622d5cc511a516b85e60fe2ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/c282864d56ae9c0deab4c11c45030f34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/c9f44db226bdc6075caf9be4b624a3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/856680a61949a83eb1a8478ed0e6ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/867f80439271706f4c38747f74e32807/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/19268d5a5e45e69ab975babf7255e60c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/20f94af482ce9eaad4a9ae69e85db016/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/dabd8d3ebb0ee43cba91a3fdf7aede65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f8588789085cd90a69e1be433d4433a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f60110ecc74a0b3900ec9f441b1788cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/00cdebe9218bf81f09b1d1a51e9cd5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/02983e0d981f7ea188c949a271a57b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/cec2199ea578d4ed6459a3eedfaf189e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/25e52648735f9c7e98f1489fd55f7494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/41a53d86c856ad58bf5ea9c1f5222536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/0b9c8c47c406e83f52eb9359a3fd3d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/badb3f656a8a7fd56386d09b2ad46bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/ac3f7ac990412e6180e7cdfc72bb1873/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/3c6165cc9fc58db9a8bd37ac7adc5a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/2ad7d6761a49863a5bf64e1344af8cc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/27d4a246726986a6f17f71d9e09af14d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/87c52c0a4c99c82d2284258187d78d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/cda805e96a4ee3c50c85680da80bbf76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/976772f92cc2d68425fbaea25faebad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/0e8afd19f12810ba276e84cb384a1da9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a1bd29c69e75275bd02fe75a55241405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/4a5e280b93e5e642db1cc474b445e332/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/218b3c72e071026c6ea43f1e107876c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/a7821334ce34251608bcc7e167da4901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/000d043d25dc58130d99a66c50521fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/aee86ab91313933de54a056f948c6ac2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
    centrafactuurnummer = 'MNL';
  } else {
    centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aee86ab91313933de54a056f948c6ac2', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','UVH','\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('factuurnummer').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f6052f0486aa32a77e3ffb9b8b5c75dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var factuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible, centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/f928a99a30fe5f71a0a70f49f87ccfa2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/e4c32ca5bbec59487a5c41ba9ef29ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text, visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuurnummer:';
  } else {
    text = 'Kwitantienummer:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuuruvh/components/adac8dd99df14cfd84420f6b59a8143d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var cent, euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['factuurkwitantie'] = (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['maandselectie'] = undefined;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['INVOICE'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('856680a61949a83eb1a8478ed0e6ddec', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dabd8d3ebb0ee43cba91a3fdf7aede65', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8588789085cd90a69e1be433d4433a1', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7821334ce34251608bcc7e167da4901', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('000d043d25dc58130d99a66c50521fb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND kmbtw<>0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee4f6b3e2aacf228be1d842aa71ebbef', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND kmbtw=0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\'',' AND factuuradres=\'VSCL\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.appData, 'maandselectie')),' - ',(getObjectProperty(___arguments.context.appData, 'factnaam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\' AND factuuradres=\'VSCL\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	if (euro) {
  	  // We maken van het getal eerst een string met 2 decimalen,
  	  // en zetten dat weer om naar een getal voor de formatter.
  	  let roundedEuro = Number(parseFloat(euro).toFixed(2));

  	  let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	    style: "currency",
  	    currency: "EUR",
  	  });

  	  result = EUcostFormat.format(roundedEuro);
  	} else {
  	  result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14b6ae5812a265798d6226178fa862ef'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND extrainformatie is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ee4f6b3e2aacf228be1d842aa71ebbef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4b7567447f9b3be56a0665b624bf5b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/75c5ac622d5cc511a516b85e60fe2ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/c282864d56ae9c0deab4c11c45030f34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/c9f44db226bdc6075caf9be4b624a3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/856680a61949a83eb1a8478ed0e6ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/867f80439271706f4c38747f74e32807/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/19268d5a5e45e69ab975babf7255e60c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/20f94af482ce9eaad4a9ae69e85db016/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/dabd8d3ebb0ee43cba91a3fdf7aede65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f8588789085cd90a69e1be433d4433a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f60110ecc74a0b3900ec9f441b1788cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/00cdebe9218bf81f09b1d1a51e9cd5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/02983e0d981f7ea188c949a271a57b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/cec2199ea578d4ed6459a3eedfaf189e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/25e52648735f9c7e98f1489fd55f7494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/41a53d86c856ad58bf5ea9c1f5222536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/0b9c8c47c406e83f52eb9359a3fd3d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/badb3f656a8a7fd56386d09b2ad46bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/ac3f7ac990412e6180e7cdfc72bb1873/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/3c6165cc9fc58db9a8bd37ac7adc5a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2ad7d6761a49863a5bf64e1344af8cc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/27d4a246726986a6f17f71d9e09af14d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/87c52c0a4c99c82d2284258187d78d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/cda805e96a4ee3c50c85680da80bbf76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/976772f92cc2d68425fbaea25faebad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/0e8afd19f12810ba276e84cb384a1da9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {

	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a1bd29c69e75275bd02fe75a55241405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/4a5e280b93e5e642db1cc474b445e332/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/218b3c72e071026c6ea43f1e107876c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/a7821334ce34251608bcc7e167da4901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/000d043d25dc58130d99a66c50521fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/aee86ab91313933de54a056f948c6ac2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
    centrafactuurnummer = 'MNL';
  } else {
    centrafactuurnummer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aee86ab91313933de54a056f948c6ac2', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',centrafactuurnummer,'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('factuurnummer').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f6052f0486aa32a77e3ffb9b8b5c75dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible, centrafactuurnummer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/f928a99a30fe5f71a0a70f49f87ccfa2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/e4c32ca5bbec59487a5c41ba9ef29ca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text, visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuurnummer:';
  } else {
    text = 'Kwitantienummer:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/adac8dd99df14cfd84420f6b59a8143d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var cent, euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['factuurkwitantie'] = (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenfactuurvscl/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\'  AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['team', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'email', 'btwplichtig'] })));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }
  ___arguments.context.pageData['btwplichtig'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  await Backendless.Messaging.sendEmail((String('Verzoek om user te deactiveren van Applicatie DS_MNL - ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Verzoek van: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'<br><br>','Deze username moet gedeactiveerd worden:','<br>username: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')),'<br>naam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),'<br>organisatie: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie'))].join('')) }), ensureArray('info@lorio.nl'), undefined);
  await Backendless.Data.of('historieaanmeldingusers').save( ({ 'aangemelddoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'aanmeldingsdatum': (new Date(((new Date()).valueOf()))),'actie': 'Aanvraag tot deactiveren','centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'naam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),'organisatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')),'username': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')) }) );
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('87b21c497cf55673c52611530531b85e'))['label'] = 'Het verzoek tot deactivatie is verzonden.';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'team')) == null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    (function (message) { alert(message) })('Het team dient geselecteerd te worden');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
      result = true;
    } else {
      result = false;
    }
    await Backendless.Data.of('newuserrequests').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`team`]: (getObjectProperty(___arguments.context.pageData, 'team')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),[`btwinclscholing`]: (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`viewinstellingenblock`]: result }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`emailnewuser`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`team`]: (getObjectProperty(___arguments.context.pageData, 'team')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),[`btwinclscholing`]: (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`viewinstellingenblock`]: result }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`team`]: (getObjectProperty(___arguments.context.pageData, 'team')) }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['rol'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['team'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('e44f6507d402cf92745c98f5a72880e8');
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['btwplichtig'] = false;
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND userStatus=\'ENABLED\'',' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['team', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'email', 'btwplichtig'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/gebruikersbeheer/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/953239d5058229af5f59984152aeeeca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['team', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'email', 'btwplichtig'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/80cb12f6a196b4b58b83b065e99e2542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['team', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'email', 'btwplichtig'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4c836e99fffea73b6fa1b016990e2322/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['team', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'email', 'btwplichtig'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/6ad20a464424c85adeac095a237937c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ecb933b6d248fd64663bb193f257da73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam, template;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    centranaam = 'Midden Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
    centranaam = 'Midden- & Oost- Brabant';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
    centranaam = 'Gelderland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
    centranaam = 'Haagsche-Zin';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
    centranaam = 'Limburg';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
    centranaam = 'Overijssel';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
    centranaam = 'Questio';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
    centranaam = 'Rotterdam & omstreken';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
    centranaam = 'Sichtpunt';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
    centranaam = 'Willem';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
    centranaam = 'Zuid-Holland Noord';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
    centranaam = 'Zinvol';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
    centranaam = 'Zuid West Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
    centranaam = 'Coöperatie NvL';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Lorio') {
    centranaam = 'Lorio';
  }
  await Backendless.Messaging.sendEmailFromTemplate('newuser', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'naam')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'username')),[`propName`]: centranaam,[`verzender`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  (function (message) { alert(message) })('De instructiemail is verzonden aan de gebruiker.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/6cd357ddeef103225a5a46913e8ca494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/e44f6507d402cf92745c98f5a72880e8/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['useraangemaakt = 0 AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/a0564e52e9e6239ef324f956fd72bfe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandakkoord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/574cd2731569b6041bc8a319aa7b4882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/ad1d6b081abc19dcf18f0eb66204ec0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mailsversturen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/3458a2575e3fe4fc701c5bc5e831d6ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://cvl23.lorio.nl', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/5b8b59a93bdf27a135394aed7aa90c82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('declaratieindienen_v2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandcontrole', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/b4e4904f4fd316cd0e51444ba7695cc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectenoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/fd0ca608999bd675b40ec72d5956524b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturatieadresgegevensvscl', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturatieadresgegevens', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/63c882547302736303fff99c660e6212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/971283dbebdb649e2ad3fe6201892761/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('updates', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/19fbeeffe2a5db1ee2fb014ed8c2aada/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/0bbfef2f2088465e2fe8823b01213e3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht_v2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/c6d5194f73da133fd4d28805df82c5e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/4bf49442f42df5de0d15403bf5cca978/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectenfinancieeloverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/efc168014aa5e7e8a0caa11dbd3ff9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/45884d595a1e740f3c71edeafae50a1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1ONm6M1B4riu9vkqjlovXh9At7lB89bDe/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/377d136dd229987ddcad88f605352667/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1tM4MwaZbbmUEdv9zeUoyHfL8Jx-DBDEZ/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/3166732d04532da40c6df273263a5e44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1n7SYqYxhE19LjytaJl-e9LEVt6d-4u2c/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/4e8ac5b88dca0896345cf8342c539b52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1TBzJM4Sq6AiwthK7PC3YSVev7Pyx66WP/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/13bbe404a03cb2bb9d6e7a7b8219b78a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1ui0eLd_YbOzeSTRGbQpMQ51vZFNAq8Op/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/1f87bb4b2f1e1483c06dd8c951485c7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/15krpqv_tPrnwLJzWuMljm28qWOpMOFo0/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/c8f27527e64ce07279cb62f75f3571b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/12H0yFPItJO59RUZN8gkg7bOLYWT9frvq/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/6e412e51753720d5e315aa6fd2a31ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/10GqiIzhaQYQjgg0cll-T07lmNTyaj7Xu/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/94f192d5595fd63b64e958490d11a1e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1hhI1iDmBQXhzTAUWndpFBKvxuBUnsjDb/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/0e8c4b3855198e71743a2cf5a70c2221/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/13Hc5Ks1XRi2_rLWfDalEWCQ9tFYUJdNK/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/4c7a54843ae742216593ea0c2cdd13ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1oagC-WNDNrie9Vtd28IgEZHtQsXww193/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/f3661a5be654d61ba6f1ffd7cfe243df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1IHMJEXE8itQw-AkUItzYgzkzPb9DA68S/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1UcRodK6WGpVQYctXX3DExHs_hLtwSGtH/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/1813ad7efcdcc24fe791d8d335b42376/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomnlbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/08ed82d346620a050de66e9e69b8c939/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvgooglestudiodata;


  csvgooglestudiodata = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvgooglestudiodatamnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['aanmaakjaar=\'2023\' AND controle=\'AKKOORD\' OR aanmaakjaar=\'2023\' AND controle=\'REEDS BETAALD\' OR ','aanmaakjaar=\'2024\' AND controle=\'AKKOORD\' OR aanmaakjaar=\'2024\' AND controle=\'REEDS BETAALD\' OR ','aanmaakjaar=\'2025\' AND controle=\'AKKOORD\' OR aanmaakjaar=\'2025\' AND controle=\'REEDS BETAALD\' ','OR aanmaakjaar=\'2026\' AND controle=\'AKKOORD\'  OR aanmaakjaar=\'2026\' AND controle=\'REEDS BETAALD\' '].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: undefined,[`pageSize`]: 10000,[`properties`]: ['aanmaakdatum', 'aanmaakdatumaanpassing', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragbtw', 'bedragbtwwaarde', 'bedragexbtw', 'bedragtotaal', 'betreft', 'bijlage', 'btwplichtig', 'controle', 'controleaantekeningen', 'controledatum', 'controleemailverzonden', 'controlereden', 'dashboardnaam', 'datum', 'datumdeclaratie', 'declaratienummer', 'invoer', 'kilometers', 'kmbtw', 'kmexbtw', 'kmtotaal', 'kostenplaats', 'maand', 'maandakkoord', 'maandakkoordmail', 'omschrijving', 'projectcode', 'projectnaam', 'registratienummer', 'soort', 'subsidie', 'tariefbtw', 'tariefperkm', 'tariefperminuut', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'werkminuten', 'werkminutenbtw', 'werkminutenexbtw', 'werkminutentotaal', 'objectId', 'ownerId', 'created', 'updated', 'centra'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakdatum', 'aanmaakdatumaanpassing', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragbtw', 'bedragbtwwaarde', 'bedragexbtw', 'bedragtotaal', 'betreft', 'bijlage', 'btwplichtig', 'controle', 'controleaantekeningen', 'controledatum', 'controleemailverzonden', 'controlereden', 'dashboardnaam', 'datum', 'datumdeclaratie', 'declaratienummer', 'invoer', 'kilometers', 'kmbtw', 'kmexbtw', 'kmtotaal', 'kostenplaats', 'maand', 'maandakkoord', 'maandakkoordmail', 'omschrijving', 'projectcode', 'projectnaam', 'registratienummer', 'soort', 'subsidie', 'tariefbtw', 'tariefperkm', 'tariefperminuut', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'werkminuten', 'werkminutenbtw', 'werkminutenexbtw', 'werkminutentotaal', 'objectId', 'ownerId', 'created', 'updated', 'centra'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvgooglestudiodata, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/6d2babe698f73788081134d4cc178514/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvbtwinstellingenmnl;


  csvbtwinstellingenmnl = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvbtwinstellingenmnl.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'userStatus=\'ENABLED\' AND dashboardnaam<>\'lori\'',[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: undefined,[`pageSize`]: 20000,[`properties`]: ['dashboardnaam', 'btwplichtig'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'btwplichtig'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvbtwinstellingenmnl, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/8f0e331e5eb75e747a1d66677be2cf8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvusersmnl, j, nietdeclarabellist, item, nietdeclarabel, registratieslist, registraties, dossierslist, dossiers;


  csvusersmnl = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvusersmnl.csv','tableName': 'Users','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: undefined,[`pageSize`]: 20000,[`properties`]: ['dashboardnaam', 'naam', 'organisatie', 'email'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'naam', 'organisatie', 'email'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvusersmnl, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/974acf198eedd65556e639de623a8764/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtlorio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/dcd9c32d13a48fca71392d25ab46bc61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtdsmnl2025.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['aanmaakjaar=2025',' AND controle=\'AKKOORD\' OR ','aanmaakjaar=2025',' AND controle=\'REEDS BETAALD\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['centra', 'aanmaakmaand as maand', 'date(datum) as datum', 'registratienummer', 'declaratienummer', 'projectcode', 'projectnaam', 'controle as status', 'naam', 'soort', 'omschrijving', 'organisatie', 'werkminuten', 'kilometers', 'bedragtotaal', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'maand', 'datum', 'registratienummer', 'declaratienummer', 'projectcode', 'projectnaam', 'status', 'naam', 'soort', 'omschrijving', 'organisatie', 'werkminuten', 'kilometers', 'bedragtotaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvJaaroverzicht, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/f52b410b27cdfbb312a7d18147c2b81a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaarcontrole', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/30947ea3997f0d410bc1542d090eaa71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/15krpqv_tPrnwLJzWuMljm28qWOpMOFo0/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/ac85ef6bd7a876c85f589b07692830d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('permissions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/e5f80dc873d8e8c45cf671692f96e7e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/3c588f586cf6733ae14d7dcad3e84a78/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c588f586cf6733ae14d7dcad3e84a78', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/6c9255485468899c28e83b59dc186138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvfactuurnummers;


  csvfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/factuurnummersnew.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: 'objectId is not null',[`relations`]: undefined,[`groupBy`]: 'maand,username',[`pageSize`]: undefined,[`properties`]: ['centra', 'aanmaakmaand', 'username'],[`columnsMapping`]: undefined }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvfactuurnummers, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht_v2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/365d3c9f35a137ca3804ed1c1c2c413a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d9235d6b15efdbeb69e939e666ea81b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/574cd2731569b6041bc8a319aa7b4882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('declaratieindienen_v2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/b4e4904f4fd316cd0e51444ba7695cc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/3c78a0cb7eeef84e8205b879cb92439c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://cvl23.lorio.nl/', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/e4db9371359c3874200e374d21017652/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1ONm6M1B4riu9vkqjlovXh9At7lB89bDe/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/72b9a96582022662433f32a4cb79deca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1tM4MwaZbbmUEdv9zeUoyHfL8Jx-DBDEZ/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/22c28266f149e11e2c63ab29dcad1a73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1n7SYqYxhE19LjytaJl-e9LEVt6d-4u2c/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/cc03de8c14322aa474731a4877646d13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/10GqiIzhaQYQjgg0cll-T07lmNTyaj7Xu/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d7f350e94f82993ec9321ec34bac599b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1IHMJEXE8itQw-AkUItzYgzkzPb9DA68S/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1FDpxfk4m30I_S0cum93KTkT8Ja69aWrS/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/ababf991ebe3ff98db8c7fc803c81c38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/38be0f1349f89fa7a9d834e862142c77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectenoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d048717848880b8cabfac5bb9e71a488/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandcontroleperprojectall', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/c68be928c0a85d0848b811e83f08d128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1TBzJM4Sq6AiwthK7PC3YSVev7Pyx66WP/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/a49fcbe82d38ff72a62a9e7ac7c84bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1ui0eLd_YbOzeSTRGbQpMQ51vZFNAq8Op/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/c1fac2e85d9813cf3258c9755f93ab88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/15krpqv_tPrnwLJzWuMljm28qWOpMOFo0/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/62c92d57be084a4c84d85092158107b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/c1e86886ae480e6aa7888f12fa58d3a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn27sil' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Br0012jml')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/45f80b1acfa8bacd336ef5685a884f58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/eaa87544c056d41d87dd30fcaed86e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaarcontroleprojectleiders', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/272dfae8a5d6a5b322217f48a668b1c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/15krpqv_tPrnwLJzWuMljm28qWOpMOFo0/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/861864d841f8ed9e67c642e8e648e8a8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('861864d841f8ed9e67c642e8e648e8a8', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12c454e2886534edcf4393894d22219', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a69240f4cce6798bf5d2c918c74c2f4', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ce3e81b02364eaa3c0c11e2f895e801')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7dfd192d040ea3656b0b8c42084ff3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/9b250b5ac5ef73d362b40c5ef967bc42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#89b087';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/8abb41ce996c4b251fb9cfd598ae3f9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await Backendless.UserService.logout();
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), false);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
      }
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0ea61c9bfc8fb45df3185d0f605189d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/00c12203fb5fb62c8d517401c5968862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/2d51f4cbaa53e3b2e878436f0d575618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1NZ7O6DF2oEUbkA2B_2j5D2wf6VXtrWLP/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/e9412d6853e70dca21d69c9a16febda7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/5238b248ffa3d41e6f3d4db33dee9b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/Gebruikersvoorwaarden MNL v1.0.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/d9d7a60547ed6afa166324a2ebee52a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = '%';
  ___arguments.context.pageData['filterprojectcode'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/jaarcontrole/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakjaar').setSortBy('created DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });}))), ({ [`value`]: '%',[`label`]: 'Alle jaren' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterjaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true,[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`info`]: 'registratie komt van status OPNIEUW INGEDIEND',[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontrole/components/36021d5de6ad92cceefc7fc478f6050e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectnaam').setSortBy('projectnaam ASC').setGroupBy('projectnaam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectnaam')),[`label`]: (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/95626727ce81f315dc15aedbd484e6e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectcode').setSortBy('projectcode ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: (getObjectProperty(item, 'projectcode')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/a53a72d4b49b28b5e0afe90dad9ac454/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectnaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/d992a4f60a6a0a8be462713bd3833ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectcode'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/d27999225b48e52e345ef309ca52ecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53dbca2609b6bd1a57c2e6186feff784')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/805b1424ff4c7984cd22d47f36c26af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/2c992123dc3fb18eadd9cfb164c3da9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijdert',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'naam')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontrole/components/486afa3e2b92de41b7e375562528915c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  } else {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/jaarcontrole/components/51dac6cf10d9f8bfe2a470a86414d0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontrole/components/084537a10503b086d86d8c948198ec45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/jaaroverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datum) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvJaaroverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = (getObjectProperty(___arguments.context.appData, 'projectnaam'));
  ___arguments.context.pageData['filterprojectcode'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setProperties('aanmaakjaar').setSortBy('created DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });}))), ({ [`value`]: '%',[`label`]: 'Alle jaren' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterjaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true,[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`info`]: 'registratie komt van status OPNIEUW INGEDIEND',[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.appData, 'projectnaam')),'\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/4d5ddb451ce7308120fe70b67c1c8fa5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'projectnaam'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/2112763a5fcdbb868be6530defee3a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63571b881632b9ae1d3a984e4841f39b')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/9d33c3c31a2c82348db51f02b50679c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/5164764708f7d296c6a826b42b031c52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijdert',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'naam')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/623d3b158d7cd71348c23c05187f773c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/cf46e7d45bca4cbbc6b1c4c3189e9a0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.print()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleperproject/components/d00e8ee2dbe894a380ccf63c0d0a4845/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl-mnl.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/jaaroverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datumdeclaratie) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvJaaroverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var listprojectcodes, listprojectleiders, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = '%';
  ___arguments.context.pageData['filterprojectcode'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;
  listprojectleiders = (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND svprojectleider=\'1\'',' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('projectcode').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'projectcode'));})));
  listprojectcodes = listprojectleiders.join('\',\'');
  ___arguments.context.pageData['filterprojectcode'] = listprojectcodes;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakjaar').setSortBy('created DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });}))), ({ [`value`]: '%',[`label`]: 'Alle jaren' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterjaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true,[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`info`]: 'registratie komt van status OPNIEUW INGEDIEND',[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filterjaar')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/36021d5de6ad92cceefc7fc478f6050e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectnaam').setSortBy('projectnaam ASC').setGroupBy('projectnaam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectnaam')),[`label`]: (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/95626727ce81f315dc15aedbd484e6e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectcode').setSortBy('projectcode ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: (getObjectProperty(item, 'projectcode')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/a53a72d4b49b28b5e0afe90dad9ac454/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectnaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/d992a4f60a6a0a8be462713bd3833ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectcode'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/d27999225b48e52e345ef309ca52ecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53dbca2609b6bd1a57c2e6186feff784')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/805b1424ff4c7984cd22d47f36c26af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/2c992123dc3fb18eadd9cfb164c3da9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijdert',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/486afa3e2b92de41b7e375562528915c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  } else {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/51dac6cf10d9f8bfe2a470a86414d0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaarcontroleprojectleiders/components/084537a10503b086d86d8c948198ec45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/jaaroverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datum) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvJaaroverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzicht/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Werktijd çoördinator','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Kilometervergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal', 'aanmaakjaar']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'aanmaakjaar']).setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('aanmaakjaar').setSortBy('created DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakjaar')),'label': (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in het jaar ',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzicht/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzicht/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzicht/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f5fa69b86d18d768205147d808285377', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties(['username', 'objectId']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandakkoord/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function totaalbedrag() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('53b8c877e341a215193f1ad61a38fd16', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('53b8c877e341a215193f1ad61a38fd16', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'REEDS BETAALD\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
}


  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b2d1738387eeb83132702d518878e44', (await Backendless.Data.of('maandafsluiten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setPageSize(100))));
  await totaalbedrag();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/6c98989bb6763daf4ef53737e753e4d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ [`maandakkoord`]: true }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 1,[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),[`naamgv`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == false) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ [`maandakkoord`]: false }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 0,[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),[`naamgv`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandakkoord/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function totaalbedrag() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  await totaalbedrag();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#EAB818';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#606742';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/536bf88fa7e15e87091f6692c205d116/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == true) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: true }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 1,[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: 'maandakkoordalles',[`naamgv`]: 'maandakkoordalles',[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == false) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: false }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 0,[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: 'maandakkoordalles',[`naamgv`]: 'maandakkoordalles',[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandakkoord/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function totaalbedrag() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e8f94183d099bb6cac8d8f8d651c978', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  await totaalbedrag();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true) {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtselfbilling', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailakkoord')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),[`centranaam`]: (getObjectProperty(___arguments.context.pageData, 'centranaam')),[`mailadresfacturatie`]: (getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailakkoord')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),[`centranaam`]: (getObjectProperty(___arguments.context.pageData, 'centranaam')),[`mailadresfacturatie`]: (getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie')) }), undefined);
  }
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),'\' ','AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoordmail`]: 1 }) );
  ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailakkoord'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/514b87df91c87a0759af23ebde228b54/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' is afgesloten'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('De maand moet eerst geselecteerd worden voordat de maand afgesloten kan worden.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1c671186c53ba3d546786987ae59e98c'), 'maandafsluiten')) == true) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ [`maandakkoord`]: true }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandafsluiten`]: true }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1c671186c53ba3d546786987ae59e98c'), 'maandafsluiten')) == false) {
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ [`maandakkoord`]: false }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandafsluiten`]: false }) );
    }
    ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1c671186c53ba3d546786987ae59e98c'), 'maandafsluiten'));
  }
  (function (message) { alert(message) })((['Maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' is afgesloten'].join('')));

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) != 'Lorio')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/06d3309bd70efca3bf74803845f86c1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true) {
    text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het projectensysteem ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' is akkoord bevonden.',' De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' voor uitbetaling.',' U vindt het maandoverzicht in het projectensysteem (https://project.lorio.nl) onder de knop \'maandoverzicht\'. Selecteer hier de maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'.'].join('');
  } else {
    text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het projectensysteem ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' (gebruikersnaam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),') is akkoord bevonden om te factureren. ','U vindt het maandoverzicht in het projectensysteem (https://project.lorio.nl) onder de knop \'maandoverzicht\'. Selecteer hier de maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),', maak een kwitantie/factuur aan en mail deze aan ',(getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie')),'.'].join('');
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/7b2d1738387eeb83132702d518878e44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'VIEW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/3773ea78257c5d888aadf756e5a8a079/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandafsluiten', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`filtermaand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  (function (message) { alert(message) })('Er is een mail verstuurd naar info@lorio.nl om de maand af te laten sluiten.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/f82b577d0709cda960b10dc8708bd9e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = ((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcc'] = (list.join(','));
  ___arguments.context.pageData['massiveemailakkoord'] = '';
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe1ffe942e0b180c3ba4b93cd79315e6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6e27756808975851917893f54456af', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2425a381a91ecef877377d497c30f16', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('25cbbd536f874422ab76cc44849f7d42', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/21a86be84f387385ced71de1e3b98aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true) {
    text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het projectensysteem ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' is akkoord bevonden.',' De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' voor uitbetaling.',' U vindt het maandoverzicht in het projectensysteem (https://project.lorio.nl) onder de knop \'maandoverzicht\'. Selecteer hier de maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'.'].join('');
  } else {
    text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het projectensysteem ',(getObjectProperty(___arguments.context.pageData, 'centranaam')),' is akkoord bevonden om te factureren. ','U vindt het maandoverzicht in het projectensysteem (https://project.lorio.nl) onder de knop \'maandoverzicht\'. Selecteer hier de maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),', maak een kwitantie/factuur aan en mail deze aan ',(getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie'))].join('');
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/c2425a381a91ecef877377d497c30f16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6e27756808975851917893f54456af', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe1ffe942e0b180c3ba4b93cd79315e6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2425a381a91ecef877377d497c30f16', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('25cbbd536f874422ab76cc44849f7d42', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/8df2edeac9b58f2dee5373beef91462c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true) {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtselfbilling', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: [(getObjectProperty(___arguments.context.pageData, 'bcc')), 'backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailakkoord')),[`centranaam`]: (getObjectProperty(___arguments.context.pageData, 'centranaam')),[`mailadresfacturatie`]: (getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordmassive', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: [(getObjectProperty(___arguments.context.pageData, 'bcc')), 'backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailakkoord')),[`centranaam`]: (getObjectProperty(___arguments.context.pageData, 'centranaam')),[`mailadresfacturatie`]: (getObjectProperty(___arguments.context.pageData, 'mailadresfacturatie')) }), undefined);
  }
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join('')), ({ [`maandakkoordmail`]: 1 }) );
  ___arguments.context.pageData['massiveemailakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2425a381a91ecef877377d497c30f16', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('25cbbd536f874422ab76cc44849f7d42', false);
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe1ffe942e0b180c3ba4b93cd79315e6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6e27756808975851917893f54456af', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  ___arguments.context.pageData['massiveemailakkoord'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/e64bc08e451606ad73ae4ec24c3dfce4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1c671186c53ba3d546786987ae59e98c'), 'maandafsluiten'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/maandakkoord/components/2b680988840871d5eed6c83849182c58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/f692c222bb3896a848f794aa6c485f08/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var registratiesobjectId, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/Pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('factuurgegevens').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/paging/Pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'declaratiesmnl', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandakkoord/components/81588bace9f899f9e15bbb6830685448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFileVSCL, list, csvFileUtrecht, old_exclude_properties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  old_exclude_properties = ['consultinwdoelgroep', 'maandfactuurontvangen', 'reistijdminutentotaalbedrag', 'organisatie'];
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND declaratiesmnl.aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND declaratiesmnl.controle=\'AKKOORD\''].join(''))).setProperties(['ibantennamevan', 'ibannummer', 'Sum(declaratiesmnl.totaalbedrag) as totaalbedrag', 'declaratiesmnl.aanmaakmaand as maand', 'declaratiesmnl.naam as naam', 'declaratiesmnl.organisatie as organisatie']).setSortBy('declaratiesmnl.naam').setGroupBy('declaratiesmnl.username').setPageSize(100)));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
    await Backendless.Data.of('verzamelbetalingwillem').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingwillem').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileVSCL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingwillem.csv','tableName': 'verzamelbetalingwillem','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    console.log('na export');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileVSCL, true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    await Backendless.Data.of('verzamelbetalingutrecht').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingutrecht').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileUtrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingutrecht.csv','tableName': 'verzamelbetalingutrecht','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    console.log('na export');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileUtrecht, true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
    await Backendless.Data.of('verzamelbetalingrotterdam').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingrotterdam').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileVSCL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingrotterdam.csv','tableName': 'verzamelbetalingrotterdam','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    console.log('na export');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileVSCL, true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
    await Backendless.Data.of('verzamelbetalinggelderland').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalinggelderland').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileVSCL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalinggelderland.csv','tableName': 'verzamelbetalinggelderland','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    console.log('na export');
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileVSCL, true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/575810ded2e730e79acbfbd8715866a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/cd5703284d75dff83561fd9899a824d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/efb4e8adfb789eb59c28f2f8db5a145f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('efb4e8adfb789eb59c28f2f8db5a145f', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandakkoord/components/d028f16e3601c6ebf8d3c7d1fab8593a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['centranaam'] = (getObjectProperty(___arguments.context.dataModel, 'centranaam'));
  ___arguments.context.pageData['mailadresfacturatie'] = (getObjectProperty(___arguments.context.dataModel, 'mailadresfacturatie'));
  ___arguments.context.pageData['selfbilling'] = (getObjectProperty(___arguments.context.dataModel, 'selfbilling'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandakkoord/components/7aa1dbd88cff56482f688ed86a9803e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/6758d8282532ec16dcb88136ec2861df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/7728f26c32184162d8e8dec1d32d6dd5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFileUtrecht, list, csvFileVSCL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND declaratiesmnl.aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND declaratiesmnl.controle=\'AKKOORD\'',' AND declaratiesmnl.factuuradres=\'VSCL\''].join(''))).setProperties(['ibantennamevan', 'ibannummer', 'Sum(declaratiesmnl.totaalbedrag) as totaalbedrag', 'declaratiesmnl.aanmaakmaand as maand', 'declaratiesmnl.naam as naam', 'declaratiesmnl.organisatie as organisatie']).setSortBy('declaratiesmnl.naam').setGroupBy('declaratiesmnl.username').setPageSize(100)));
  await Backendless.Data.of('verzamelbetalingvscl').bulkDelete( 'objectId is not null' );
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Data.of('verzamelbetalingvscl').bulkCreate( list );
  await new Promise(r => setTimeout(r, 1000 || 0));
  csvFileVSCL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingvscl.csv','tableName': 'verzamelbetalingvscl','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
  console.log('na export');
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileVSCL, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling VSCL ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/93a61ef8b71b33f84378ca380fffe33b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFileUVH, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND declaratiesmnl.aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND declaratiesmnl.controle=\'AKKOORD\'',' AND declaratiesmnl.factuuradres=\'UVH\''].join(''))).setProperties(['ibantennamevan', 'ibannummer', 'Sum(declaratiesmnl.totaalbedrag) as totaalbedrag', 'declaratiesmnl.aanmaakmaand as maand', 'declaratiesmnl.naam as naam', 'declaratiesmnl.organisatie as organisatie']).setSortBy('declaratiesmnl.naam').setGroupBy('declaratiesmnl.username').setPageSize(100)));
  await Backendless.Data.of('verzamelbetalinguvh').bulkDelete( 'objectId is not null' );
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Data.of('verzamelbetalinguvh').bulkCreate( list );
  await new Promise(r => setTimeout(r, 1000 || 0));
  csvFileUVH = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalinguvh.csv','tableName': 'verzamelbetalinguvh','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['ibantennamevan', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`ibantennamevan`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
  console.log('na export');
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFileUVH, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling UVH',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra'))].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = '%';
  ___arguments.context.pageData['filterprojectcode'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandcontrole/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function totaalbedrag() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await totaalbedrag();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ [`value`]: '%',[`label`]: 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true,[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`info`]: 'registratie komt van status OPNIEUW INGEDIEND',[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam, reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
      centranaam = '';
    }
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam, mailadresfacturatie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    centranaam = 'Midden Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
    centranaam = 'Midden- & Oost- Brabant';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
    centranaam = 'Gelderland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
    centranaam = 'Haagsche-Zin';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
    centranaam = 'Limburg';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
    centranaam = 'Overijssel';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
    centranaam = 'Questio';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
    centranaam = 'Rotterdam & omstreken';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
    centranaam = 'Sichtpunt';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
    centranaam = 'Willem';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
    centranaam = 'Zuid-Holland Noord';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
    centranaam = 'Zinvol';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
    centranaam = 'Zuid West Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
    centranaam = 'Coöperatie NvL';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
    centranaam = '';
  }
  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/36021d5de6ad92cceefc7fc478f6050e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectnaam').setSortBy('projectnaam ASC').setGroupBy('projectnaam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectnaam')),[`label`]: (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/95626727ce81f315dc15aedbd484e6e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('projectcode').setSortBy('projectcode ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: (getObjectProperty(item, 'projectcode')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/a53a72d4b49b28b5e0afe90dad9ac454/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectnaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/d992a4f60a6a0a8be462713bd3833ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settotaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dd01a77517ddb641dbf4cb56df8bbc9f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterprojectcode'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await settotaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/d27999225b48e52e345ef309ca52ecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('53dbca2609b6bd1a57c2e6186feff784')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/805b1424ff4c7984cd22d47f36c26af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/2c992123dc3fb18eadd9cfb164c3da9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijderd',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'projectnaam')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('53dbca2609b6bd1a57c2e6186feff784'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53dbca2609b6bd1a57c2e6186feff784', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/486afa3e2b92de41b7e375562528915c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  } else {
    ___arguments.context.pageData['totaalbedrag'] = (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['Sum(totaalbedrag) as totaalbedrag']).setPageSize(10)));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/maandcontrole/components/51dac6cf10d9f8bfe2a470a86414d0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/fc9c7bdc852345b51f85c70574468b71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvMaandoverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvMaandoverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/maandoverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datumdeclaratie) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvMaandoverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export maandoverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export maandoverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/b5b5dd569c8cb5db962ee24e8b8c0f7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('66f178392d6c6346cfff015d5ff2bf7e')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = (getObjectProperty(___arguments.context.appData, 'projectnaam'));
  ___arguments.context.pageData['filterprojectcode'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandcontroleperproject/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ [`value`]: '%',[`label`]: 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'info': 'registratie komt van status OPNIEUW INGEDIEND','controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam, reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
      centranaam = '';
    }
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.appData, 'projectnaam')),'\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
      centranaam = '';
    }
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperproject/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/4d5ddb451ce7308120fe70b67c1c8fa5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'projectnaam'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/2112763a5fcdbb868be6530defee3a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63571b881632b9ae1d3a984e4841f39b')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/9d33c3c31a2c82348db51f02b50679c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/5164764708f7d296c6a826b42b031c52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijderd',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'projectnaam')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/623d3b158d7cd71348c23c05187f773c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperproject/components/48f6aa4fae6ae34581e42a79e5948229/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.print()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperproject/components/d50315858615a6d6a205fba6dec9dcce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvMaandoverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvMaandoverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/maandoverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datumdeclaratie) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvMaandoverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export maandoverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export maandoverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var listprojectcodes, listprojectleiders, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true)) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterprojectnaam'] = (getObjectProperty(___arguments.context.appData, 'projectnaam'));
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;
  listprojectleiders = (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND svprojectleider=\'1\'',' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('projectcode').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'projectcode'));})));
  listprojectcodes = listprojectleiders.join('\',\'');
  ___arguments.context.pageData['filterprojectcode'] = listprojectcodes;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ [`value`]: '%',[`label`]: 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'soort')),[`label`]: (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`maandakkoord`]: true,[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'NIET AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`controle`]: 'TE CONTROLEREN',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),[`info`]: 'registratie komt van status OPNIEUW INGEDIEND',[`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam, reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
      centranaam = '';
    }
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND projectcode LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == '') {
      centranaam = '';
    }
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: centranaam }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraaglorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`emaillorio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function set_totaal() {
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9712572eee52fc2c6c128957432a72e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))).setProperties(['sum(totaalbedrag) as totaalbedrag']).setPageSize(10))));
  }
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }
  await set_totaal();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/7be37698b18f850e0955c3a7b2e65fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ [`controle`]: 'AKKOORD',[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`controledatum`]: (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/4d5ddb451ce7308120fe70b67c1c8fa5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'projectnaam'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/99f7e3d87c940f6e20d5afdae0da3825/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/2112763a5fcdbb868be6530defee3a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63571b881632b9ae1d3a984e4841f39b')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/9d33c3c31a2c82348db51f02b50679c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/5164764708f7d296c6a826b42b031c52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijderd',[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'soort')),[`totaalbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'totaalbedrag')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamreg`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'projectnaam')) }) );
  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63571b881632b9ae1d3a984e4841f39b'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63571b881632b9ae1d3a984e4841f39b', false);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/623d3b158d7cd71348c23c05187f773c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/48f6aa4fae6ae34581e42a79e5948229/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.print()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontroleperprojectall/components/d50315858615a6d6a205fba6dec9dcce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvMaandoverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvMaandoverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportmnl/maandoverzichtmnl.csv','tableName': 'declaratiesmnl','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectcode')),'\') AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: 100000,[`properties`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'date(datumdeclaratie) as declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakjaar', 'aanmaakmaand', 'naam', 'organisatie', 'projectnaam', 'projectcode', 'declaratienummer', 'registratienummer', 'soort', 'omschrijving', 'declaratiedatum', 'bedragtotaal', 'kilometers', 'werkminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvMaandoverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Export-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export maandoverzichtmnl.csv'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export maandoverzichtmnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old() {
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcade9802d7c96164b8b6db4678b37d', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('856680a61949a83eb1a8478ed0e6ddec', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dabd8d3ebb0ee43cba91a3fdf7aede65', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8588789085cd90a69e1be433d4433a1', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7821334ce34251608bcc7e167da4901', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('000d043d25dc58130d99a66c50521fb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee4f6b3e2aacf228be1d842aa71ebbef', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandoverzichtakkoord').setGroupBy('maandoverzichtakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord'))];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord')) == 1) {
      ___arguments.context.pageData['maandoverzichtakkoord'] = 1;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/359deb7271c7ebc941874474de24a14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/25386f857648dae49aa8aff65f0ec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == true) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/58cd94c8d92e575ac13d5bc664ffa391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e61405f3e5e9e8d92f3a4a53b289d06d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/d05dde1c23aae976ac4d1711c99db218/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/8f465d5f56d41fd77d3bba4ad0fe1cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b042965597ab58d182efe49443d2bd4c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c46c49345d390b33f8f9fe4c18d43641/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/48abbe635c4cf09158ea9065bc590d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/06657ca945c2ad438fa409dbc9faed18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/574a0f155f748c53e9a5d71345bdf882/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/001baa1ff71bca787fcdf7f87e51e458/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/8af521110fc5173b5566a99943f30197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ca654e33a74a3908db4f71d17b9ba957/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9695d8b181662d02ba845776ecb88571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c415e9bfc50ea9780785b50471299bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af521110fc5173b5566a99943f30197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48abbe635c4cf09158ea9065bc590d1f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06657ca945c2ad438fa409dbc9faed18')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibantennamevan')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['height'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['minHeight'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['maxHeight'] = '800px';
    ___arguments.context.pageData['FACTGEGEVENS'] = false;
    ___arguments.context.pageData['INVOICE'] = true;
    ___arguments.context.pageData['VIEW'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/834cfcd4e27b987ed4466cb27c593dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9abccdb7d87b42cbc4bb37cfb854ad51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3ddf7cac281621eeec87c315dbb28265/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3ddf7cac281621eeec87c315dbb28265');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b47731d1e605fb51fdf28405747a1ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['factuurnummer'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/599b909b0142fe61127df516ca5aa6dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/bad1987b2381573e85b317378631dc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/d6a188e563f6175576de4a5e75b6920c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden';
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', true);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e2c7d3af12bd48437da63d9277863c51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ba7ddb4552c305c6680eedbd65c78f9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandselectie')) == null) {
    (function (message) { alert(message) })('U dient eerst de maand te selecteren voordat u een factuur kunt opmaken.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = true;
    ___arguments.context.pageData['INVOICE'] = false;
    ___arguments.context.pageData['VIEW'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );
    ___arguments.context.pageData['factuurnummer'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ee4f6b3e2aacf228be1d842aa71ebbef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4b7567447f9b3be56a0665b624bf5b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/75c5ac622d5cc511a516b85e60fe2ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c282864d56ae9c0deab4c11c45030f34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/c9f44db226bdc6075caf9be4b624a3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/856680a61949a83eb1a8478ed0e6ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/867f80439271706f4c38747f74e32807/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/19268d5a5e45e69ab975babf7255e60c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/20f94af482ce9eaad4a9ae69e85db016/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/dabd8d3ebb0ee43cba91a3fdf7aede65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f8588789085cd90a69e1be433d4433a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f60110ecc74a0b3900ec9f441b1788cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/00cdebe9218bf81f09b1d1a51e9cd5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/02983e0d981f7ea188c949a271a57b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/cec2199ea578d4ed6459a3eedfaf189e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/25e52648735f9c7e98f1489fd55f7494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/41a53d86c856ad58bf5ea9c1f5222536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/0b9c8c47c406e83f52eb9359a3fd3d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/badb3f656a8a7fd56386d09b2ad46bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/ac3f7ac990412e6180e7cdfc72bb1873/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/3c6165cc9fc58db9a8bd37ac7adc5a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/2ad7d6761a49863a5bf64e1344af8cc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/27d4a246726986a6f17f71d9e09af14d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/87c52c0a4c99c82d2284258187d78d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/cda805e96a4ee3c50c85680da80bbf76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/976772f92cc2d68425fbaea25faebad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/0e8afd19f12810ba276e84cb384a1da9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a1bd29c69e75275bd02fe75a55241405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/4a5e280b93e5e642db1cc474b445e332/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/218b3c72e071026c6ea43f1e107876c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/a7821334ce34251608bcc7e167da4901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/000d043d25dc58130d99a66c50521fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f3ba7b33a19bd1ccaabe689c90cac138/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/7bcade9802d7c96164b8b6db4678b37d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcade9802d7c96164b8b6db4678b37d', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/f008273864d81c650fa85c3412f96a0a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selfbilling'] = (getObjectProperty(___arguments.context.dataModel, 'selfbilling'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/1f1f925d9c7cfecc4125808f27bc4898/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2/components/e034686def628f7648db17434586c506/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selfbilling')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('856680a61949a83eb1a8478ed0e6ddec', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dabd8d3ebb0ee43cba91a3fdf7aede65', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd coördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8588789085cd90a69e1be433d4433a1', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7821334ce34251608bcc7e167da4901', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('000d043d25dc58130d99a66c50521fb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuutmaandoverzicht', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('tariefperminuutmaandoverzicht ASC').setGroupBy('tariefperminuutmaandoverzicht').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee4f6b3e2aacf228be1d842aa71ebbef', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setSortBy('tariefperkm ASC').setGroupBy('tariefperkm').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandoverzichtakkoord').setGroupBy('maandoverzichtakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord'))];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord')) == 1) {
      ___arguments.context.pageData['maandoverzichtakkoord'] = 1;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/359deb7271c7ebc941874474de24a14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/25386f857648dae49aa8aff65f0ec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == true) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/58cd94c8d92e575ac13d5bc664ffa391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e61405f3e5e9e8d92f3a4a53b289d06d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/d05dde1c23aae976ac4d1711c99db218/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/8f465d5f56d41fd77d3bba4ad0fe1cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b042965597ab58d182efe49443d2bd4c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c46c49345d390b33f8f9fe4c18d43641/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/48abbe635c4cf09158ea9065bc590d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/06657ca945c2ad438fa409dbc9faed18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/574a0f155f748c53e9a5d71345bdf882/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/001baa1ff71bca787fcdf7f87e51e458/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/8af521110fc5173b5566a99943f30197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ca654e33a74a3908db4f71d17b9ba957/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9695d8b181662d02ba845776ecb88571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c415e9bfc50ea9780785b50471299bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af521110fc5173b5566a99943f30197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48abbe635c4cf09158ea9065bc590d1f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06657ca945c2ad438fa409dbc9faed18')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibantennamevan')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['height'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['minHeight'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['maxHeight'] = '800px';
    ___arguments.context.pageData['FACTGEGEVENS'] = false;
    ___arguments.context.pageData['INVOICE'] = true;
    ___arguments.context.pageData['VIEW'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/834cfcd4e27b987ed4466cb27c593dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9abccdb7d87b42cbc4bb37cfb854ad51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3ddf7cac281621eeec87c315dbb28265/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3ddf7cac281621eeec87c315dbb28265');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b47731d1e605fb51fdf28405747a1ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['factuurnummer'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/599b909b0142fe61127df516ca5aa6dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/bad1987b2381573e85b317378631dc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/d6a188e563f6175576de4a5e75b6920c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', true);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e2c7d3af12bd48437da63d9277863c51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ba7ddb4552c305c6680eedbd65c78f9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandselectie')) == null) {
    (function (message) { alert(message) })('U dient eerst de maand te selecteren voordat u een factuur kunt opmaken.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = true;
    ___arguments.context.pageData['INVOICE'] = false;
    ___arguments.context.pageData['VIEW'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`factuurnummer`]: null }) );
    ___arguments.context.pageData['factuurnummer'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ee4f6b3e2aacf228be1d842aa71ebbef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4b7567447f9b3be56a0665b624bf5b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/75c5ac622d5cc511a516b85e60fe2ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c282864d56ae9c0deab4c11c45030f34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/c9f44db226bdc6075caf9be4b624a3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7567447f9b3be56a0665b624bf5b9d'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/856680a61949a83eb1a8478ed0e6ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/867f80439271706f4c38747f74e32807/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/19268d5a5e45e69ab975babf7255e60c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/20f94af482ce9eaad4a9ae69e85db016/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f60110ecc74a0b3900ec9f441b1788cf'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/dabd8d3ebb0ee43cba91a3fdf7aede65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f8588789085cd90a69e1be433d4433a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f60110ecc74a0b3900ec9f441b1788cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/00cdebe9218bf81f09b1d1a51e9cd5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/02983e0d981f7ea188c949a271a57b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/cec2199ea578d4ed6459a3eedfaf189e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/25e52648735f9c7e98f1489fd55f7494/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/41a53d86c856ad58bf5ea9c1f5222536/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/0b9c8c47c406e83f52eb9359a3fd3d74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/badb3f656a8a7fd56386d09b2ad46bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/ac3f7ac990412e6180e7cdfc72bb1873/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'tariefperminuutmaandoverzicht')) * 60;

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(euro))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/3c6165cc9fc58db9a8bd37ac7adc5a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/2ad7d6761a49863a5bf64e1344af8cc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/27d4a246726986a6f17f71d9e09af14d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/87c52c0a4c99c82d2284258187d78d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/cda805e96a4ee3c50c85680da80bbf76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/976772f92cc2d68425fbaea25faebad4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02983e0d981f7ea188c949a271a57b4f'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/0e8afd19f12810ba276e84cb384a1da9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cec2199ea578d4ed6459a3eedfaf189e'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a1bd29c69e75275bd02fe75a55241405/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/4a5e280b93e5e642db1cc474b445e332/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25e52648735f9c7e98f1489fd55f7494'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/218b3c72e071026c6ea43f1e107876c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('00cdebe9218bf81f09b1d1a51e9cd5cd'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/a7821334ce34251608bcc7e167da4901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/000d043d25dc58130d99a66c50521fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht_v2_backup05022026/components/f3ba7b33a19bd1ccaabe689c90cac138/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  ___arguments.context.pageData['SOURCE'] = (['https://cvl-mnl.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98b9e3b4e9dbd936e86481c92eed0eb4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd bestuurslid','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a43976777081f9d6a19378afa97339f4', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd çoördinator','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c252c5921ab7eecc6134cd98fe697561', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd teamcoördinator','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('00d650d94f2ef1a874e2288e6bd71822', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd geestelijk verzorger','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7cc6c021a7fd52bb88eca52f255d894', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Werktijd projectleider','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tariefperminuut', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort ASC').setGroupBy('tariefperminuut').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Materiële kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('549d660c4df768435354f2ebf6f62f0b', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Administratie kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cb76b6d78214f58ec862b5848fc77b7', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','IT kosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7bcf2565e5bbc5c4790ee068891a6bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Kosten derden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32620b08963b7abc652db33d847598e8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vrijwilligersvergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setSortBy('soort ASC').setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Kilometervergoeding','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefperkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','OV/parkeerkosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddaa158c7115ed063bb79bb71495e585', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Locatiekosten','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setGroupBy('bedragbtw').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aead5041be515d2ac88dc7d7bf849563', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'','Vaste vacatiegelden','\' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde', 'Sum(bedragtotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=0'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=9'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39ed3b0abdfad9f572fb2966984e2e2f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragbtw=21'].join(''))).setProperties(['Sum(bedragexbtw) as bedragexbtw', 'Sum(bedragbtwwaarde) as bedragbtwwaarde']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandoverzichtakkoord').setGroupBy('maandoverzichtakkoord').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('aanmaakmaand DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefperkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord'))];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord')) == 1) {
      ___arguments.context.pageData['maandoverzichtakkoord'] = 1;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/359deb7271c7ebc941874474de24a14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/25386f857648dae49aa8aff65f0ec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == true) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/58cd94c8d92e575ac13d5bc664ffa391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e61405f3e5e9e8d92f3a4a53b289d06d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/d05dde1c23aae976ac4d1711c99db218/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/8f465d5f56d41fd77d3bba4ad0fe1cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b042965597ab58d182efe49443d2bd4c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/c46c49345d390b33f8f9fe4c18d43641/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/48abbe635c4cf09158ea9065bc590d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/06657ca945c2ad438fa409dbc9faed18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/574a0f155f748c53e9a5d71345bdf882/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/001baa1ff71bca787fcdf7f87e51e458/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/8af521110fc5173b5566a99943f30197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ca654e33a74a3908db4f71d17b9ba957/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9695d8b181662d02ba845776ecb88571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/c415e9bfc50ea9780785b50471299bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af521110fc5173b5566a99943f30197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48abbe635c4cf09158ea9065bc590d1f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06657ca945c2ad438fa409dbc9faed18')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibantennamevan')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['height'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['minHeight'] = '800px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['maxHeight'] = '800px';
    ___arguments.context.pageData['FACTGEGEVENS'] = false;
    ___arguments.context.pageData['INVOICE'] = true;
    ___arguments.context.pageData['VIEW'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/834cfcd4e27b987ed4466cb27c593dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw9'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.pageData, 'inclbedragbtw9'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9abccdb7d87b42cbc4bb37cfb854ad51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl-mnl.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/3ddf7cac281621eeec87c315dbb28265/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b47731d1e605fb51fdf28405747a1ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['factuurnummer'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/599b909b0142fe61127df516ca5aa6dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/bad1987b2381573e85b317378631dc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/d6a188e563f6175576de4a5e75b6920c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', true);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e2c7d3af12bd48437da63d9277863c51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ba7ddb4552c305c6680eedbd65c78f9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandselectie')) == null) {
    (function (message) { alert(message) })('U dient eerst de maand te selecteren voordat u een factuur kunt opmaken.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = true;
    ___arguments.context.pageData['INVOICE'] = false;
    ___arguments.context.pageData['VIEW'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );
    ___arguments.context.pageData['factuurnummer'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/3ddc48d42722a35b763df8e923894a79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4881845bae951bbc3d3c68e68e6880c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9eb2ce0fefcf75ef78c567fc842667d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/088f62f3c7b38b7157949d6950392d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/5a0d5b471e8e6243fd9351a226bbdc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/1c09cdce829c7701e5ad19775a72f63d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/dac8c2d35c1c1642a8eeef68395d9084/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/457f5f6b1394f2faf80156f1993ba9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw21')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/6c567772ee692cb3405376d669e9599e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/3cf5e52ca9029d32c33695adc25d2a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/20e80c2b9924062246f897a17bae50df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/c4dfc2b7bdc7f8531a5585f5f68af01b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/98b9e3b4e9dbd936e86481c92eed0eb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a43976777081f9d6a19378afa97339f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/7504c6f90e196702482d218a20a2a797/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/fed1c6453d3f8a6275a1a31c4cccd7a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a6ade1c34eadda76dc6320dc2be27509/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/fa79bb8ebbc927c9a3190f9b0dd59c27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/c252c5921ab7eecc6134cd98fe697561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/00d650d94f2ef1a874e2288e6bd71822/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ddaa158c7115ed063bb79bb71495e585/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/aead5041be515d2ac88dc7d7bf849563/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/0fcc56ff9dd3abcad5381bd605c15cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/093c5fb7f10a45099c3a5a1444e432e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9d8ad8af6b58405c5feb699b8332b5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b863032715983366c7a200960bb39b99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/11c591094f09a22cb7dc21192ca60e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/ec4a46dfa9b88e1ea2f5419209cac795/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093c5fb7f10a45099c3a5a1444e432e2'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/dc5c0639a06c9bd99d2ddd1428db242d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d8ad8af6b58405c5feb699b8332b5f4'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/f4b52a6bf5f669ed9339c66dd996fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fa79bb8ebbc927c9a3190f9b0dd59c27'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/3b89e9c3a8fd591628dea1994268edb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a6ade1c34eadda76dc6320dc2be27509'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/4e541bbedb43e221035b154bfe64c3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9d52ff874f475a4c700e1ccb5a499abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7504c6f90e196702482d218a20a2a797'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e97d376a443ca2b6c869a635472dc4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw21'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtwwaarde'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/26c4260b50918df103f8d9b83a0b979b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/bea72832f0a88866541d927b627efb25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3dceefd300064edb7a88f4de996d157c'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/6b9bec3cc1a5820abf2a0b7e937ab82f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b9bec3cc1a5820abf2a0b7e937ab82f', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats ASC').setGroupBy('kostenplaats').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/e7cc6c021a7fd52bb88eca52f255d894/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/10a7f0cdc4c729abb3cfc6887fd6ad4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/9f4b47a71488c833a273ecdc817480a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/24b25d5b37991b7413e5721a5138fa08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2297a1f15749725e6c84e565c2ff98f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'werkminutenexbtw'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/32620b08963b7abc652db33d847598e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/6bc73fda12b9014b09ef296d6de6d7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/8673223d3f4ace01237763222594d5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b0f342ba67f59993c36b341769cde0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bc73fda12b9014b09ef296d6de6d7a1'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/549d660c4df768435354f2ebf6f62f0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/2cb76b6d78214f58ec862b5848fc77b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/bd57674e65cade7cb745957174f6649c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/c44510664812d25fe711effc924fcb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/70a6d0786d687af4ba775e8b0b775d47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/78f3542f29b8b4cd93d2766ca071743d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/f4de326eae11e5f7e2b1321bb52f667f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bd57674e65cade7cb745957174f6649c'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/3f272313fc7428e32e054117b2a20365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c44510664812d25fe711effc924fcb5a'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/7bcf2565e5bbc5c4790ee068891a6bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/6d6a4b69724c28df7743b55c3968bdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/b404ae86124155b3424c48fde9a6618b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == null) {
    text = '0%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 9) {
    text = '9%';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragbtw')) == 21) {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/928680491b6ee0e38a94e8c5ca6f1c28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6d6a4b69724c28df7743b55c3968bdbc'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/a44b883ef00133eb06feb5c9c96321a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fed1c6453d3f8a6275a1a31c4cccd7a2'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/36a13bf13453ad9fca5f00a4356e10a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('10a7f0cdc4c729abb3cfc6887fd6ad4d'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtlorio/components/1165ca8cc38be077e5b2959c501e8ee2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('username').setSortBy('username DESC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['username'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mailsversturen/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mailsversturen/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mailsversturen/components/46fd706be85c360dba93a7bd58abf674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Drechtsteden') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserdrechtstedengv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserlimburggv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Questio') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserquestiogv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Rotterdam') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserrotterdamgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserutrechtgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserwillemgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'PL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserpl', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  }
  (function (message) { alert(message) })('De email is verzonden');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/mailsversturen/components/a5f2894760c25477d98149be945e217d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'centraname')),'label': (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mailsversturen/components/7671de5e224e3a37f7fc464d67c2a03d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND userStatus = \'ENABLED\''].join(''))).setProperties('username').setSortBy('username DESC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('428a94dc344d207d80f18564426c60cf', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mailsversturen/components/99be46479d8a7ab7c4faeeebe38b3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailmnl', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Midden Nederland is verzonden');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/mailsversturen/components/7df41258017331085d290d69b2072f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Utrecht','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcc'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mailsversturen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndeclaraties/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tarievenitkosten, tarievenadministratiekosten, tarievenvastevacatiegelden, tarievenkm, tarievenovparkeerkosten, tarievenvrijwilligersvergoeding, tarievenmaterielekosten, tarievenlocatiekosten, tarievenwerktijdpl, tarievenwerktijdtc, tarievenwerktijdgv, tarievenwerktijdco, tarievenwerktijdbl, tarievenkostenderden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loadmax() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    tarievenwerktijdbl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd bestuurslid','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdbl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdbl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdbl'] = (getObjectProperty(tarievenwerktijdbl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    tarievenwerktijdco = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd coördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdco => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdco, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdco'] = (getObjectProperty(tarievenwerktijdco, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    tarievenwerktijdgv = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd geestelijk verzorger','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdgv => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdgv, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdgv'] = (getObjectProperty(tarievenwerktijdgv, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    tarievenwerktijdtc = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd teamcoördinator','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdtc => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdtc, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdtc'] = (getObjectProperty(tarievenwerktijdtc, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    tarievenwerktijdpl = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Werktijd projectleider','\''].join(''))).setProperties(['maxaantal']).setPageSize(1))).map(async tarievenwerktijdpl => {; return ({ 'maxaantal': (getObjectProperty(tarievenwerktijdpl, 'maxaantal')) });})))[0];
    ___arguments.context.pageData['maxwerktijdpl'] = (getObjectProperty(tarievenwerktijdpl, 'maxaantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    tarievenlocatiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Locatiekosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenlocatiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenlocatiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenlocatiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxlocatiekosten'] = (getObjectProperty(tarievenlocatiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    tarievenmaterielekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Materiële kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenmaterielekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenmaterielekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenmaterielekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxmaterielekosten'] = (getObjectProperty(tarievenmaterielekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    tarievenvrijwilligersvergoeding = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vrijwilligersvergoeding','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenvrijwilligersvergoeding => {; return ({ 'maxbedrag': (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenvrijwilligersvergoeding, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxvrijwilligersvergoeding'] = (getObjectProperty(tarievenvrijwilligersvergoeding, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    tarievenovparkeerkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','OV/Parkeerkosten','\''].join(''))).setProperties(['maxbedrag', 'informatietekst']).setPageSize(10))).map(async tarievenovparkeerkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenovparkeerkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'maxbedrag'));
    ___arguments.context.pageData['informatieovparkeerkosten'] = (getObjectProperty(tarievenovparkeerkosten, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    tarievenkm = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kilometervergoeding','\''].join(''))).setProperties(['informatietekst', 'maxaantal']).setPageSize(1))).map(async tarievenkm => {; return ({ 'maxaantal': (getObjectProperty(tarievenkm, 'maxaantal')),'informatietekst': (getObjectProperty(tarievenkm, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkilometervergoeding'] = (getObjectProperty(tarievenkm, 'maxaantal'));
    ___arguments.context.pageData['informatiekilometervergoeding'] = (getObjectProperty(tarievenkm, 'informatietekst'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'vacatiegeldenbedrag') {
    tarievenvastevacatiegelden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Vaste vacatiegelden','\''].join(''))).setProperties(['vacatiegeldenbedrag']).setPageSize(1))).map(async tarievenvastevacatiegelden => {; return ({ 'kostenplaats': (getObjectProperty(tarievenvastevacatiegelden, 'kostenplaats')),'tariefperkm': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperkm')),'tariefperminuut': (getObjectProperty(tarievenvastevacatiegelden, 'tariefperminuut')),'vacatiegeldenbedrag': (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag')) });})))[0];
    ___arguments.context.pageData['vacatiegeldenbedrag'] = (getObjectProperty(tarievenvastevacatiegelden, 'vacatiegeldenbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    tarievenadministratiekosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Administratie kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenadministratiekosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenadministratiekosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenadministratiekosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxadministratiekosten'] = (getObjectProperty(tarievenadministratiekosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    tarievenitkosten = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','IT kosten','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenitkosten => {; return ({ 'maxbedrag': (getObjectProperty(tarievenitkosten, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenitkosten, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxitkosten'] = (getObjectProperty(tarievenitkosten, 'maxbedrag'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    tarievenkostenderden = (await Promise.all((await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'projectcode')),'\' AND soort=\'','Kosten derden','\''].join(''))).setProperties(['informatietekst', 'maxbedrag']).setPageSize(1))).map(async tarievenkostenderden => {; return ({ 'maxbedrag': (getObjectProperty(tarievenkostenderden, 'maxbedrag')),'informatietekst': (getObjectProperty(tarievenkostenderden, 'informatietekst')) });})))[0];
    ___arguments.context.pageData['maxkostenderden'] = (getObjectProperty(tarievenkostenderden, 'maxbedrag'));
  }
}


  ___arguments.context.pageData['pageoffset'] = 0;
  await loadmax();
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? false : true))))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider' ? true : false))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd bestuurslid') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdbl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd geestelijk verzorger') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdgv'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdco'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd teamcoördinator') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdtc'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) > (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))) {
      (function (message) { alert(message) })((String('De maximale aantal werkminuten die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['werkminuten'] = (getObjectProperty(___arguments.context.pageData, 'maxwerktijdpl'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kilometervergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'reistijd')) == 'Ja') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) > (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale aantal kilometers die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['kilometers'] = (getObjectProperty(___arguments.context.pageData, 'maxkilometervergoeding'));
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? true : false))))))) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxvrijwilligersvergoeding'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))) {
      (function (message) { alert(message) })((String('Het maximale bedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxkostenderden'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijndeclaraties/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaratiesmnl'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var target;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    target = String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  } else {
    target = ['kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))].join('');
  }

  return target

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht') {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  } else {
    ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));
  }

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/mijndeclaraties/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaratiesmnl').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['filterprojectnaam'] = '%';
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'change': false }) );
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndeclaraties/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;
    	
    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);
    	
    	} else {
    	   result = '€ 0,00';
    	}
    	
    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Kosten derden' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Vrijwilligersvergoeding' ? false : true))))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijndeclaraties/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/b8abb0b929925621d74834d7f84ba81e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#e0ab0d';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'REEDS BETAALD') {
    label = 'reeds betaald';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#3B83BD';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/61fb7db6d2c2cabad2d63507fe829a43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'maandakkoord')) == true) {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ [`change`]: false,[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'OPNIEUW INGEDIEND',[`maandakkoord`]: false }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'OPNIEUW INGEDIEND',[`maandakkoord`]: false,[`activiteitdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  } else {
    await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ [`change`]: false,[`controle`]: 'OPNIEUW INGEDIEND' }) );
    await Backendless.Data.of('historiestatus').save( ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'registratienummer')),[`aanmaakdatumaanpassing`]: (new Date()),[`controle`]: 'OPNIEUW INGEDIEND',[`maandakkoord`]: false,[`activiteitdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/d10e4d172897ca2c4a1202a11bf8e7a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'change')) == true && (getObjectProperty(___arguments.context.dataModel, 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/938d30edda12673e1914c67b903b01f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/072cdd11d74fc821eaaec9eeea9e4c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['filterprojectnaam'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\'','AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijndeclaraties/components/6a3b7b69cd95019f9bd477f7a8f8e834/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'controle')),[`label`]: (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/f6e4eabb330a00e398e11533c36211b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\' AND ','controle LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'%\''].join(''))).setProperties('aanmaakmaand').setSortBy('aanmaakmaand ASC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/e0cec201524fc0b9ce5edc2378694b59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/00b628d698e515548e1c9525c73db767/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/28c1e187a48a63d75ba160d481b41918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));
  }
  await Backendless.Data.of('declaratiesmnl').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/d229ab1a613e24df18a57658f639f02b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/4b7573b6cbec91dba72267cd5bca7c6d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/b83ccfd16786e118f5b4582fbd5e6b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/cd5d87bd5b35e2a45236ab126f53f583/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/44364fe1aa4311949a34c6e5ad3f5637/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('projectnaam').setSortBy('projectnaam ASC').setGroupBy('projectnaam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectnaam')),[`label`]: (getObjectProperty(item, 'projectnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/2dcfb25c7d18e1293ad219a9c46ed3c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterprojectnaam'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND projectnaam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterprojectnaam')),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/0acb77bc8c41398696b3eaf765fac8f4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Locatiekosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxlocatiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'OV/Parkeerkosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxovparkeerkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Materiële kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxmaterielekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Administratie kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxadministratiekosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'IT kosten') {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragbtw')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragexbtw')) > (getObjectProperty(___arguments.context.pageData, 'maxitkosten'))) {
      (function (message) { alert(message) })((String('Het maximale totaalbedrag dat u kunt invoeren is ') + String(getObjectProperty(___arguments.context.pageData, 'maxitkosten'))));
      ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac')['bedragexbtw'] = null;
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    } else {
      await Backendless.Data.of('declaratiesmnl').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijndeclaraties/components/2a437df6e14f3602a0f5c44735c3136d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/24448b06c05c53a4a4c7f366d736403e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail. ');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 5000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/b7cd3465433ff6d941452d0458e2f0c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['SOURCE'] = (['https://cvl-mnl.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('509b2e9dd3b1166801d5a401f6da6fa8', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('509b2e9dd3b1166801d5a401f6da6fa8', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/mijngegevens/components/b92e094af901585b56f3f9fd132ba2d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/7b8304e6917e23cb12d74c36de2937ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/57eb1fc20f61cc7f8d5fc9fe37b56a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/5b2a824695749c17cb4da796cdfcecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/f5596b12de2bd03f1ed94a43ef1138dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/b9e397841257984168dc6c1a7ab76233/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/7d73f29d80a26b6bd2111ed7fc691dec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/063ece8f772e6a616a93505b32876d41/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/e742c20af8e7be2c949fc7cce63de0f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cb3361e47f5d58d4a0393f6576ddf21e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/41f16b1452a54d78b0af28fa346e0a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9e8b61cef3f8c07db3a96d2191def80a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/559f1d3b394db28f7bbeea2dcb3d36ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/mijngegevens/components/20c3c9c216c24da6ed187defb2748946/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/9d5e92a96cb93068a3d8adb8ebf42a47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/0615cc02759c0e385f887b013f75e7d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/775c7a8524f6b7aa3e0a745113347624/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/e1b2361f380fa0f43b57b24a36c8d8d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/1498c05285229e9f85b1b144c4467e7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/b86dc28e0161d1b5fe47bdad6aac2dce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/2b374b0d9324ca9aff383d5ce4a27eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/ce94f5ec657f422b62bdc2afb8811529/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwinclconsulten')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/f49f5972c5e5991606ced5df25e506bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwinclscholing')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if (!((await Backendless.UserService.getUserRoles()).includes('gebruiker'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(((await Backendless.UserService.getUserRoles()).includes('gebruiker')) || ((await Backendless.UserService.getUserRoles()).includes('beheerder')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
}


  if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  await Backendless.Data.of('newuserrequests').bulkUpdate( 'objectId is not null', ({ [`aanmaken`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/permissions/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/4a67327458c19016e76ef8c6c29d9487/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('centra').setSortBy('centra ASC').setGroupBy('centra').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centra')),[`label`]: (getObjectProperty(item, 'centra')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['username'] = null;
  ___arguments.context.pageData['hospice'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/6bffa1831d56fc9d986bf61b85b50b14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, j, declaratieslist, declaraties, userslist, users, gegevenslist, gegevens, gebruikersbeheerlist, gebruikersbeheer, userslist2, users2, centralist, centra;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in projectleiderslist) {
        m = projectleiderslist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaratiesmnl uitgevoerd');
  (function (message) { alert(message) })('permissions declaratiesmnl uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'facturatieadresgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index2 in declaratieslist) {
      k = declaratieslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index2 in beheerderslist) {
        l = beheerderslist[l_index2];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions facturatieadresgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index3 in gegevenslist) {
      k = gegevenslist[k_index3];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions factuurgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','properties': ['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'email', 'userStatus', 'lastLogin', 'objectId', 'viewprojectenblock'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index4 in userslist) {
    j = userslist[j_index4];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`centra`]: (getObjectProperty(j, 'centra')),[`username`]: (getObjectProperty(j, 'username')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`rol`]: (getObjectProperty(j, 'rol')),[`team`]: (getObjectProperty(j, 'team')),[`email`]: (getObjectProperty(j, 'email')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`viewprojectenblock`]: (getObjectProperty(j, 'viewprojectenblock')) }) );
  }
  centra = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\''].join('')),'groupBy': 'centra','properties': ['centra'] }));
  centralist = (await Promise.all(centra.map(async item => {; return (getObjectProperty(item, 'centra'));})));
  for (var k_index4 in centralist) {
    k = centralist[k_index4];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',k,'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',k,'\' AND viewprojectenblock = TRUE'].join('')) }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index3 in userslist2) {
      l = userslist2[l_index3];
      gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',k,'\''].join('')) }));
      gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index2 in gebruikersbeheerlist) {
        m = gebruikersbeheerlist[m_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
      }
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
  (function (message) { alert(message) })('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND userStatus=\'ENABLED\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
  (function (message) { alert(message) })('permissions users uitgevoerd');
}

/**
 * Describe this function...
 */
async function projectfinanciering() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectfinanciering','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['projectcode', 'objectId'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`projectcode`]: (getObjectProperty(item, 'projectcode')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  console.log(String('gegevenslist: ') + String(gegevenslist));
  for (var j_index5 in gegevenslist) {
    j = gegevenslist[j_index5];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var k_index5 in beheerderslist) {
      k = beheerderslist[k_index5];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index5 in projectleiderslist) {
      l = projectleiderslist[l_index5];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  if (false) {
    console.log('permissions projectfinanciering uitgevoerd');
    (function (message) { alert(message) })('permissions projectfinanciering uitgevoerd');
  }
}

/**
 * Describe this function...
 */
async function projectgegevens() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
  for (var j_index6 in gegevenslist) {
    j = gegevenslist[j_index6];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index6 in userslist) {
      k = userslist[k_index6];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index6 in beheerderslist) {
      l = beheerderslist[l_index6];
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index3 in projectleiderslist) {
      m = projectleiderslist[m_index3];
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projectgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions projectgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function projecttarieven() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttarieven','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
  for (var j_index7 in gegevenslist) {
    j = gegevenslist[j_index7];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index7 in userslist) {
      k = userslist[k_index7];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index7 in beheerderslist) {
      l = beheerderslist[l_index7];
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index4 in projectleiderslist) {
      m = projectleiderslist[m_index4];
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttarieven uitgevoerd');
  (function (message) { alert(message) })('permissions projecttarieven uitgevoerd');
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index8 in gegevenslist) {
    j = gegevenslist[j_index8];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index8 in userslist) {
      k = userslist[k_index8];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index8 in beheerderslist) {
      l = beheerderslist[l_index8];
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index5 in projectleiderslist) {
      m = projectleiderslist[m_index5];
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttarieven uitgevoerd');
  (function (message) { alert(message) })('permissions projecttarieven uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionfiles() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index9 in userslist) {
    j = userslist[j_index9];
    await Backendless.Files.Permissions.READ.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    await Backendless.Files.Permissions.DELETE.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    await Backendless.Files.Permissions.WRITE.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND viewprojectenblock = TRUE'].join('')),'properties': ['objectId'] }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index9 in userslist2) {
      k = userslist2[k_index9];
      await Backendless.Files.Permissions.READ.grantForUser(k, (String('kopiescan') + String(getObjectProperty(___arguments.context.pageData, 'centra'))));
    }
  }
  console.log('permissions files uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index10 in userslist) {
    j = userslist[j_index10];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'maandafsluiten','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index10 in declaratieslist) {
      k = declaratieslist[k_index10];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await permissionsdeclaratiesmnl();
    await permissionsfacturatieadresgegevens();
    await permissionsfactuurgegevens();
    await permissionsgebruikersbeheer();
    await permissionsusers();
    await projectfinanciering();
    await projectgegevens();
    await projecttarieven();
    await projecttoestemmingen();
    await permissionfiles();
    (function (message) { alert(message) })('Permissions zijn toegekend voor centra in alle tabellen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/67f403196da705f23d86dfac2267d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Selecteer naam');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Selecteer email');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == null) {
    (function (message) { alert(message) })('Selecteer rol');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
      centranaam = 'Midden Nederland';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Drechtsteden') {
      centranaam = 'Drechtsteden';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Brabant') {
      centranaam = 'Midden- & Oost- Brabant';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
      centranaam = 'Gelderland';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Haaglanden') {
      centranaam = 'Haagsche-Zin';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
      centranaam = 'Limburg';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
      centranaam = 'Overijssel';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Questio') {
      centranaam = 'Questio';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Rotterdam') {
      centranaam = 'Rotterdam & omstreken';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Sichtpunt') {
      centranaam = 'Sichtpunt';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
      centranaam = 'Willem';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZHN') {
      centranaam = 'Zuid-Holland Noord';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Zinvol') {
      centranaam = 'Zinvol';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
      centranaam = 'Zuid West Nederland';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Groningen') {
      centranaam = 'Coöperatie NvL';
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'VSCL') {
      centranaam = 'VSCL';
    }
    if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'gebruiker') {
      await Backendless.Messaging.sendEmailFromTemplate('newusergebruiker', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`centranaam`]: centranaam,[`verzender`]: 'Lorio' }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserbeheerder', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`centranaam`]: centranaam,[`verzender`]: 'Lorio' }), undefined);
    }
    await Backendless.Messaging.sendEmailFromTemplate('newuseraangemaakt', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`centranaam`]: centranaam }), undefined);
    (function (message) { alert(message) })('De inloggegevens zijn verzonden naar de nieuwe user en de aanvrager heeft bevestiging ontvangen via mail.');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3c46bf080591e52937d1171cdf247b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.REMOVE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in projectleiderslist) {
        m = projectleiderslist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.REMOVE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaratiesmnl uitgevoerd');
  (function (message) { alert(message) })('permissions declaratiesmnl uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsdeclaratiesmnl();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/d35d2ecc5053f5d217e97dd6aa67a7fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, k, userslist2, users2, centralist, centra, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','properties': ['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'email', 'userStatus', 'lastLogin', 'objectId', 'viewprojectenblock'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`centra`]: (getObjectProperty(j, 'centra')),[`username`]: (getObjectProperty(j, 'username')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`rol`]: (getObjectProperty(j, 'rol')),[`team`]: (getObjectProperty(j, 'team')),[`email`]: (getObjectProperty(j, 'email')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`viewprojectenblock`]: (getObjectProperty(j, 'viewprojectenblock')) }) );
  }
  centra = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\''].join('')),'groupBy': 'centra','properties': ['centra'] }));
  centralist = (await Promise.all(centra.map(async item => {; return (getObjectProperty(item, 'centra'));})));
  for (var k_index in centralist) {
    k = centralist[k_index];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',k,'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',k,'\' AND viewprojectenblock = TRUE'].join('')) }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in userslist2) {
      l = userslist2[l_index];
      gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',k,'\''].join('')) }));
      gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index in gebruikersbeheerlist) {
        m = gebruikersbeheerlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
      }
    }
  }
  for (var k_index2 in centralist) {
    k = centralist[k_index2];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',k,'\''].join('')) }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index2 in userslist2) {
      l = userslist2[l_index2];
      gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',k,'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',k,'\' AND viewprojectenblock = TRUE'].join('')) }));
      gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index2 in gebruikersbeheerlist) {
        m = gebruikersbeheerlist[m_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
      }
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
  (function (message) { alert(message) })('permissions gebruikersbeheer uitgevoerd');
}


  await permissionsgebruikersbeheer();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a68db61433b22daeb3e3c9beb0d3c9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND userStatus=\'ENABLED\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
  (function (message) { alert(message) })('permissions users uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsusers();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/06afe53f20dd88c4c8a3fa47993e261e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, j, projectleiderslist, item, projectleiders, k, beheerderslist, beheerders, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projectfinanciering() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectfinanciering','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['projectcode', 'objectId'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`projectcode`]: (getObjectProperty(item, 'projectcode')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  console.log(String('gegevenslist: ') + String(gegevenslist));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in beheerderslist) {
      k = beheerderslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(k, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in projectleiderslist) {
      l = projectleiderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projectfinanciering uitgevoerd');
  (function (message) { alert(message) })('permissions projectfinanciering uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projectfinanciering();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a82c20491441c4b947942eddaf1c1456/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, j, declaratieslist, declaraties, userslist, users, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projectgegevens() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index in projectleiderslist) {
      m = projectleiderslist[m_index];
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projectgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions projectgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function projectgegevens2() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index2 in declaratieslist) {
      k = declaratieslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index2 in beheerderslist) {
        l = beheerderslist[l_index2];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index2 in projectleiderslist) {
        m = projectleiderslist[m_index2];
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions projectgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions projectgegevens uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projectgegevens();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/bfb66cb2f42e8afcf5b28649842d0c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newuser, m, k, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, j, declaratieslist, declaraties, userslist, users, gegevenslist, gegevens, gebruikersbeheerlist, gebruikersbeheer, userslist2, users2, centralist, centra;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function instellen_permissions() {
  await permissionsgebruikersbeheer();
  await permissionsdeclaratiesmnl();
  await permissionsfacturatieadresgegevens();
  await permissionsfactuurgegevens();
  await permissionsusers();
  await projectgegevens();
  await projecttarieven();
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
    await permissionsmaandafsluiten();
    await projectfinanciering();
    await projecttoestemmingen();
    await permissionsdeclaratiesmnlbeheerders();
  }
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in projectleiderslist) {
        m = projectleiderslist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaratiesmnl uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'facturatieadresgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index2 in declaratieslist) {
      k = declaratieslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index2 in beheerderslist) {
        l = beheerderslist[l_index2];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`centra`]: (getObjectProperty(___arguments.context.pageData, 'centra')) }) );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index3 in gegevenslist) {
      k = gegevenslist[k_index3];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'email', 'userStatus', 'lastLogin', 'objectId', 'viewprojectenblock'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index4 in userslist) {
    j = userslist[j_index4];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`centra`]: (getObjectProperty(j, 'centra')),[`username`]: (getObjectProperty(j, 'username')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`rol`]: (getObjectProperty(j, 'rol')),[`team`]: (getObjectProperty(j, 'team')),[`email`]: (getObjectProperty(j, 'email')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`viewprojectenblock`]: (getObjectProperty(j, 'viewprojectenblock')) }) );
  }
  centra = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'groupBy': 'centra','properties': ['centra'] }));
  centralist = (await Promise.all(centra.map(async item => {; return (getObjectProperty(item, 'centra'));})));
  for (var k_index4 in centralist) {
    k = centralist[k_index4];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',k,'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',k,'\' AND viewprojectenblock = TRUE'].join('')) }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index3 in userslist2) {
      l = userslist2[l_index3];
      gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',k,'\''].join('')) }));
      gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index2 in gebruikersbeheerlist) {
        m = gebruikersbeheerlist[m_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
      }
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
}

/**
 * Describe this function...
 */
async function projectgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index5 in userslist) {
    j = userslist[j_index5];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index5 in declaratieslist) {
      k = declaratieslist[k_index5];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index5 in beheerderslist) {
        l = beheerderslist[l_index5];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index3 in projectleiderslist) {
        m = projectleiderslist[m_index3];
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projectgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions projectgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function projecttarieven() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index6 in userslist) {
    j = userslist[j_index6];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttarieven','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index6 in declaratieslist) {
      k = declaratieslist[k_index6];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index6 in beheerderslist) {
        l = beheerderslist[l_index6];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index4 in projectleiderslist) {
        m = projectleiderslist[m_index4];
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions projecttarieven uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index7 in userslist) {
    j = userslist[j_index7];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'maandafsluiten','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index7 in declaratieslist) {
      k = declaratieslist[k_index7];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
}

/**
 * Describe this function...
 */
async function projectfinanciering() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectfinanciering','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['projectcode', 'objectId'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`projectcode`]: (getObjectProperty(item, 'projectcode')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  console.log(String('gegevenslist: ') + String(gegevenslist));
  for (var j_index8 in gegevenslist) {
    j = gegevenslist[j_index8];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index8 in beheerderslist) {
      k = beheerderslist[k_index8];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index7 in projectleiderslist) {
      l = projectleiderslist[l_index7];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectfinanciering',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  if (false) {
    console.log('permissions projectfinanciering uitgevoerd');
    (function (message) { alert(message) })('permissions projectfinanciering uitgevoerd');
  }
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode', 'username'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index9 in gegevenslist) {
    j = gegevenslist[j_index9];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index8 in beheerderslist) {
      l = beheerderslist[l_index8];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttoestemmingen uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnlbeheerders() {
  declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index10 in declaratieslist) {
    j = declaratieslist[j_index10];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var l_index9 in beheerderslist) {
      l = beheerderslist[l_index9];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions declaraties beheerders uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties beheerders uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionfiles() {
  users = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))).setProperties(['objectId']).setPageSize(10)));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index11 in userslist) {
    j = userslist[j_index11];
    await Backendless.Files.Permissions.READ.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    await Backendless.Files.Permissions.DELETE.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    await Backendless.Files.Permissions.WRITE.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND viewprojectenblock = TRUE'].join('')),'properties': ['objectId'] }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index9 in userslist2) {
      k = userslist2[k_index9];
      await Backendless.Files.Permissions.READ.grantForUser(k, (String('kopiescan') + String(getObjectProperty(___arguments.context.pageData, 'centra'))));
    }
  }
  console.log('permissions files uitgevoerd');
}


  ___arguments.context.pageData['spinner'] = true;
  newuser = (await Backendless.UserService.register( new Backendless.User({ 'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'team': (getObjectProperty(___arguments.context.pageData, 'team')),'centra': (getObjectProperty(___arguments.context.pageData, 'centra')),'username': (getObjectProperty(___arguments.context.pageData, 'usernameregister')),'password': 'CVL2022isBegonnen!?','btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),'btwinclscholing': (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),'rol': (getObjectProperty(___arguments.context.pageData, 'rol')),'viewinstellingenblock': (getObjectProperty(___arguments.context.pageData, 'viewinstellingenblock')),'viewprojectaanmakenknop': (getObjectProperty(___arguments.context.pageData, 'viewprojectaanmakenknop')) }) ));
  await instellen_permissions();
  (function (message) { alert(message) })((['User is geregistreerd: \n',['Naam: ',(getObjectProperty(newuser, 'naam')),' \n'].join(''),['Email: ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Username:  ',(getObjectProperty(newuser, 'username')),' \n'].join(''),['Centra:  ',(getObjectProperty(newuser, 'centra')),' \n'].join(''),['btwplichtig:  ',(getObjectProperty(newuser, 'btwplichtig')),' \n'].join(''),['btwinclconsulten:  ',(getObjectProperty(newuser, 'btwinclconsulten')),' \n'].join(''),['btwinclscholing:  ',(getObjectProperty(newuser, 'btwinclscholing')),' \n'].join(''),['Rol:  ',(getObjectProperty(newuser, 'rol')),' \n'].join(''),['Toegang tot instellingen:  ',(getObjectProperty(newuser, 'viewinstellingenblock')),' \n'].join(''),['Toegang tot projecten aanmaken: ',(getObjectProperty(newuser, 'viewprojectaanmakenknop')),' \n'].join('')].join('')));
  await Backendless.Data.of('newuserrequests').bulkUpdate( (['naam=\'',(getObjectProperty(newuser, 'naam')),'\''].join('')), ({ [`useraangemaakt`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setSortBy('created DESC').setPageSize(100))));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  await Backendless.Files.saveFile(encodePath((['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'/'].join(''))), (['start-',(await Backendless.Counters.get('kopiescan')),'.txt'].join('')), 'text', false);
  await permissionfiles();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/05ab59ac7c3b9157ad86d6a130cb67a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND dashboardnaam NOT LIKE \'lorio%\''].join(''))).setProperties('dashboardnaam').setSortBy('created DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/9449ebc70bf23e2a1d64b969cf6647d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/permissions/components/543c1647fb91edcf0518d46c37752178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'facturatieadresgegevens','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions facturatieadresgegevens uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsfacturatieadresgegevens();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/6c3d7b18c98f6608c648ab78251bce44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gegevenslist, item, gegevens, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in gegevenslist) {
      k = gegevenslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions factuurgegevens uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsfactuurgegevens();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/6018ba8820282857f5e8e868bb18b018/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, j, declaratieslist, declaraties, userslist, users, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projecttarieven() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttarieven','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index in projectleiderslist) {
      m = projectleiderslist[m_index];
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttarieven',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttarieven uitgevoerd');
  (function (message) { alert(message) })('permissions projecttarieven uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projecttarieven();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/1efa76a97c0820088c78ab688958df08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, j, projectleiderslist, item, projectleiders, l, beheerderslist, beheerders, k, userslist, users, gegevenslist, gegevens, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode', 'username'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index in projectleiderslist) {
      m = projectleiderslist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttoestemmingen uitgevoerd');
  (function (message) { alert(message) })('permissions projecttoestemmingen uitgevoerd');
}

/**
 * Describe this function...
 */
async function projecttoestemmingen_oud() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index2 in declaratieslist) {
      k = declaratieslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index2 in beheerderslist) {
        l = beheerderslist[l_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index2 in projectleiderslist) {
        m = projectleiderslist[m_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions projecttoestemmingen uitgevoerd');
  (function (message) { alert(message) })('permissions projecttoestemmingen uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projecttoestemmingen();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/c3c8692edd7df313d0589228c22790e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j, rol, newuser;


  var j_list = ['naam', 'email', 'organisatie', 'team', 'centra', 'usernameregister', 'btwplichtig', 'btwinclconsulten', 'btwinclscholing', 'rol', 'viewinstellingenblock', 'viewprojectaanmakenknop'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f8daf5872d2777cc4a819fead57ce1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/permissions/components/7622db78b4a8b818b068046e27e81c18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('newuserrequests').save( ___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58') );
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwinclscholing'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwplichtig'));
  ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'centra'));
  ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'email'));
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'naam'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'organisatie'));
  ___arguments.context.pageData['team'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'team'));
  ___arguments.context.pageData['rol'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'rol'));
  ___arguments.context.pageData['aangemelddoor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'aangemelddoor'));
  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'aangemelddooremail'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/a60a526ee29e9d1ff87863c88f0885c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, userslist2, item, users2, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionfiles() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Files.Permissions.READ.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    await Backendless.Files.Permissions.DELETE.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    await Backendless.Files.Permissions.WRITE.grantForUser((getObjectProperty(j, 'objectId')), (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(j, 'username'))].join('')));
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND viewprojectenblock = TRUE'].join('')),'properties': ['objectId'] }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist2) {
      k = userslist2[k_index];
      await Backendless.Files.Permissions.READ.grantForUser(k, (String('kopiescan') + String(getObjectProperty(___arguments.context.pageData, 'centra'))));
    }
  }
  console.log('permissions files uitgevoerd');
  (function (message) { alert(message) })('permissions files uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await permissionfiles();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/7cef7da404088638c51e3a888e53ae58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, declaratieslist, item, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'maandafsluiten','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
  (function (message) { alert(message) })('permissions maandafsluiten uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await permissionsmaandafsluiten();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/57c849c81b7887b8300328298235b709/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.UserService.findByRole('beheerder', false, Backendless.DataQueryBuilder.create().setPageSize(100)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/63011ca8e2b4c136da480e2816e84046/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, j, beheerderslist, item, beheerders, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode', 'username'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttoestemmingen enkel beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions projecttoestemmingen enkel beheerder uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projecttoestemmingen();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/22f9ffdb34143f98a1a7e64690d8d143/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, j, userslist, item, users, gegevenslist, gegevens, l, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode', 'username'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttoestemmingen users uitgevoerd');
  (function (message) { alert(message) })('permissions projecttoestemmingen users uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projecttoestemmingen();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/8918126801c23ca96409c65401e87126/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, j, projectleiderslist, item, projectleiders, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function projecttoestemmingen() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId', 'projectcode', 'username'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')),[`username`]: (getObjectProperty(item, 'username')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index in projectleiderslist) {
      m = projectleiderslist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    }
  }
  console.log('permissions projecttoestemmingen enkel projectleiders uitgevoerd');
  (function (message) { alert(message) })('permissions projecttoestemmingen enkel projectleiders uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await projecttoestemmingen();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/06ae39ec3388491b5458344b5f081e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, projectleiderslist, item, projectleiders, declaratieslist, declaraties, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId', 'projectcode'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(k, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in projectleiderslist) {
        m = projectleiderslist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.REMOVE.grantForUser(m, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties projectleiders uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties projectleiders uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsdeclaratiesmnl();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3848b36881a8b3d87de847a8dccb6618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaratiesmnl beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaratiesmnl beheerder uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    await permissionsdeclaratiesmnl();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/eeb35e48d7c8efe8a727f11c56583f19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, listnewtoestemming, item, usernamesprojecttoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Zat voor Save Object projectfinanciering 20250426
 */
async function relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens() {
  usernamesprojecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND username NOT LIKE \'lorio%\''].join('')),'properties': ['username'] }));
  listnewtoestemming = (await Promise.all(usernamesprojecttoestemmingen.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in listnewtoestemming) {
    j = listnewtoestemming[j_index];
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projecttoestemmingen', [(getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties('userobjectId').setPageSize(10)))[0]), 'userobjectId'))]);
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectgegevens', [(await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
  }
  console.log('relaties maken tussen user en projecttoestemmingen en projectgegevens uitgevoerd');
  (function (message) { alert(message) })('relaties maken tussen user en projecttoestemmingen en projectgegevens uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('Selecteer een projectcode');
  } else {
    await relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/2f782bd8a84a13a8607895b955247178/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join(''))).setProperties('projectcode').setSortBy('projectcode ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: (getObjectProperty(item, 'projectcode')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/permissions/components/28b8eef8926eb86d18c8f1798c28e468/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, userslist, item, users, projectleiderslist, projectleiders, j, gegevenslist, gegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function users_retrieve_geven_tot_projectleider() {
  gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'groupBy': 'projectcode','properties': ['projectcode'] }));
  gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
  for (var j_index in gegevenslist) {
    j = gegevenslist[j_index];
    projectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(j, 'projectcode')),'\' AND svprojectleider = TRUE'].join(''))).setProperties('objectId').setPageSize(100)));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    console.log(String('projectleiderslist: ') + String(projectleiderslist));
    for (var k_index in projectleiderslist) {
      k = projectleiderslist[k_index];
      users = (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND username NOT LIKE \'lorio%\''].join(''))).setProperties('userobjectId').setPageSize(100)));
      userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      console.log(String('userslist: ') + String(userslist));
      for (var l_index in userslist) {
        l = userslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: k }));
      }
    }
  }
  console.log('Permissions users retrieve projecteleider projecttoestemmingen uitgevoerd');
  (function (message) { alert(message) })('Permissions users retrieve projecteleider projecttoestemmingen uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else {
    await users_retrieve_geven_tot_projectleider();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/fcb8b0b8b2c250b167389ff8a7f4c7c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, j, userslist, item, users, projecttoestemmingenlist, projecttoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissions_voor_projectcode_geven() {
  projecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join('')) }));
  projecttoestemmingenlist = (await Promise.all(projecttoestemmingen.map(async item => {; return item;})));
  console.log(String('projecttoestemmingenlist: ') + String(projecttoestemmingen));
  for (var j_index in projecttoestemmingenlist) {
    j = projecttoestemmingenlist[j_index];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return item;})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      if ((getObjectProperty(j, 'username')) == (getObjectProperty(k, 'username'))) {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      if ((getObjectProperty(k, 'rol')) == 'beheerder') {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      if ((getObjectProperty(j, 'creator')) == (getObjectProperty(k, 'username'))) {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
    }
  }
  (function (message) { alert(message) })('permissions voor projectcodes zijn gegeven');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer een centra');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('Selecteer een projectcode');
  } else {
    await permissions_voor_projectcode_geven();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/c6883e64bf8bef65b91f8bc825b55d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var GVORG;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    GVORG = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/GVORG.csv','tableName': 'factuurgegevens','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND username NOT LIKE  \'lorio%\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['username', 'bedrijfsnaam', 'email'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['username', 'bedrijfsnaam', 'email'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(GVORG, true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a1a5941320c26ee8a9a8c433023d9448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('de', ({ [`dateStyle`]: 'medium',[`timeStyle`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/4407d708da9d79bfaa9f2dc84018a75c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaratiesmnl','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')) }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaratiesmnl beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaratiesmnl beheerder uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else if ((getObjectProperty(___arguments.context.pageData, 'usernameregister')) == null) {
    (function (message) { alert(message) })('Vul username in');
  } else {
    await permissionsdeclaratiesmnl();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectenoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/c10e42811fd8851cfa31c2e1261f8321/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ec1d79f0bd8972298b19c4f2cb5a6c', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties(['projectcode', 'Sum(budget) as totaalbudget']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a58028e8cc5de4a1cb36ac271df4a94', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND controle <>\'NIET AKKOORD\''].join(''))).setProperties(['projectcode', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectdetails/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('PROJECT ') + String((getObjectProperty(___arguments.context.appData, 'projectnaam')).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/f907d99bc1e99c59148d04cc02ab490c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/764369293ad70fa99a78c6d2a7519dbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/891e29d8be551f2c8f0575deef47e295/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/07eb361932f6f95229f1f33ee89dc3a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/eb015b1a4745370a68b1037c7d89cd66/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eb015b1a4745370a68b1037c7d89cd66', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/a2efca34992c0098b8672d0562fbeb64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/65f96fa13bf48ae9e9a672fce389968f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/d87d1573db9f5ed5bb685a959f5a1a29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/23734cb76ff29bfe8e77b8fcf3da324c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/4cb422cfd4382881a6fa57ed3c13c238/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4cb422cfd4382881a6fa57ed3c13c238', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectstatus')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4cb422cfd4382881a6fa57ed3c13c238'))['backgroundColor'] = '#C2CC9D';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4cb422cfd4382881a6fa57ed3c13c238'))['backgroundColor'] = 'red';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/b096f96cb24c291437449eeb68866bcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
  if ((getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) == null) {
    (function (message) { alert(message) })('De instellingen voor de btw zijn niet ingevuld op de pagina financieringsgegevens. Deze gegevens moeten eerst ingevuld worden voordat het project op actief gezet kan worden.');
    ___arguments.context.getComponentDataStoreByUid('947787e86e9ca94a7ebcc3b23a06255b')['projectstatus'] = false;
    await Backendless.Data.of('projectgegevens').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')), ({ [`projectstatus`]: false }) );
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4cb422cfd4382881a6fa57ed3c13c238'))['backgroundColor'] = 'red';
  } else {
    await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('947787e86e9ca94a7ebcc3b23a06255b') );
    await Backendless.Data.of('historieprojectstatus').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: ___arguments.value }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('947787e86e9ca94a7ebcc3b23a06255b'), 'projectstatus')) == true) {
      await Backendless.Messaging.sendEmailFromTemplate('projectakkoord', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }), undefined);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4cb422cfd4382881a6fa57ed3c13c238'))['backgroundColor'] = '#C2CC9D';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4cb422cfd4382881a6fa57ed3c13c238'))['backgroundColor'] = 'red';
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectdetails/components/bcbcfc2e70fdcc2e672abd1e96b6c811/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bcbcfc2e70fdcc2e672abd1e96b6c811'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bcbcfc2e70fdcc2e672abd1e96b6c811'))['color'] = '#a6b07a';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/projectdetails/components/d1cfc4de4153466e793c47592dc575b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectdetails/components/eb71ffcef7280bcf78b35899a43270e5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f')['readOnly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/073d717c0091d37d30fd7add7c753e27/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('073d717c0091d37d30fd7add7c753e27', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties(['projectcode', 'Sum(budget) as totaalbudget']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/bf38c3c4605809c84cc594d24c75bb6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['totaalbudget'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbudget'));

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbudget'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/c9d77ad15aa2f1b7b28f9e6beb122c76/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c9d77ad15aa2f1b7b28f9e6beb122c76', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties(['projectcode', 'financieringsstroom', 'budget']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/1ab2bc8b9b82713f27f328e7e0d5429e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25bcf51cc37a7d08461b7fa8aafda227'), 'budget'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/a7dbaf6a3c6aefe314afae17432f0134/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7dbaf6a3c6aefe314afae17432f0134', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND controle <>\'NIET AKKOORD\''].join(''))).setProperties(['projectcode', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/b2e3291bd131a3974f639e75d0ae4c3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/b75ce7179474b0a7cc48e22c4061e0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b75ce7179474b0a7cc48e22c4061e0b8', (await Backendless.Data.of('declaratiesmnl').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND controle <>\'NIET AKKOORD\''].join(''))).setProperties(['projectcode', 'sum(totaalbedrag) as totaalbedrag', 'soort']).setGroupBy('soort').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectdetails/components/2855ac7eb497c211aed890d6d059bee8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0ddadacbc8b7ae660e21c479c648ab22'), 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/59dc8f0b5d73703979e345c62ba54788/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(((getObjectProperty(___arguments.context.pageData, 'totaalbudget')) - (getObjectProperty(___arguments.context.pageData, 'totaalbesteed')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/1f1f35d2d81a0e83280ea059e7c63a42/bundle.js', [], () => ({
  /* content */
  /* handler:goalLogic */
  ['goalLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'totaalbudget'))

  },
  /* handler:goalLogic */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'totaalbesteed'))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/projectdetails/components/5c5cd97766d30f44087b4c36acd543ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6a5294a464bfa4af0c6a3ca03e25f2c')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6a5294a464bfa4af0c6a3ca03e25f2c', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6a5294a464bfa4af0c6a3ca03e25f2c', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/0485dcd7ef02a601b25a3adea4bec94e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['totaalbudget'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbudget'));

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbudget'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/ee7c1ab2f6be192ec7d7a681d6af9c64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['totaalbesteed'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/46662f733fdb5d375061b547d34c9ee8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandcontroleperproject', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectdetails/components/bd7228f41464cbffce03139181947b34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0ddadacbc8b7ae660e21c479c648ab22'), 'soort')) == 'Werktijd coördinator') {
    text = 'Werktijd algemeen coördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0ddadacbc8b7ae660e21c479c648ab22'), 'soort')) == 'Werktijd projectleider') {
    text = 'Werktijd projectleider/ coördinator';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0ddadacbc8b7ae660e21c479c648ab22'), 'soort'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectdetails/components/a41c043c15c5904978d5e052bed5d94a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaarcontroleperproject', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenfinancieeloverzicht/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenfinancieeloverzicht/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenfinancieeloverzicht/components/98c2c011ceae03ab5c6c183a7e345f9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ec4e6a18442568cc6ebf86f33f287198')), 'display')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec4e6a18442568cc6ebf86f33f287198', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec4e6a18442568cc6ebf86f33f287198', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenfinancieeloverzicht/components/9da698a9cfafeb9250ab1873c52b4ba8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenfinancieeloverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectenoverzicht/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenoverzicht/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenoverzicht/components/9da698a9cfafeb9250ab1873c52b4ba8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenoverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function on_page_enter() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectgegevens','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join('')) })));
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['projectcode'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectenoverzicht/components/18f9436dc38de9f92d2145884f758bc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['projectcode'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectcode'));
  ___arguments.context.appData['projectnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectnaam'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectdetails', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visibility, k, userslist, item, users, j, userslistprojectleiders, listprojectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == '') {
    visibility = true;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn73rzm') {
    visibility = true;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn60jmn') {
    visibility = true;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn01bhr1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn02bhr2') {
    visibility = true;
  }
}


  listprojectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectcode')),'\' AND svprojectleider=\'1\'',' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('username').setGroupBy('projectcode').setPageSize(100)));
  userslistprojectleiders = (await Promise.all(listprojectleiders.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var j_index in userslistprojectleiders) {
    j = userslistprojectleiders[j_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == j) {
      visibility = true;
    } else {
      visibility = false;
    }
  }
  users = (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND rol=\'beheerder\''].join(''))).setProperties('username').setPageSize(10)));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var k_index in userslist) {
    k = userslist[k_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == k) {
      visibility = true;
    } else {
      visibility = false;
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomnlbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm') {
    visibility = true;
  }

  return visibility

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectenoverzicht/components/54dcd10ef6fe9808d939ab216735e79d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectstatus')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('60f42a26cab3a8f1d509231eab4ec05e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe86762ab70b9b06cd4f97cdf6be7a73', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe86762ab70b9b06cd4f97cdf6be7a73', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('60f42a26cab3a8f1d509231eab4ec05e', false);
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectenoverzicht/components/8532e4a6f62c256b3db7ae1e78fecbd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8532e4a6f62c256b3db7ae1e78fecbd6'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8532e4a6f62c256b3db7ae1e78fecbd6'))['color'] = '#a6b07a';
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var changeomschrijving, item, j, k, listprojectleiders, users, userslist, userslistprojectleiders, visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listprojectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectcode')),'\' AND svprojectleider=\'1\'',' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('username').setGroupBy('projectcode').setPageSize(100)));
  userslistprojectleiders = (await Promise.all(listprojectleiders.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var j_index in userslistprojectleiders) {
    j = userslistprojectleiders[j_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == j) {
      changeomschrijving = true;
    }
  }
  users = (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND rol=\'beheerder\''].join(''))).setProperties('username').setPageSize(10)));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var k_index in userslist) {
    k = userslist[k_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == k) {
      changeomschrijving = true;
    } else {
      changeomschrijving = false;
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomnlbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomnlbhrjm') {
    changeomschrijving = true;
  }

  return changeomschrijving

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectenoverzicht/components/d1cfc4de4153466e793c47592dc575b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectenoverzicht/components/eb71ffcef7280bcf78b35899a43270e5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f')['readOnly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectenoverzicht/components/ac5b2cb82076fa58178c5f56a392ab9d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectstatus=TRUE'].join(''))).setProperties(['projectnaam', 'projectcode']).setSortBy('projectnaam ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: [(getObjectProperty(item, 'projectnaam')),' - ',(getObjectProperty(item, 'projectcode'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var projectcode, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  projectcode = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'selectproject')),'\''].join(''))).setProperties(['projectnaam', 'projectcode']).setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')) });})))[0];
  ___arguments.context.pageData['projectcode'] = (getObjectProperty(projectcode, 'value'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' '].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectenoverzicht/components/5f353bfbfc4ab31fc269af94b8c7692a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));
}


  ___arguments.context.pageData['selectproject'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectenoverzicht/components/2e54fb9b80ac6cd8efe7f805d4797773/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66d7082460b3f7461c61ffcefe48b4f'), 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectenoverzicht/components/60433b07876ebfd1393b7bb5742fd72f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var projectcode, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  projectcode = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'selectproject')),'\''].join(''))).setProperties(['projectnaam', 'projectcode']).setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')) });})))[0];
  ___arguments.context.pageData['projectcode'] = (getObjectProperty(projectcode, 'value'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' '].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectstatus=FALSE'].join(''))).setProperties(['projectnaam', 'projectcode']).setSortBy('projectnaam ASC').setGroupBy('projectcode').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'projectcode')),[`label`]: [(getObjectProperty(item, 'projectnaam')),' - ',(getObjectProperty(item, 'projectcode'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectenoverzicht/components/19ba9449e8c7654c0a4b91052838051c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));
}


  ___arguments.context.pageData['selectproject'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c10e42811fd8851cfa31c2e1261f8321', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e54fb9b80ac6cd8efe7f805d4797773', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap1/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap1/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectmakenstap1/components/2add8a278bd246ba86a11f2e38fb195e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, listcreatedobjects, item, createdobjects, TEMPprojectnaam, TEMPprojectcode, k, userslist, users, projecttoestemmingenlist, projecttoestemmingen, listnewtoestemming, usernamesprojecttoestemmingen, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  console.log(String('projecttoestemmingenlist: ') + String(listcreatedobjects));
}

/**
 * Describe this function...
 */
async function permissions_projecttoestemmingen() {
  console.log('start permissions projecttoestemmingen');
  projecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join('')) }));
  projecttoestemmingenlist = (await Promise.all(projecttoestemmingen.map(async item => {; return item;})));
  for (var j_index2 in projecttoestemmingenlist) {
    j = projecttoestemmingenlist[j_index2];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return item;})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      if ((getObjectProperty(j, 'username')) == (getObjectProperty(k, 'username'))) {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      if ((getObjectProperty(k, 'rol')) == 'beheerder') {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
    }
  }
}

/**
 * Zat voor Save Object projectfinanciering 20250426
 */
async function relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens() {
  usernamesprojecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join('')),'properties': ['username'] }));
  listnewtoestemming = (await Promise.all(usernamesprojecttoestemmingen.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index3 in listnewtoestemming) {
    j = listnewtoestemming[j_index3];
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projecttoestemmingen', [(getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties('userobjectId').setPageSize(10)))[0]), 'userobjectId'))]);
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectgegevens', [(await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
  }
}

/**
 * Describe this function...
 */
async function testing() {
  (function (message) { alert(message) })((JSON.parse(j)));
}

/**
 * Describe this function...
 */
async function do_something2() {
  for (var j_index4 in listcreatedobjects) {
    j = listcreatedobjects[j_index4];
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['objectId=\'',(JSON.parse(j)),'\''].join('')), ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')) }) );
  }
}

/**
 * Describe this function...
 */
async function users_retrieve_geven_tot_projectleider() {
  projectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider = TRUE'].join(''))).setProperties('objectId').setPageSize(100)));
  projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  console.log(String('projectleiderslist: ') + String(projectleiderslist));
  for (var j_index5 in projectleiderslist) {
    j = projectleiderslist[j_index5];
    users = (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join(''))).setProperties('userobjectId').setPageSize(100)));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    console.log(String('userslist: ') + String(userslist));
    for (var k_index2 in userslist) {
      k = userslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: j }));
    }
  }
}


  TEMPprojectcode = (await Backendless.Data.of('projectgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join('')))));
  TEMPprojectnaam = (await Backendless.Data.of('projectgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam=\'',(getObjectProperty(___arguments.context.pageData, 'projectnaam')),'\''].join('')))));
  if (TEMPprojectcode == 1) {
    (function (message) { alert(message) })('De projectcode is al in gebruik, maak een andere projectcode aan');
    ___arguments.context.pageData['projectcode'] = null;
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('De projectcode is nog niet ingevuld');
  } else if (getValueLength((getObjectProperty(___arguments.context.pageData, 'projectcode'))) == 0) {
    (function (message) { alert(message) })('De projectcode is nog niet ingevuld');
  } else if (TEMPprojectnaam == 1) {
    (function (message) { alert(message) })('De projectnaam is al in gebruik, maak een andere projectnaam aan');
    ___arguments.context.pageData['projectnaam'] = null;
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectnaam')) == null) {
    (function (message) { alert(message) })('De projectnaam is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectomschrijving')) == null) {
    (function (message) { alert(message) })('De projectomschrijving is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectstartdatum')) == null) {
    (function (message) { alert(message) })('De startdatum van het project is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projecteinddatum')) == null) {
    (function (message) { alert(message) })('De einddatum van het project is nog niet ingevuld');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' && (getObjectProperty(___arguments.context.pageData, 'factuuradres')) == null) {
    (function (message) { alert(message) })('Factuuradres moet geselecteerd worden');
  } else {
    ___arguments.context.pageData['spinner'] = true;
    ___arguments.context.pageData['disablesave'] = true;
    try {
      await Backendless.Data.of('projectgegevens').save( ({ [`factuuradres`]: (getObjectProperty(___arguments.context.pageData, 'factuuradres')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`projectomschrijving`]: (getObjectProperty(___arguments.context.pageData, 'projectomschrijving')),[`projectstartdatum`]: (getObjectProperty(___arguments.context.pageData, 'projectstartdatum')),[`projecteinddatum`]: (getObjectProperty(___arguments.context.pageData, 'projecteinddatum')) }) );
      ___arguments.context.appData['projectcode'] = (getObjectProperty(___arguments.context.pageData, 'projectcode'));
      ___arguments.context.appData['projectnaam'] = (getObjectProperty(___arguments.context.pageData, 'projectnaam'));
      createdobjects = (await Backendless.Data.of('projecttoestemmingen').bulkCreate( (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join(''))).setProperties(['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'userobjectId']).excludeProperties('objectId').setPageSize(100))) ));
      listcreatedobjects = (await Promise.all(createdobjects.map(async item => {; return (JSON.stringify(item));})));
      for (var j_index in listcreatedobjects) {
        j = listcreatedobjects[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (JSON.parse(j)) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (JSON.parse(j)) }));
        await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['objectId=\'',(JSON.parse(j)),'\''].join('')), ({ [`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')) }) );
      }
      await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`svprojectleider`]: true }) );
      await permissions_projecttoestemmingen();
      await users_retrieve_geven_tot_projectleider();
      await Backendless.Data.of('projectfinanciering').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')) }) );
      await relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 1155) {
        (function (message) { alert(message) })('Deze projectcode en/of projectnaam bestaat al. Maak een andere projectcode aan of ga naar het projectenoverzicht.');
      }
      ___arguments.context.pageData['disablesave'] = false;
      console.log(error);

    }
  }
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap1/components/84294ea3e44a900f3b6aace61bb2e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap1/components/fd2830e84c3860bdd0b8661e12b648d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties(['factuuradres']).setSortBy('factuuradres ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'factuuradres')),[`label`]: (getObjectProperty(item, 'factuuradres')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectmakenstap1/components/2a3814d609281bbbee7847cf1b885b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap1backup/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap1backup/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap1backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectmakenstap1backup/components/2add8a278bd246ba86a11f2e38fb195e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, TEMPprojectnaam, TEMPprojectcode, j, listnewtoestemming, item, usernamesprojecttoestemmingen, k, userslist, users, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Zat voor Save Object projectfinanciering 20250426
 */
async function relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens() {
  usernamesprojecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join('')),'properties': ['username'] }));
  listnewtoestemming = (await Promise.all(usernamesprojecttoestemmingen.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in listnewtoestemming) {
    j = listnewtoestemming[j_index];
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projecttoestemmingen', [(getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties('userobjectId').setPageSize(10)))[0]), 'userobjectId'))]);
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectgegevens', [(await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
  }
}

/**
 * Describe this function...
 */
async function users_retrieve_geven_tot_projectleider() {
  projectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND svprojectleider = TRUE'].join(''))).setProperties('objectId').setPageSize(100)));
  projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  console.log(String('projectleiderslist: ') + String(projectleiderslist));
  for (var j_index2 in projectleiderslist) {
    j = projectleiderslist[j_index2];
    users = (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join(''))).setProperties('userobjectId').setPageSize(100)));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    console.log(String('userslist: ') + String(userslist));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: j }));
    }
  }
}


  TEMPprojectcode = (await Backendless.Data.of('projectgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\''].join('')))));
  TEMPprojectnaam = (await Backendless.Data.of('projectgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['projectnaam=\'',(getObjectProperty(___arguments.context.pageData, 'projectnaam')),'\''].join('')))));
  if (TEMPprojectcode == 1) {
    (function (message) { alert(message) })('De projectcode is al in gebruik, maak een andere projectcode aan');
    ___arguments.context.pageData['projectcode'] = null;
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectcode')) == null) {
    (function (message) { alert(message) })('De projectcode is nog niet ingevuld');
  } else if (getValueLength((getObjectProperty(___arguments.context.pageData, 'projectcode'))) == 0) {
    (function (message) { alert(message) })('De projectcode is nog niet ingevuld');
  } else if (TEMPprojectnaam == 1) {
    (function (message) { alert(message) })('De projectnaam is al in gebruik, maak een andere projectnaam aan');
    ___arguments.context.pageData['projectnaam'] = null;
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectnaam')) == null) {
    (function (message) { alert(message) })('De projectnaam is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectomschrijving')) == null) {
    (function (message) { alert(message) })('De projectomschrijving is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectstartdatum')) == null) {
    (function (message) { alert(message) })('De startdatum van het project is nog niet ingevuld');
  } else if ((getObjectProperty(___arguments.context.pageData, 'projecteinddatum')) == null) {
    (function (message) { alert(message) })('De einddatum van het project is nog niet ingevuld');
  } else {
    ___arguments.context.pageData['spinner'] = true;
    ___arguments.context.pageData['disablesave'] = true;
    try {
      await Backendless.Data.of('projectgegevens').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`projectomschrijving`]: (getObjectProperty(___arguments.context.pageData, 'projectomschrijving')),[`projectstartdatum`]: (getObjectProperty(___arguments.context.pageData, 'projectstartdatum')),[`projecteinddatum`]: (getObjectProperty(___arguments.context.pageData, 'projecteinddatum')) }) );
      ___arguments.context.appData['projectcode'] = (getObjectProperty(___arguments.context.pageData, 'projectcode'));
      ___arguments.context.appData['projectnaam'] = (getObjectProperty(___arguments.context.pageData, 'projectnaam'));
      await Backendless.Data.of('projecttoestemmingen').bulkCreate( (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join(''))).setProperties(['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'userobjectId']).excludeProperties('objectId').setPageSize(100))) );
      await new Promise(r => setTimeout(r, 2000 || 0));
      await Backendless.Data.of('projecttoestemmingen').bulkUpdate( 'projectcode is null', ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')) }) );
      await new Promise(r => setTimeout(r, 2000 || 0));
      await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.pageData, 'projectcode')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`svprojectleider`]: true }) );
      await users_retrieve_geven_tot_projectleider();
      await Backendless.Data.of('projectfinanciering').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.pageData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')) }) );
      await relaties_maken_tussen_user_en_projecttoestemmingen_en_projectgegevens();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap2', undefined);

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 1155) {
        (function (message) { alert(message) })('Deze projectcode en/of projectnaam bestaat al. Maak een andere projectcode aan of ga naar het projectenoverzicht.');
      }
      ___arguments.context.pageData['disablesave'] = false;
      console.log(error);

    }
  }
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap1backup/components/84294ea3e44a900f3b6aace61bb2e3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectdetails', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b86899d3a68a20ac200acd515b4f16a8', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8a55ce0b8f8af58ac59f3a38ee951644', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a79cb8270852da800c74b4a643aed2f', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('82bb601840684608b4e510f810d8e098', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
  btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
  ___arguments.context.pageData['projectbtwsoort'] = (getObjectProperty(btwsoortgevuld, 'projectbtwsoort'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectmakenstap2/components/8e47514c8f4e09f9ccf74432f1c5334c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svwerktijdcoordinator',[`soort`]: 'Werktijd coördinator' }) );
    ___arguments.context.pageData['svwerktijdcoordinator'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd coördinator',[`soortcode`]: 'svwerktijdcoordinator',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['svwerktijdcoordinator'] = false;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd coördinator',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svwerktijdcoordinator=1'].join('')), ({ [`svwerktijdcoordinator`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svwerktijdcoordinator','\''].join('')) );
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd coördinator',[`soortcode`]: 'svwerktijdcoordinator',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7b2399e910cd3650a11b0dfb92e90d1', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdcoordinator','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/5de1e11e4179ae720d886dbb8998574e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svreiskosten',[`soort`]: 'Kilometervergoeding' }) );
    ___arguments.context.pageData['svreiskosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Kilometervergoeding',[`soortcode`]: 'svreiskosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Reiskosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svreiskosten=1'].join('')), ({ [`svreiskosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svreiskosten','\''].join('')) );
    ___arguments.context.pageData['svreiskosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Kilometervergoeding',[`soortcode`]: 'svreiskosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6a4678be9e30dff81cd4adff70e5278', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svreiskosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/386e0cfdae53967f91bf565313e30d15/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svparkeerkosten',[`soort`]: 'OV/Parkeerkosten' }) );
    ___arguments.context.pageData['svparkeerkosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'OV/Parkeerkosten',[`soortcode`]: 'svparkeerkosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'OV/Parkeerkosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svparkeerkosten=1'].join('')), ({ [`svparkeerkosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svparkeerkosten','\''].join('')) );
    ___arguments.context.pageData['svparkeerkosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'OV/Parkeerkosten',[`soortcode`]: 'svparkeerkosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c91bff995637a11fe2a8cf99c9459abf', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svparkeerkosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/6e05178c0a0559a76345d3cf0c98fc63/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svvastevacatiegelden',[`soort`]: 'Vaste vacatiegelden' }) );
    ___arguments.context.pageData['svvastevacatiegelden'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Vaste vacatiegelden',[`soortcode`]: 'svvastevacatiegelden',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Vaste vacatiegelden',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svvastevacatiegelden=1'].join('')), ({ [`svvastevacatiegelden`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svvastevacatiegelden','\''].join('')) );
    ___arguments.context.pageData['svvastevacatiegelden'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Vaste vacatiegelden',[`soortcode`]: 'svvastevacatiegelden',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d9f035a70addd1886dad9d6c88b89c7', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svvastevacatiegelden','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/e1a8df1d9b11bcd690b6725bddc4195f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svlocatiekosten',[`soort`]: 'Locatiekosten' }) );
    ___arguments.context.pageData['svlocatiekosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Locatiekosten',[`soortcode`]: 'svlocatiekosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Locatiekosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svlocatiekosten=1'].join('')), ({ [`svlocatiekosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svlocatiekosten','\''].join('')) );
    ___arguments.context.pageData['svlocatiekosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Locatiekosten',[`soortcode`]: 'svlocatiekosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('889bb21d6e9366f7a87a09d153a771ca', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svlocatiekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/3de4bbc296cf76e1c4c686fb0afb6e85/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svmaterielekosten',[`soort`]: 'Materiële kosten' }) );
    ___arguments.context.pageData['svmaterielekosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Materiële kosten',[`soortcode`]: 'svmaterielekosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Materiële kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svmaterielekosten=1'].join('')), ({ [`svmaterielekosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svmaterielekosten','\''].join('')) );
    ___arguments.context.pageData['svmaterielekosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Materiële kosten',[`soortcode`]: 'svmaterielekosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2c1c9d73eec6c0955e832fa4aeafff38', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svmaterielekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/1e378b1ad3772bb808cb5a6e7c44ee15/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svwerktijdbestuurslid',[`soort`]: 'Werktijd bestuurslid' }) );
    ___arguments.context.pageData['svwerktijdbestuurslid'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd bestuurslid',[`soortcode`]: 'svwerktijdbestuurslid',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd bestuurslid',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svwerktijdbestuurslid','\''].join('')) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svwerktijdbestuurslid=1'].join('')), ({ [`svwerktijdbestuurslid`]: 0 }) );
    ___arguments.context.pageData['svwerktijdbestuurslid'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd bestuurslid',[`soortcode`]: 'svwerktijdbestuurslid',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1fcc6de5221bc95e8287e182aeceb3eb', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdbestuurslid','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/508ac9795aeb1dbba72a70758f1f1e2c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svwerktijdgeestelijkverzorger',[`soort`]: 'Werktijd geestelijk verzorger' }) );
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd geestelijk verzorger',[`soortcode`]: 'svwerktijdgeestelijkverzorger',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd geestelijk verzorger',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svwerktijdgeestelijkverzorger=1'].join('')), ({ [`svwerktijdgeestelijkverzorger`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svwerktijdgeestelijkverzorger','\''].join('')) );
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd geestelijk verzorger',[`soortcode`]: 'svwerktijdgeestelijkverzorger',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('56ee0b7700238d0566c131fc4f056e1f', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdgeestelijkverzorger','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/1fcc6de5221bc95e8287e182aeceb3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1fcc6de5221bc95e8287e182aeceb3eb', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdbestuurslid','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/d7b2399e910cd3650a11b0dfb92e90d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7b2399e910cd3650a11b0dfb92e90d1', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdcoordinator','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/56ee0b7700238d0566c131fc4f056e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('56ee0b7700238d0566c131fc4f056e1f', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdgeestelijkverzorger','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/e5b60ed540787b8f9ae81a5f52ee4244/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svwerktijdteamcoordinator',[`soort`]: 'Werktijd teamcoördinator' }) );
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd teamcoördinator',[`soortcode`]: 'svwerktijdteamcoordinator',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd teamcoördinator',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svwerktijdteamcoordinator=1'].join('')), ({ [`svwerktijdteamcoordinator`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svwerktijdteamcoordinator','\''].join('')) );
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd teamcoördinator',[`soortcode`]: 'svwerktijdteamcoordinator',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc364936f25e599a3b7c1a5ef621d896', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdteamcoordinator','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/fc364936f25e599a3b7c1a5ef621d896/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc364936f25e599a3b7c1a5ef621d896', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdteamcoordinator','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/8d9f035a70addd1886dad9d6c88b89c7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d9f035a70addd1886dad9d6c88b89c7', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svvastevacatiegelden','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/b6a4678be9e30dff81cd4adff70e5278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svreiskosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b6a4678be9e30dff81cd4adff70e5278', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svreiskosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/c91bff995637a11fe2a8cf99c9459abf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svparkeerkosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c91bff995637a11fe2a8cf99c9459abf', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svparkeerkosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/2c1c9d73eec6c0955e832fa4aeafff38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svmaterielekosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2c1c9d73eec6c0955e832fa4aeafff38', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svmaterielekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/889bb21d6e9366f7a87a09d153a771ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svlocatiekosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('889bb21d6e9366f7a87a09d153a771ca', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svlocatiekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/4fafdd4190ba26c2692f44fed40548d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'svwerktijdbestuurslid')) == true) {
    ___arguments.context.pageData['svwerktijdbestuurslid'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svwerktijdcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdcoordinator'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svwerktijdgeestelijkverzorger')) == true) {
    ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svwerktijdteamcoordinator')) == true) {
    ___arguments.context.pageData['svwerktijdteamcoordinator'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svwerktijdprojectleider')) == true) {
    ___arguments.context.pageData['svwerktijdprojectleider'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svlocatiekosten')) == true) {
    ___arguments.context.pageData['svlocatiekosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svmaterielekosten')) == true) {
    ___arguments.context.pageData['svmaterielekosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svparkeerkosten')) == true) {
    ___arguments.context.pageData['svparkeerkosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svreiskosten')) == true) {
    ___arguments.context.pageData['svreiskosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svvastevacatiegelden')) == true) {
    ___arguments.context.pageData['svvastevacatiegelden'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svvrijwilligersvergoeding')) == true) {
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svadministratiekosten')) == true) {
    ___arguments.context.pageData['svadministratiekosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svitkosten')) == true) {
    ___arguments.context.pageData['svitkosten'] = true;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'svkostenderden')) == true) {
    ___arguments.context.pageData['svkostenderden'] = true;
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/9b82d3ec1712d22f8b8badd7f2db8fce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await Backendless.Data.of('projectfinanciering').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b86899d3a68a20ac200acd515b4f16a8', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/d74a1614560fd696d89be05fd89fb028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiefinancieringsstroom').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`financieringsstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'financieringsstroom')),[`budget`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'budget')),[`status`]: 'Verwijderd' }) );
  await Backendless.Data.of('projectfinanciering').remove( ___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d') );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b86899d3a68a20ac200acd515b4f16a8', (await Backendless.Data.of('projectfinanciering').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('projectfinanciering').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))))) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/bdf3fe94553b45cd40e313d51c7e5533/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/96c6561738421c39d687f16605f4b0c5/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/762ede8b61565d88cadb11c5570b537b/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/b8537a3955155b5ee2f91e64dc01448a/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/edd69ef8ed1e5235ea9f048dc2cfffd3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'tariefperuur')) == null) {
    (function (message) { alert(message) })('Tarief per uur moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6') );
    ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd bestuurslid',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'tariefperuur')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/413527024632f43823c2863e032185a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/92631ede11781993a5f2c728048bbcf4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/f58ec97be553dfdcde56f98df578ba33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/9ce14711e6e2b368fd46359191ad8acb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/29fbd70b2d6288cf9f1581020a657aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/3eeff47da822fe3c3e18b8eec70953d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/bbd7a084eae4f79e0de5d1952b138762/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/9c6f216e734fe0ba408e65f668252b41/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/605457c669fd63dc22e1ad21071ba26e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/e97ff5dc582f899f13822e7df68b8913/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/ce1643f5276be34f28d2ffcfbcb9a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/754786f92d72958e2cb91f788469888c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/7b2d031b451c358e134a12f4f8059edf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == false) {
    ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/8303e78576384dd35e09f11dfd1c179a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/ce6a22717b5514efe7cccfdc91b8c159/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/5fdeafef92b41d1c33d94dafaa3d6dba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/6a24f9a417b816c5edb6b6deb3d36511/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/6a3f4f8292a9488ee01fa02fc9b2bbe9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'tariefperuur')) == null) {
    (function (message) { alert(message) })('Tarief per uur moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4') );
    ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd coördinator',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'tariefperuur')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/cc5fe1587e3c0e975954b8977959a53b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'tariefperuur')) == null) {
    (function (message) { alert(message) })('Tarief per uur moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33') );
    ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd geestelijk verzorger',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'tariefperuur')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/38a73bcb98c9626d52395b5b3bed47bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'tariefperuur')) == null) {
    (function (message) { alert(message) })('Tarief per uur moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb') );
    ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd teamcoördinator',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'tariefperuur')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/c92b73b7aa92e049bc95138d16d2616e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'vacatiegeldenbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3') );
    ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Vaste vacatiegelden',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`vacatiegeldenbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'vacatiegeldenbedrag')),[`tarief`]: undefined,[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/cec649f482fc893e2db930bd52df00aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'tariefperkm')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7') );
    ___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Reiskosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'tariefperminuut')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/916761931eeeafaf650539c23e03cd44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762') );
    ___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'OV/Parkeerkosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/64cd84dc1a7b0418ab92984de098a5a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41') );
    ___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Materiele kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/3151f94eab7d7dbf65f7a327eb49303f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Het maximale bedrag moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e') );
    ___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Locatie kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/036fe13cca7651e80334d64a505d272a/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/cf4d491a5b853a7b00ce137763063eee/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/7d7c122ecd63f2668482541792226e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/db52f9c11a9244f17d4e6387e30ad6f9/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/bfc4371fc968ac33d30d1d8e0b3635de/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/aefc7a14e9fecb8770b24a3509b5bb0b/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/ee415e1114050d9954060b31d6c774f2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/0abc7ba74aad62342f4abbb6e9d246dd/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/f96c16f127086191974d736eba9387b9/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/c98a75d1932dba1a620db493f40a39f1/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/9bc65f1a78fee409beb7dc46ae5b42bf/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/34c5ac8d249c3c08b0b1f9e528058df4/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/a6c3a318ab7b5f882f23a842516fec35/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/11f41d4c69afa509189dfbf5f59f96ab/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/825eb7baffe977473e8a4af4cd48127c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/8d4229f9f575a567ed564c1b7724ac4c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/c308faba65cdad96db6f9cd1cb61e058/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/173f6821f5ffd917028a12d3eb9cd5bd/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/9d3fe2092e752c575ab5ebd5498b19fa/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/c0e756e42254812dc65adbb8576afefd/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/a622668ea25a35eb99ef91858e75a071/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectmakenstap3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('PROJECT ') + String((getObjectProperty(___arguments.context.appData, 'projectnaam')).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/fe03b48dc642fe3aff52d0f7247a7084/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3eeff47da822fe3c3e18b8eec70953d7'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/406a950578758f16c8d2413e32366517/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bbd7a084eae4f79e0de5d1952b138762'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1244243f069df908a88b110c4c2e4ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9c6f216e734fe0ba408e65f668252b41'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/f406270d24883c4d90ef8aa4e6fa23e2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605457c669fd63dc22e1ad21071ba26e'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/9a74d25c23117d2846df5145e9ef11a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var budget1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'financieringsstroom')) == null) {
    (function (message) { alert(message) })('De financieringsstroom moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'budget')) == null) {
    (function (message) { alert(message) })('Het budget moet ingevuld zijn');
  } else {
    ___arguments.context.pageData['created'] = (await Backendless.Data.of('projectfinanciering').save( ___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d') ));
    await Backendless.Data.of('projectgegevens').addRelation(((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectfinanciering', [(getObjectProperty(___arguments.context.pageData, 'created'))]);
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
    await Backendless.Data.of('historiefinancieringsstroom').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`financieringsstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'financieringsstroom')),[`budget`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d'), 'budget')),[`status`]: 'Toegevoegd' }) );
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/5696684ccbf3478ed87e210767151a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svwerktijdprojectleider',[`soort`]: 'Werktijd projectleider' }) );
    ___arguments.context.pageData['svwerktijdprojectleider'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd projectleider',[`soortcode`]: 'svwerktijdprojectleider',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd projectleider',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svwerktijdprojectleider=1'].join('')), ({ [`svwerktijdprojectleider`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svwerktijdprojectleider','\''].join('')) );
    ___arguments.context.pageData['svwerktijdprojectleider'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Werktijd projectleider',[`soortcode`]: 'svwerktijdprojectleider',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f501e91bc7d6ca2aa569a5095a01a7b6', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdprojectleider','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/f501e91bc7d6ca2aa569a5095a01a7b6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f501e91bc7d6ca2aa569a5095a01a7b6', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svwerktijdprojectleider','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/34f456c7a7de5f478833588532cc7f37/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/fd543768e8fe1d882f74334e82ccfc07/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/b2cd06c87fb3e1acfbdf51f37c66b627/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/fa1483d118396e9bce2799c3ef2460ec/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/34b5faba50bb302142fc1ff2d29c5389/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/f85aec423a6198d443115328aed6670e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'tariefperuur')) == null) {
    (function (message) { alert(message) })('Tarief per uur moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'maxaantal')) == null) {
    (function (message) { alert(message) })('Maximale aantal moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37') );
    ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Werktijd projectleider',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`tarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'tariefperuur')),[`maxaantal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'maxaantal')),[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/3b034071b57edb6eeabcf555e5dfa1fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svvrijwilligersvergoeding',[`soort`]: 'Vrijwilligersvergoeding' }) );
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Vrijwilligersvergoeding',[`soortcode`]: 'svvrijwilligersvergoeding',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Vrijwilligersvergoeding',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svvrijwilligersvergoeding=1'].join('')), ({ [`svvrijwilligersvergoeding`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svvrijwilligersvergoeding','\''].join('')) );
    ___arguments.context.pageData['svvrijwilligersvergoeding'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Vrijwilligersvergoeding',[`soortcode`]: 'svvrijwilligersvergoeding',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f782217c2998beaa4796534dd6c77c9', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svvrijwilligersvergoeding','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/2f782217c2998beaa4796534dd6c77c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f782217c2998beaa4796534dd6c77c9', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svvrijwilligersvergoeding','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/c4b669c8ae2c7815b249c1dc0253fbf6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['readonly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/e7b34f595c28879817c8bb737539f21c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/279552c8ba4533039d5d47c4cc12acaa/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/0b4933650e01ef69bc352e9bdce6a2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/5ce2c6ccf5b9a6dc7625f4ce08c83ea6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/509ff1d27b0f469394f5e59bf0bd6d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Het maximale bedrag moet ingevuld zijn');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'reistijd')) == null) {
    (function (message) { alert(message) })('Reistijd moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6') );
    ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Vrijwilligersvergoeding',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast',[`reistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'reistijd')),[`tariefperkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'tariefperkm')),[`informatietekstreistijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'informatietekstreistijd')) }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/6c1a602a463c84551eb4be2a4d27f5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('748214d43cc7760a9913e99fa037f03d')['projectnaam'] = ___arguments.context.appData;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/ccf7e21cec6dfcda9b1992aa6f896659/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svadministratiekosten',[`soort`]: 'Administratie kosten' }) );
    ___arguments.context.pageData['svadministratiekosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Administratie kosten',[`soortcode`]: 'svadministratiekosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Administratie kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svadministratiekosten=1'].join('')), ({ [`svadministratiekosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svadministratiekosten','\''].join('')) );
    ___arguments.context.pageData['svadministratiekosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Administratie kosten',[`soortcode`]: 'svadministratiekosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('880804b8a6a4744e42dc00aeedaa2063', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svadministratiekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/757cac45a3125cfb51eb21f4d8a7a24d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svitkosten',[`soort`]: 'IT kosten' }) );
    ___arguments.context.pageData['svitkosten'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`datum`]: (new Date()),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'IT kosten',[`soortcode`]: 'svitkosten',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'IT kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svitkosten=1'].join('')), ({ [`svitkosten`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svitkosten','\''].join('')) );
    ___arguments.context.pageData['svitkosten'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'IT kosten',[`soortcode`]: 'svitkosten',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f58fe3227cd511aa8c3d1d5e7d322b43', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svitkosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/5cb303d14d4358c8ba6e5a8940df3039/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/480b325e80a5481d30bf888ee6d213ad/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/8975c0ddc57b2ea454eaa1c8bf9c66f7/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/12f7b833e993d2c783dadd41cf63976f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/66e54d552d88a81d2c2da8a85aa4c415/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/5bb40b059d2d6aa9b318b3447576d857/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/7a2972c5bb6f9d7ee8fd54ac0fb8a5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/f15fb611b2839047b8e95a92800ab7b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127') );
    ___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Administratie kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/2bd3b0798c77c48ab6394e77a4abbdd2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f') );
    ___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'IT kosten',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33cfb63bef9660f9c2e3c729571ac45f'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/880804b8a6a4744e42dc00aeedaa2063/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svadministratiekosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('880804b8a6a4744e42dc00aeedaa2063', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svadministratiekosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/f58fe3227cd511aa8c3d1d5e7d322b43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svitkosten')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f58fe3227cd511aa8c3d1d5e7d322b43', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svitkosten','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/2d334fc8422274c8b72f163ff309e16d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('acbbbc31dc7a8eccc7af2403a227c127')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/9745bd5836f5c25d9b3ec73f171caa5f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectgegevens').save( ___arguments.context.getComponentDataStoreByUid('4fafdd4190ba26c2692f44fed40548d7') );
  if (___arguments.value == true) {
    await Backendless.Data.of('projecttarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`creator`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soortcode`]: 'svkostenderden',[`soort`]: 'Kosten derden' }) );
    ___arguments.context.pageData['svkostenderden'] = true;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Kosten derden',[`soortcode`]: 'svkostenderden',[`status`]: 'Geactiveerd',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  } else if (___arguments.value == false) {
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Kosten derden',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`status`]: 'Verwijdert' }) );
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svkostenderden=1'].join('')), ({ [`svkostenderden`]: 0 }) );
    await Backendless.Data.of('projecttarieven').bulkDelete( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND soortcode=\'','svkostenderden','\''].join('')) );
    ___arguments.context.pageData['svkostenderden'] = false;
    await Backendless.Data.of('historiesoortvergoedingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`datum`]: (new Date()),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`soort`]: 'Kosten derden',[`soortcode`]: 'svkostenderden',[`status`]: 'Verwijdert',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8bee5e01d34d64b2c6db9964eb14c5f7', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svkostenderden','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap2/components/23e422db69d38efe993d80f1050cfaac/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/05115f2ce28ddeede8d1ea572472d99e/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/e24629c467eba3627864a7a72167028d/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/fa0941447247afa48c578d031b15a287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d')['readonly'] = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'readonly')) == true) {
    ___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d')['readonly'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/6f6d6ef74ed48e8a4dc324594c666d67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d')['kostenplaats'] = (getObjectProperty(___arguments.context.appData, 'projectcode'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'maxbedrag')) == null) {
    (function (message) { alert(message) })('Tarief per minuut moet ingevuld zijn');
  } else {
    await Backendless.Data.of('projecttarieven').save( ___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d') );
    ___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d')['readonly'] = true;
    await Backendless.Data.of('historietarieven').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`soort`]: 'Kosten derden',[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')),[`datum`]: (new Date()),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maxbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fef8b5ef93ac2949ae7d35d8417d4f5d'), 'maxbedrag')),[`maxaantal`]: undefined,[`kostenplaats`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`status`]: 'Aangepast' }) );
    (function (message) { alert(message) })('Wijzigingen zijn opgeslagen');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap2/components/8bee5e01d34d64b2c6db9964eb14c5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'svkostenderden')) == true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8bee5e01d34d64b2c6db9964eb14c5f7', (await Backendless.Data.of('projecttarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND soortcode=\'','svkostenderden','\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap2/components/a9a1e428a3d6acd2e32d1aec3e0dcd6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0032f92619ca6ec920873bfb04be383'), 'projectbtwsoort')) == null) {
    (function (message) { alert(message) })('Er moet eerst een instelling voor de btw gekozen worden');
  } else {
    await Backendless.Data.of('projectgegevens').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')), ({ [`projectbtwsoort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0032f92619ca6ec920873bfb04be383'), 'projectbtwsoort')) }) );
    await Backendless.Data.of('historiebtwsoort').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`datum`]: (new Date(((new Date()).valueOf()))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`activiteit`]: 'btwsoort ingegeven',[`projectbtwsoort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0032f92619ca6ec920873bfb04be383'), 'projectbtwsoort')) }) );
    (function (message) { alert(message) })('Instellingen btw zijn opgeslagen');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8a55ce0b8f8af58ac59f3a38ee951644', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a79cb8270852da800c74b4a643aed2f', (await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    var state, btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
  if ((getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) == null) {
    state = false;
  } else {
    state = true;
  }

  return state

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/484e0a74621cb7125daabe459e637da6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    var state, btwsoortgevuld;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwsoortgevuld = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('projectbtwsoort').setPageSize(10))).map(async btwsoortgevuld => {; return ({ [`projectbtwsoort`]: (getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) });})))[0];
  if ((getObjectProperty(btwsoortgevuld, 'projectbtwsoort')) == null) {
    state = false;
  } else {
    state = true;
  }

  return state

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/76ee9f21690bc0d18bde3125db7904dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'standaard') {
    visible = '(excl. btw)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'zonderbtw' || (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'totaalbedragenbtweraf') {
    visible = '(totaalbedrag)';
  } else {
    visible = '';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1843a6afbf5c093f4a3a052e9bcd3bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'standaard') {
    visible = '(excl. btw)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'zonderbtw' || (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'totaalbedragenbtweraf') {
    visible = '(totaalbedrag)';
  } else {
    visible = '';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/297a9fbbc3f644527479a6e1d9fe01eb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'standaard') {
    visible = '(excl. btw)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'zonderbtw' || (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'totaalbedragenbtweraf') {
    visible = '(totaalbedrag)';
  } else {
    visible = '';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/119a8af82cb522de044a33952a28a6ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'standaard') {
    visible = '(excl. btw)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'zonderbtw' || (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'totaalbedragenbtweraf') {
    visible = '(totaalbedrag)';
  } else {
    visible = '';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/f96343d7f3e6068f4a94a4f4409481ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'standaard') {
    visible = '(excl. btw)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'zonderbtw' || (getObjectProperty(___arguments.context.pageData, 'projectbtwsoort')) == 'totaalbedragenbtweraf') {
    visible = '(totaalbedrag)';
  } else {
    visible = '';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/9b1916e4fe23b0d65277adabcd9b0794/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/d6984b2a382bf7c29b37984ae8bf7c0e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/36b47b760fcddc0a548f8ef2bb440a81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/b554184236dd53b4765b655d11ce50aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/6b2bda0d05e4a79eccf61accdabc593a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/7882cd4c96f7d2327a3b2133df1d6675/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/6f0d0d6a4528f0c9a3b7889dd95ba96d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/356ae4042a39b20eb0cc3c1510748b73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    ___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6')['tariefperkm'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/70378be293fd7bfb3aff75063624622c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/9df590e1b03ce5cc1dd230f5e3ca4f82/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/0b0f3802ca4fcc288833938ee90d8b64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/43fb8d78cab903689097b50a15a75b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/a65cc67b7b8409b33b5d6ea190532414/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/537819347e8dbad1b3f4a20953e41b22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/34ceb5b7ff07ddbf465f1c187fb36c14/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/b7d7ee183ea5dc363b0b968953f39cf3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/358fa2d86bf6a50757523b6c78bc2f17/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1e7b55deb2fcf75fe6d2bae73bedd92f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/7444718ae24f887721d205ebe4281f16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1e862fa92dfe4691cec5a5e9766d61be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/2ab7b0de69e112abcbc462c7c1f3c117/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'reistijd')) == 'Ja')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1363d3186d997f61f3e87c582b8bed62/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/5e29095c2318e8455b9d75a7b99841dd/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('413527024632f43823c2863e032185a6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/a8621321bd8b31e2c1accf78b551779e/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/d5b83d59795ea74112e53ac8fdc8b72e/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('92631ede11781993a5f2c728048bbcf4'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/593b7842fd0d66428dcd5e584bf90316/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/5b69e31a2a5817330b790a1c0e2fd8ae/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f58ec97be553dfdcde56f98df578ba33'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/980817450b92e13f496d65b82111a0ab/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/cc5509bddda7689a1173fb3bb48ec275/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ce14711e6e2b368fd46359191ad8acb'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/ae81bd734829842b6699b146b5bdb47c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/823dd367fb3457e12cc7c7280877f971/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('34f456c7a7de5f478833588532cc7f37'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/bda20169fb85b6ab65b14e4d3e5ee0f8/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/1c3f4323ea967f981c6484454239227e/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29fbd70b2d6288cf9f1581020a657aa3'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/f8dd425578c8b3a392083e3add3d3dee/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/4463245a83bf10cf0bcadc2ec8662ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4b669c8ae2c7815b249c1dc0253fbf6'), 'readonly')) == true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/projectmakenstap2/components/77e2d4918dae459cb3f5475734d6ba57/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('77e2d4918dae459cb3f5475734d6ba57', (!___arguments['isOpen']));

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('77e2d4918dae459cb3f5475734d6ba57', ___arguments['isOpen']);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/projectmakenstap2/components/82bb601840684608b4e510f810d8e098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')) == 'VSCL')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectdetails', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('gebruiker')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var projectgegevensdata, j, n, newtoestemming, projectleiderslist, item, projectleiders, m, beheerderslist, beheerders, l, userslist, users, k, listmissingusers, x, userlistprojecttoestemmingen, usersprojecttoestemmingen, projecttoestemmingenlist, projecttoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function userstoevoegen() {
  usersprojecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistprojecttoestemmingen = (await Promise.all(usersprojecttoestemmingen.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username NOT LIKE \'lorio%\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  listmissingusers = [];
  for (var x_index in userslist) {
    x = userslist[x_index];
    if (userlistprojecttoestemmingen.includes(x)) {
    } else {
      addItemToList(listmissingusers, x);
    }
  }
  for (var j_index in listmissingusers) {
    j = listmissingusers[j_index];
    console.log(String('toegevoegde user: ') + String(JSON.parse(j)));
    newtoestemming = (await Backendless.Data.of('projecttoestemmingen').bulkCreate( (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'userobjectId']).excludeProperties('objectId').setPageSize(10))) ));
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( 'projectcode is null', ({ [`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }) );
    console.log('permissions projecttoestemmingen toegevoegde users instellen start');
    console.log(String('newtoestemming: ') + String(newtoestemming));
    for (var k_index in newtoestemming) {
      k = newtoestemming[k_index];
      users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['username=\'',(JSON.parse(j)),'\''].join('')) }));
      userslist = (await Promise.all(users.map(async item => {; return item;})));
      for (var l_index in userslist) {
        l = userslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(l, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
      }
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return item;})));
      for (var m_index in beheerderslist) {
        m = beheerderslist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(m, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(m, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return item;})));
      for (var n_index in projectleiderslist) {
        n = projectleiderslist[n_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(n, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(n, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
      }
    }
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projecttoestemmingen', [(getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties('userobjectId').setPageSize(10)))[0]), 'userobjectId'))]);
    await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectgegevens', [(await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
  }
}

/**
 * Describe this function...
 */
async function werkend_maar_maar_1_user_tegelijk() {
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    if (!(userlistprojecttoestemmingen.indexOf(j) !== -1)) {
      if (!(typeof j === 'undefined')) {
        console.log(String('toegevoegde user: ') + String(JSON.parse(j)));
        newtoestemming = (await Backendless.Data.of('projecttoestemmingen').bulkCreate( (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['centra', 'username', 'naam', 'organisatie', 'rol', 'team', 'userobjectId']).excludeProperties('objectId').setPageSize(10))) ));
        await Backendless.Data.of('projecttoestemmingen').bulkUpdate( 'projectcode is null', ({ [`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }) );
        console.log('permissions projecttoestemmingen toegevoegde users instellen start');
        console.log(String('newtoestemming: ') + String(newtoestemming));
        for (var k_index2 in newtoestemming) {
          k = newtoestemming[k_index2];
          users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['username=\'',(JSON.parse(j)),'\''].join('')) }));
          userslist = (await Promise.all(users.map(async item => {; return item;})));
          for (var l_index2 in userslist) {
            l = userslist[l_index2];
            await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(l, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
          }
          beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND rol=\'beheerder\''].join('')) }));
          beheerderslist = (await Promise.all(beheerders.map(async item => {; return item;})));
          for (var m_index2 in beheerderslist) {
            m = beheerderslist[m_index2];
            await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(m, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
            await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(m, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
          }
          projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
          projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return item;})));
          for (var n_index2 in projectleiderslist) {
            n = projectleiderslist[n_index2];
            await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(n, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
            await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(n, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: newtoestemming }));
          }
        }
        await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projecttoestemmingen', [(getObjectProperty(((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties('userobjectId').setPageSize(10)))[0]), 'userobjectId'))]);
        await Backendless.Data.of('projecttoestemmingen').addRelation(((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'projectgegevens', [(await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
      }
    }
  }
}

/**
 * Describe this function...
 */
async function do_something2() {
  console.log(String('listmissingusers: ') + String(listmissingusers));
  console.log(String('userlistprojecttoestemmingen: ') + String(userlistprojecttoestemmingen));
  console.log(String('userslist: ') + String(userslist));
}

/**
 * permissions nieuwe users die toegevoegd zijn > dit is te langzaam
 * om dat alle users de permissions opnieuw krijgen, gewijzigd naar
 * enkel de user die toegevoegd zijn, bij userstoevoegen toegevoegd
 */
async function permissions_nieuwe_users_die_toegevoegd_zijn__3E_3E_3EOLD() {
  projecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')) }));
  projecttoestemmingenlist = (await Promise.all(projecttoestemmingen.map(async item => {; return item;})));
  console.log(String('projecttoestemmingenlist: ') + String(projecttoestemmingenlist));
  for (var j_index3 in projecttoestemmingenlist) {
    j = projecttoestemmingenlist[j_index3];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\''].join('')) }));
    userslist = (await Promise.all(users.map(async item => {; return item;})));
    for (var k_index3 in userslist) {
      k = userslist[k_index3];
      if ((getObjectProperty(j, 'username')) == (getObjectProperty(k, 'username'))) {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      if ((getObjectProperty(k, 'rol')) == 'beheerder') {
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider = TRUE'].join('')) }));
      projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index3 in projectleiderslist) {
        m = projectleiderslist[m_index3];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'projecttoestemmingen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
    }
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  projecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND username=\'',(JSON.parse(j)),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')) }));
  projecttoestemmingenlist = (await Promise.all(projecttoestemmingen.map(async item => {; return item;})));
  console.log(String('projecttoestemmingenlist: ') + String(projecttoestemmingenlist));
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectaanmakenknop')) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'viewprojectenblock')) == true || ((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['spinner'] = true;
  projectgegevensdata = (await Promise.all((await Backendless.Data.of('projectgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join(''))).setProperties(['svwerktijdbestuurslid', 'svwerktijdcoordinator', 'svwerktijdgeestelijkverzorger', 'svwerktijdteamcoordinator', 'svwerktijdprojectleider', 'svlocatiekosten', 'svmaterielekosten', 'svparkeerkosten', 'svreiskosten', 'svvastevacatiegelden', 'projectnaam', 'svvrijwilligersvergoeding', 'svadministratiekosten', 'svitkosten', 'svkostenderden']).setPageSize(10))).map(async projectgegevensdata => {; return ({ [`svwerktijdbestuurslid`]: (getObjectProperty(projectgegevensdata, 'svwerktijdbestuurslid')),[`svwerktijdcoordinator`]: (getObjectProperty(projectgegevensdata, 'svwerktijdcoordinator')),[`svwerktijdgeestelijkverzorger`]: (getObjectProperty(projectgegevensdata, 'svwerktijdgeestelijkverzorger')),[`svwerktijdteamcoordinator`]: (getObjectProperty(projectgegevensdata, 'svwerktijdteamcoordinator')),[`svwerktijdprojectleider`]: (getObjectProperty(projectgegevensdata, 'svwerktijdprojectleider')),[`svlocatiekosten`]: (getObjectProperty(projectgegevensdata, 'svlocatiekosten')),[`svmaterielekosten`]: (getObjectProperty(projectgegevensdata, 'svmaterielekosten')),[`svparkeerkosten`]: (getObjectProperty(projectgegevensdata, 'svparkeerkosten')),[`svreiskosten`]: (getObjectProperty(projectgegevensdata, 'svreiskosten')),[`svvastevacatiegelden`]: (getObjectProperty(projectgegevensdata, 'svvastevacatiegelden')),[`projectnaam`]: (getObjectProperty(projectgegevensdata, 'projectnaam')),[`svvrijwilligersvergoeding`]: (getObjectProperty(projectgegevensdata, 'svvrijwilligersvergoeding')),[`svadministratiekosten`]: (getObjectProperty(projectgegevensdata, 'svadministratiekosten')),[`svitkosten`]: (getObjectProperty(projectgegevensdata, 'svitkosten')),[`svkostenderden`]: (getObjectProperty(projectgegevensdata, 'svkostenderden')) });})))[0];
  ___arguments.context.pageData['svwerktijdbestuurslid'] = (getObjectProperty(projectgegevensdata, 'svwerktijdbestuurslid'));
  ___arguments.context.pageData['svwerktijdcoordinator'] = (getObjectProperty(projectgegevensdata, 'svwerktijdcoordinator'));
  ___arguments.context.pageData['svwerktijdgeestelijkverzorger'] = (getObjectProperty(projectgegevensdata, 'svwerktijdgeestelijkverzorger'));
  ___arguments.context.pageData['svwerktijdteamcoordinator'] = (getObjectProperty(projectgegevensdata, 'svwerktijdteamcoordinator'));
  ___arguments.context.pageData['svwerktijdprojectleider'] = (getObjectProperty(projectgegevensdata, 'svwerktijdprojectleider'));
  ___arguments.context.pageData['svlocatiekosten'] = (getObjectProperty(projectgegevensdata, 'svlocatiekosten'));
  ___arguments.context.pageData['svmaterielekosten'] = (getObjectProperty(projectgegevensdata, 'svmaterielekosten'));
  ___arguments.context.pageData['svparkeerkosten'] = (getObjectProperty(projectgegevensdata, 'svparkeerkosten'));
  ___arguments.context.pageData['svreiskosten'] = (getObjectProperty(projectgegevensdata, 'svreiskosten'));
  ___arguments.context.pageData['svvastevacatiegelden'] = (getObjectProperty(projectgegevensdata, 'svvastevacatiegelden'));
  ___arguments.context.pageData['svvrijwilligersvergoeding'] = (getObjectProperty(projectgegevensdata, 'svvrijwilligersvergoeding'));
  ___arguments.context.pageData['svadministratiekosten'] = (getObjectProperty(projectgegevensdata, 'svadministratiekosten'));
  ___arguments.context.pageData['svitkosten'] = (getObjectProperty(projectgegevensdata, 'svitkosten'));
  ___arguments.context.pageData['svkostenderden'] = (getObjectProperty(projectgegevensdata, 'svkostenderden'));
  await userstoevoegen();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['filterrol'] = '%';
  ___arguments.context.pageData['filterteam'] = '%';
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectmakenstap3/components/4102515735477d0dea4ddae83f59904e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var k, j, userslist, item, users, projecttoestemmingenlist, projecttoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdbestuurslid')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdbestuurslid')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/6ac8a79d3a6c8958c69c26244b49335d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svvastevacatiegelden')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svvastevacatiegelden')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/a837bf18a607aa562cfc61f3dffb03e1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svreiskosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svreiskosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/0e73c861515163148c3b031b054800fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svparkeerkosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svparkeerkosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/af32003720c12f82a919f6ec1826cfcf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svlocatiekosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svlocatiekosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/8251a5964d3e5bba79498f7d6b0e8dc6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svmaterielekosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svmaterielekosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/0e7815779616ee4fae8c193d662eba94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdcoordinator')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdcoordinator')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/748ba72fe44a9468d5f32775dbd71694/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdteamcoordinator')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdteamcoordinator')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/c974e6d68e9f61bee91f0f7d07ed44c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdgeestelijkverzorger')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdgeestelijkverzorger')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/c684c1cdc1957e789f3bc6aeca233777/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),' \''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/2e44597710f646984c0d19ef78af118c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e44597710f646984c0d19ef78af118c', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectmakenstap3/components/adfe1e9f5a888e5c8a66f9f6251f2b13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, userslistprojectleiders, item, listprojectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old_code() {
  listprojectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause('svprojectleider=\'1\'').setProperties('username').setPageSize(100)));
  userslistprojectleiders = (await Promise.all(listprojectleiders.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var j_index in userslistprojectleiders) {
    j = userslistprojectleiders[j_index];
    await Backendless.Request.put(`${Backendless.appPath}/services/rolbeheerder/rolbeheerder`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(j));
  }
}


  ___arguments.context.pageData['spinner'] = true;
  await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`svprojectleider`]: true }) );
  await Backendless.Request.post(`${Backendless.appPath}/services/permissions/projectleideradd`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'projectcode': (getObjectProperty(___arguments.context.appData, 'projectcode')),'username': (getObjectProperty(___arguments.context.pageData, 'username')) });
  ___arguments.context.pageData['username'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e44597710f646984c0d19ef78af118c', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));
  await Backendless.Data.of('historieprojectleiders').save( ({ [`actie`]: 'Projectleider toegevoegd',[`actiedoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datum`]: (new Date(((new Date()).valueOf()))),[`usernameprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`propName`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }) );
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/afb43547fabfdb6fe80cf4c78eb33f26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectdetails', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('PROJECT ') + String((getObjectProperty(___arguments.context.appData, 'projectnaam')).toUpperCase()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/714e1ce3e67a21b7cef9a1ee711498bb/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join(''))).setProperties('rol').setSortBy('rol ASC').setGroupBy('rol').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'rol')),[`label`]: (getObjectProperty(item, 'rol')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/aed34e2aab4367b773e99528a308d677/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/7e84756bee635052feb8c2a763cbe9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join(''))).setProperties('organisatie').setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'organisatie')),[`label`]: (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/7525e17eae74ec29a96b7f8834da1d0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/0c649675d4eb09f2d5cbc7b5e8622eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterorganisatie'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/0675fbdc05c400389a9dd5d52c68b861/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterrol'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/f44e5af881292ccf3644c2d777a25a74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/e5fef36806ce3151c352eb7565bac6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/cf28235a0d08aa29bd01fc7a27fb53eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/da41624d7468546186542e13c99afcee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/af132caac069dfa361ad201b76f3e733/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/a52671a335c5fde50bd91bd93ff25171/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/67fee4bdf183af9169d60713eb8f3f33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/5244693823cac2f98e4274d132cae51c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/721551a4a2963cfe732277aa4096d3b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorger'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/e4883e08d878acb9c1ba828c3b816fa4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/678a2926f582b513a8a4575789321e27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/2efdd2e8ab47b7a3229e14dc28bbaf0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinator'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/670786746a6edcfb7bb106ceb83eccfa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svlocatiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/b872867d32719b593c83e296f48a9ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svparkeerkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/6c1b549625253c570768c40891c60766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svlocatiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/508b2d29657a317d25688ae223b42b03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svmaterielekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/3632e2b9de486ea780a6c3033d91af11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svmaterielekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/f12e73571b030d188fa3fdbc80988a79/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svmaterielekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/41ba5f5693c9d8e9258da35d41d98311/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svparkeerkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/e871026cf3259521f3b5f702de145086/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svparkeerkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/2fdc446d6bedbdb35c927b0de4567ecb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svreiskosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/9b74ed61019ac429ada87c8aa708384b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svreiskosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/feffbb215507c49457e7cd9407ab020e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svreiskosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/c2cfb2318e2ce9ef5b5af4da78439b66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var projectgegevensdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/cc15f4b618a17c3e2dfe3d5d957b99df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/6ac5ea522ec19731d92dec25a0b6a727/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvastevacatiegelden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/541f60b5a71a41f83beff29a16932d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svlocatiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/e35c6ffa117c623e260d3a1c153b33b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslidknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdbestuurslid`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdbestuurslidknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdbestuurslid`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/b794ea2dab714fc953584c9e980d22a7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinatorknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdcoordinator`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdcoordinatorknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdcoordinator`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/b273d05b569908487033907eeb3d1ea2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinatorknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdteamcoordinator`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdteamcoordinatorknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdteamcoordinator`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/ca0e816391b102ae2a950b1564c13b59/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorgerknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdgeestelijkverzorger`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdgeestelijkverzorgerknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdgeestelijkverzorger`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/c339646d7c04c0b1726548b78efe7854/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svvastevacatiegeldenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svvastevacatiegelden`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svvastevacatiegeldenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svvastevacatiegelden`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/e0485a1f01fc72b50e623cfc0af55bb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svreiskostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svreiskosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svreiskostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svreiskosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/ce8f9b9998bbbc9a78466c4cf88ba37a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svparkeerkostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svparkeerkosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svparkeerkostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svparkeerkosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/b78f277c1c135b6c0747d356f7665f7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svlocatiekostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svlocatiekosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svlocatiekostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svlocatiekosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/be1ad759eb58c4f12f3c8d37fcf2356e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svmaterielekostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svmaterielekosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svmaterielekostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svmaterielekosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/cfc92a15c243cd7a6828037501534a1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, userslistprojectleiders, item, listprojectleiders, count;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old() {
  listprojectleiders = (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause('svprojectleider=\'1\' ').setProperties('username').setPageSize(100)));
  userslistprojectleiders = (await Promise.all(listprojectleiders.map(async item => {; return item;})));
  for (var j_index in userslistprojectleiders) {
    j = userslistprojectleiders[j_index];
    await Backendless.Request.put(`${Backendless.appPath}/services/rolbeheerder/rolbeheerder`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(j, 'username'))));
  }
}

/**
 * Describe this function...
 */
async function old_2() {
  count = (await Backendless.Data.of('projecttoestemmingen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['svprojectleider=\'1\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' OR username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' AND rol=\'beheerder\''].join('')))));
  if (count == 0) {
    await Backendless.Request.put(`${Backendless.appPath}/services/rolgebruiker/rolgebruiker`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'username'))));
  }
}


  ___arguments.context.pageData['spinner'] = true;
  await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`svprojectleider`]: false }) );
  await Backendless.Request.post(`${Backendless.appPath}/services/permissions/projectleiderremove`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'projectcode': (getObjectProperty(___arguments.context.appData, 'projectcode')),'username': (getObjectProperty(___arguments.context.pageData, 'username')) });
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e44597710f646984c0d19ef78af118c', (await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND svprojectleider=\'1\''].join(''))).setPageSize(100))));
  await Backendless.Data.of('historieprojectleiders').save( ({ [`actie`]: 'Projectleider verwijderd',[`actiedoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datum`]: (new Date(((new Date()).valueOf()))),[`usernameprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`propName`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')),[`projectnaam`]: (getObjectProperty(___arguments.context.appData, 'projectnaam')) }) );
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/e559da6c852e64ccbdfc4401a3f9264c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, newtoestemming, userlistprojecttoestemmingen, userslist, item, users, usersprojecttoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  usersprojecttoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistprojecttoestemmingen = (await Promise.all(usersprojecttoestemmingen.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistprojecttoestemmingen.indexOf(j) !== -1)) {
      newtoestemming = (await Backendless.Data.of('projecttoestemmingen').bulkCreate( (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username', 'naam', 'organisatie', 'rol']).excludeProperties('objectId').setPageSize(100))) ));
      await Backendless.Data.of('projecttoestemmingen').bulkUpdate( 'projectcode is null', ({ [`projectcode`]: (getObjectProperty(___arguments.context.appData, 'projectcode')) }) );
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/7c69c567c529bd8b31513885877d27b1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projecttoestemmingen').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join(''))).setProperties('team').setSortBy('team ASC').setGroupBy('team').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'team')),[`label`]: (getObjectProperty(item, 'team')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/5d48079c081de1dd7026283859343a86/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterteam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\' AND team LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterteam')),'\''].join('')),'sortBy': 'naam ASC','groupBy': 'username' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectmakenstap3/components/c8cb35842d132837368d4e63aba87ec9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/d7315f173d61a17c71c4acb18ec1e115/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleiderknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdprojectleider`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleiderknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svwerktijdprojectleider`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/7a790cf94dc7ffa65d55d3355fbd84b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdprojectleider')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svwerktijdprojectleider')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/7ccb2fb99334a56857d2056ffefb875f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/dd2c5127bab48bf11a02267beb5e6e32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svwerktijdprojectleider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/4f1fceab038c6cea7ba4978a472ff037/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/f1515d137eebd604b68dddac2e8d9f6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/80bf5a82c1fc9ae50be4ba15c1f2a623/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoedingknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svvrijwilligersvergoeding`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoedingknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svvrijwilligersvergoeding`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/ade1211d2fb3401f0ee47095d3e55d72/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svvrijwilligersvergoeding'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/72f138ed9b6a5f09565ee50f45a4530b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svvrijwilligersvergoeding')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svvrijwilligersvergoeding')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/0c6634064e2a1a5e345bfb2a50ce449c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svadministratiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/da424712b5beae05d88eaaa272672af3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svitkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/7da4a113973cb3021b153a834c066b46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svadministratiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/960c1cea857e0daf3e53fbcc0c3c388f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svadministratiekosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/377a50a7a96fdb7fef49f61b16f9759e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svitkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/db73aaa38de83dc1fa9f54d8d3f2be8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svitkosten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/ed2ccfca726f7886d99bccd2505d64a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svadministratiekostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svadministratiekosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svadministratiekostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svadministratiekosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/4b41b71a51b46e796acdaac467522a26/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svitkostenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svitkosten`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svitkostenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svitkosten`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/de46b947da1691eb7bf5a9249764d791/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svadministratiekosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svmaterielekosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/656e1b7963a8a0572f39134a07824ce3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svitkosten')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svitkosten')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/de54cfa791d643fba77eb089963fa048/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svkostenderden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/0bb27a5370a99cd6b57f8fba073b868c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svkostenderden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/758840028776994d9d5855fbb4d6496a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'svkostenderden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectmakenstap3/components/5daa8bea5aeab6aa49474eefe70b6db3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'svkostenderdenknop')) == true) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svkostenderden`]: true }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'svkostenderdenknop')) == false) {
    await Backendless.Data.of('projecttoestemmingen').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')), ({ [`svkostenderden`]: false }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b9bae3140be48dbfa7072f64405af40e', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projecttoestemmingen','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'\' AND projectcode=\'',(getObjectProperty(___arguments.context.appData, 'projectcode')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND rol LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterrol')),'\''].join('')),'sortBy': 'naam','groupBy': 'username' })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectmakenstap3/components/9624b4f64806094272316c44643a1e0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svkostenderden')) == true) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed'), 'svkostenderden')) == false) {
    await Backendless.Data.of('projecttoestemmingen').save( ___arguments.context.getComponentDataStoreByUid('245a206c938752597621f29d511f95ed') );
  }

  },
  /* handler:onChange */
  /* content */
}))

